import React, { useState, useEffect, useRef, useMemo } from 'react'
import backButton from '../../../../../assets/images/back_button_arrow.svg';
import demandIcon from '../../../../../assets/images/icons/demand_icon.svg';
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal, Table, TreeSelect, Switch } from "antd";
import { notifysuccess } from "../../../../../utils/toast";
import { notifyfailure } from "../../../../../utils/toast";
import { notifycatch } from "../../../../../utils/toast";
import { DatePicker/*, Space*/ } from 'antd';
import configData from "../../../../../config/config.json";
import axios from "axios";
import FullLoader from "../../../../../assets/images/full-page-loader.gif"
import Cookies from "js-cookie";
import { SearchOutlined } from '@ant-design/icons';
import editIcon from '../../../../../assets/images/icons/edit.svg';
import DeleteIcon from '../../../../../assets/images/icons/delete_icon.svg';
import DeleteIconDisabled from '../../../../../assets/images/icons/delete_icon_disabled.svg';
import tablecopyIcon from '../../../../../assets/images/icons/table_copy_icon.svg';
import constantData from "../../../../../constants/constantData.json"
import macrosicon from '../../../../../assets/images/icons/macros_modal_icon.svg';
import CreativeIcon from '../../../../../assets/images/icons/add_creative_icon.svg';
import creativetemicon from '../../../../../assets/images/icons/creative_tem_icon.svg';
import alertCircleModal from '../../../../../assets/images/icons/alert-circle.svg';
import uploadIcon from '../../../../../assets/images/icons/upload-cloud.svg';
import addIcon from '../../../../../assets/images/icons/add.svg';
import loaderIcon from "../../../../../assets/images/login-and-signup/loader.gif";
import dayjs from 'dayjs';

const { TextArea } = Input;
const { Option } = Select;
const { SHOW_PARENT } = TreeSelect;

const CampaignCreateGam = ({ handlePageViewChange }) => {

    const [tabView, setTabView] = useState(0)
    const [repeatedHits, setRepeatedHits] = useState(false)
    const [buttonProcessing, setButtonProcessing] = useState(false)
    const [initialProcessing, setInitialProcessing] = useState(true)

    const scrollTopBudgetRef = useRef(null)
    const scrollTopOptimizationRef = useRef(null)
    const scrollTopTargetingRef = useRef(null)
    const scrollTopCreativeRef = useRef(null)

    function handleBackViewRandom(data) {
        if (data < tabView) {
            setSearchExcludedcategoryList("")
            setSearchSensitiveCategoryList("")

            setSearchCountryList("")
            setSearchStateList("")
            setSearchCityList("")

            setSearchDeviceList("")
            setSearchDeviceBrandList("")
            setSearchBrowserList("")

            setSearchIpList("")
            setSearchDomainList("")
            setSearchExtendedUserList("")
            setSearchAppBundleList("")
            setTabView(data)
        }

        setTimeout(() => {
            if (data === 0) {
                scrollToItem(scrollTopBudgetRef)
            }
            if (data === 1) {
                scrollToItem(scrollTopOptimizationRef)
            }
            if (data === 2) {
                scrollToItem(scrollTopTargetingRef)
            }
            if (data === 3) {
                scrollToItem(scrollTopCreativeRef)
            }

        }, 0)

    }

    function handleBackView(data) {

        setSearchExcludedcategoryList("")
        setSearchSensitiveCategoryList("")

        setSearchCountryList("")
        setSearchStateList("")
        setSearchCityList("")

        setSearchDeviceList("")
        setSearchDeviceBrandList("")
        setSearchBrowserList("")

        setSearchIpList("")
        setSearchDomainList("")
        setSearchExtendedUserList("")
        setSearchAppBundleList("")
        setTabView(data)

        setTimeout(() => {
            if (data === 0) {
                scrollToItem(scrollTopBudgetRef)
            }
            if (data === 1) {
                scrollToItem(scrollTopOptimizationRef)
            }
            if (data === 2) {
                scrollToItem(scrollTopTargetingRef)
            }
            if (data === 3) {
                scrollToItem(scrollTopCreativeRef)
            }
        }, 0)

    }


    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 0);
        }
    };

    // ---------------------------------------------------------------------------------------------------------------------------------------//
    // -----------------------------------------  Budget Code Starts ---------------------------------------------------------------------------//
    // ---------------------------------------------------------------------------------------------------------------------------------------//
    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });

    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "ops/iabCategories", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setCampaignCategoryList(response.data.data)
            })
            .catch((error) => { });


        axios
            .get(configData.SERVER_URL + "ops/gam/domainsbycategory?category=" + encodeURIComponent("IAB1"), {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setDomain_html_ViaCategory(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/exchangeType", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setExchangeMappingData(response.data.data.map(obj => ({
                    ...obj,
                    check: false,
                    ssplist: "",
                    loading: false,
                    validate: false,
                    rfData: [],
                    newZone: [],
                    delZones: [],
                    zoneFlag: {},
                })))

                setLoadingExchangeMapping(false)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/gamPubList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setPublisherOptions(response.data.data)


            })
            .catch((error) => { });

        setTimeout(() => {
            setInitialProcessing(false)
        }, 100)


    }, [])


    //modal opening macros  ------

    const [isModalVisibleTypeChange, setIsModalVisibleTypeChange] = useState(false);

    const showModalTypeChangeProceed = () => {
        setCreativeMainTableData([])
        setCampaignType(campaignTypeMid)
        if (publisher !== "") {
            const result = publisherOptions?.find(item => item.value === publisher);
            if (campaignTypeMid === "Banner") {
                setCampaignName("GAM_" + result?.label?.split("-").slice(1).join("-") + "_Banner")
            }
            else {
                setCampaignName("GAM_" + result?.label?.split("-").slice(1).join("-") + "_IBV")
            }
        }

        setIsModalVisibleTypeChange(false)
    };

    const closeModalTypeChangeDiscard = () => {
        setCampaignTypeMid(campaignType)
        setIsModalVisibleTypeChange(false);
    };

    //-------------------------------

    const [campaignType, setCampaignType] = useState("Banner");
    const [campaignTypeMid, setCampaignTypeMid] = useState("Banner");

    const [campaignTypeOptions] = useState([{ label: "Banner", value: "Banner" }, { label: "IBV", value: "IBV" }]);

    function onChangeCampaignType(event) {
        setCampaignTypeMid(event)
        if (creativeMainTableData.length > 0) {
            setIsModalVisibleTypeChange(true)
        }
        else {

            setCampaignType(event)
            if (publisher !== "") {
                const result = publisherOptions?.find(item => item.value === publisher);
                if (event === "Banner") {
                    setCampaignName("GAM_" + result?.label?.split("-").slice(1).join("-") + "_Banner")
                }
                else {
                    setCampaignName("GAM_" + result?.label?.split("-").slice(1).join("-") + "_IBV")
                }
            }

        }

    }

    const [advertiser] = useState("Google-Adexchange");

    const [publisher, setPublisher] = useState("");
    const [publisherIsRequiredError, setPublisherIsRequiredError] = useState(false);
    const [publisherOptions, setPublisherOptions] = useState([]);


    function onChangePublisher(event) {
        setPublisherIsRequiredError(false)
        setExchangeMappingDataIsRequiredError(false)

        const result = publisherOptions?.find(item => item.value === event);
        setPublisher(event)

        if (campaignType === "IBV") {
            if (creativeMainTableData.length > 0) {
                let tempCreativeArray = creativeMainTableData.map(item =>
                    item.adSource
                        ? {
                            ...item,
                            adSource: {
                                ...item.adSource,
                                demandPublisher_aniview: event
                            }
                        }
                        : item // Return the item unchanged if `adSource` doesn't exist
                );

                setCreativeMainTableData(tempCreativeArray)
            }
        }
        setNameDependOnPublisher_aniview(result?.label?.split("-").slice(1).join("-") + "_IBV")
        setName_aniview(result?.label?.split("-").slice(1).join("-") + "_IBV")

        if (campaignType === "Banner") {
            setCampaignName("GAM_" + result?.label?.split("-").slice(1).join("-") + "_Banner")
        }
        else {
            setCampaignName("GAM_" + result?.label?.split("-").slice(1).join("-") + "_IBV")
        }

        setCampaignNameIsRequiredError(false)


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + "ops/gam/zonesByPub?publisherId=" + event, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    if (response.status === 200) {

                        if (response.data.data.zones.length > 0) {

                            let tempData = exchangeMappingData.map(obj =>
                                obj.id === 785 ? { ...obj, check: true, validate: false, ssplist: response.data.data.zones?.join(",") } : obj

                            );

                            tempData.sort((a, b) => b.check - a.check)

                            setExchangeMappingData(tempData);
                        }
                        else {
                            let tempData = exchangeMappingData.map(obj =>
                                obj.id === 785 ? { ...obj, check: true, validate: false, ssplist: "" } : obj

                            );

                            tempData.sort((a, b) => b.check - a.check)

                            setExchangeMappingData(tempData);

                        }

                        setMinCpmValueError(false);
                        setMinCpmIsRequiredError(false);
                        setMaxCpmValueError(false);
                        setMaxGreaterThanMinError(false);
                        setMaxCpmIsRequiredError(false);


                        if (Object.keys(response.data.data.bidfloorData).length > 0) {


                            if (response.data.data.bidfloorData?.min_eCPM) {
                                setMinCpm(response.data.data.bidfloorData?.min_eCPM)


                                if (!(response.data.data.bidfloorData?.min_eCPM > 0 && response.data.data.bidfloorData?.min_eCPM <= 50)) {
                                    setMinCpmValueError(true)
                                }


                            }

                            if (response.data.data.bidfloorData?.max_eCPM) {
                                setMaxCpm(response.data.data.bidfloorData?.max_eCPM)


                                if (!(response.data.data.bidfloorData?.max_eCPM > 0 && response.data.data.bidfloorData?.max_eCPM <= 50)) {
                                    setMaxCpmValueError(true)
                                }

                            }

                        }
                        else {
                            setMinCpm("")
                            setMaxCpm("")
                        }




                        if (response.data.data.zones.length === 0 && response.data.data.error) {
                            notifyfailure("No zones found for the selected publisher")
                        }

                        if (response.data.data.zones.length !== 0 && response.data.data.error) {
                            notifyfailure("Bidfloor value not found")
                        }



                    }
                })
                .catch((error) => { });
        }
    }


    const [campaignName, setCampaignName] = useState("");
    const [campaignNameIsRequiredError, setCampaignNameIsRequiredError] =
        useState(false);

    function onChangeCampaignName(event) {
        setCampaignNameIsRequiredError(false);
        setCampaignName(event.target.value);
        if (event.target.value.trim().length === 0) {
            setCampaignNameIsRequiredError(true)
        }
        else {
            setCampaignNameIsRequiredError(false)
        }
    }

    function onBlurCampaignName(event) {
        setCampaignName(event.target.value.trim())
    }

    const [campaignCategoryList, setCampaignCategoryList] = useState([]);
    const [selectedCampaignCategory, setSelectedCampaignCategory] = useState("IAB1");
    const [campaignCategoryIsRequiredError, setCampaignCategoryIsRequiredError] =
        useState(false);

    function onChangeCampaignCategory(event) {
        setCampaignCategoryIsRequiredError(false);
        setSelectedCampaignCategory(event);

        axios
            .get(configData.SERVER_URL + "ops/gam/domainsbycategory?category=" + encodeURIComponent(event), {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setDomain_html_ViaCategory(response.data.data)

            })
            .catch((error) => { });

    }


    const [selectedRunTimeOption, setSelectedRuntimeOption] = useState(
        "Start immediately, run continuously"
    );

    const onChangeRuntimeOption = (event) => {
        setSelectedRuntimeOption(event.target.value);
        if (event.target.value === "Start immediately, run continuously") {
            setStartDateValidation(false);
        }
    };


    const [startDate, setStartDate] = useState(null);
    const [startDateString, setStartDateString] = useState("");
    const [startDateValidation, setStartDateValidation] = useState(false);
    const [endDate, setEndDate] = useState(null);
    const [endDateString, setEndDateString] = useState("");

    const onChangeStartDate = (date, dateString) => {
        setStartDate(date);
        setStartDateString(dateString);
        setStartDateValidation(false);

    };

    const disabledStartDate = (current) => {
        return current && (current < new Date().setHours(0, 0, 0, 0) || (endDate && current > endDate));
    };

    const onChangeEndDate = (date, dateString) => {
        setEndDate(date);
        setEndDateString(dateString);
    };

    const disabledEndDate = (current) => {
        return current && (startDate && current < startDate);
    };


    const [totalBudget, setTotalBudget] = useState("999999");
    const [totalBudgetIsRequiredError, setTotalBudgetIsRequiredError] =
        useState(false);
    const [totalBudgetValueError, setTotalBudgetValueError] = useState(false);
    const [budgetMaxGreaterThanMinError, setBudgetMaxGreaterThanMinError] =
        useState(false);

    function onChangeTotalBudget(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setTotalBudget(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 0.01 && Number(event.target.value.trim()) < 1000000) {
                setTotalBudgetValueError(false)

                if (monthlyBudget.trim().length > 0) {
                    if (Number(event.target.value.trim()) < Number(monthlyBudget.trim())) {
                        setBudgetMaxGreaterThanMinError(true)
                    }
                    else {
                        setBudgetMaxGreaterThanMinError(false)
                    }
                }

                if (dailyBudget.trim().length > 0) {
                    if (Number(event.target.value.trim()) < Number(dailyBudget.trim())) {
                        setBudgetMaxGreaterThanMinError(true)
                    }
                    else {
                        setBudgetMaxGreaterThanMinError(false)
                    }
                }

            }
            else {
                setBudgetMaxGreaterThanMinError(false)
                setTotalBudgetValueError(true)
            }


            if (event.target.value.trim()?.length === 0) {
                setTotalBudgetValueError(false)
                setBudgetMaxGreaterThanMinError(false)
                setTotalBudgetIsRequiredError(true)
            }
            else {
                setTotalBudgetIsRequiredError(false)
            }
        }
    }

    const [dailyBudget, setDailyBudget] = useState("25");
    const [dailyBudgetValueError, setDailyBudgetValueError] = useState(false);


    function onChangeDailyBudget(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setDailyBudget(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 0.01 && Number(event.target.value.trim()) < 1000000) {
                setDailyBudgetValueError(false)


                if (event.target.value.trim().length > 0) {


                    if (Number(event.target.value.trim()) > Number(totalBudget.trim())) {
                        setBudgetMaxGreaterThanMinError(true)
                    }
                    else {
                        setBudgetMaxGreaterThanMinError(false)
                    }
                }

            }
            else {
                setDailyBudgetValueError(true)
            }


            if (event.target.value.trim()?.length === 0) {
                setDailyBudgetValueError(false)
            }
            else {
                setMonthlyBudget("")
            }


            if (event.target.value.trim()?.length === 0 && totalBudget.trim().length === 0 && monthlyBudget.length === 0) {
                setBudgetMaxGreaterThanMinError(false)
            }


        }
    }

    const [monthlyBudget, setMonthlyBudget] = useState("");
    const [monthlyBudgetValueError, setMonthlyBudgetValueError] = useState(false);

    function onChangeMonthlyBudget(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setMonthlyBudget(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 0.01 && Number(event.target.value.trim()) < 1000000) {
                setMonthlyBudgetValueError(false)

                if (event.target.value.trim().length > 0) {
                    if (Number(event.target.value.trim()) > Number(totalBudget.trim())) {
                        setBudgetMaxGreaterThanMinError(true)
                    }
                    else {
                        setBudgetMaxGreaterThanMinError(false)
                    }
                }

            }
            else {
                setMonthlyBudgetValueError(true)
            }


            if (event.target.value.trim()?.length === 0) {
                setMonthlyBudgetValueError(false)
            }
            else {
                setDailyBudget("")
            }



            if (event.target.value.trim()?.length === 0 && totalBudget.trim().length === 0 && dailyBudget.length === 0) {
                setBudgetMaxGreaterThanMinError(false)
            }

        }
    }

    const [totalWins, setTotalWins] = useState("");
    const [totalWinsValueError, setTotalWinsValueError] = useState(false);
    const [winsMaxGreaterThanMinError, setWinsMaxGreaterThanMinError] =
        useState(false);

    function onChangeTotalWins(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setTotalWins(event.target.value.trim());

            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 1000000) {
                setTotalWinsValueError(false)



                if (dailyWins.trim().length > 0) {
                    if (Number(event.target.value.trim()) < Number(dailyWins.trim())) {
                        setWinsMaxGreaterThanMinError(true)
                    }
                    else {
                        setWinsMaxGreaterThanMinError(false)
                    }
                }
                else {
                    setWinsMaxGreaterThanMinError(false)
                }

            }
            else {
                setWinsMaxGreaterThanMinError(false)
                setTotalWinsValueError(true)
            }



            if (event.target.value.trim().length === 0) {
                setWinsMaxGreaterThanMinError(false)
                setTotalWinsValueError(false)
            }

        }
    }


    const [dailyWins, setDailyWins] = useState("");
    const [dailyWinsValueError, setDailyWinsValueError] = useState(false);


    function onChangeDailyWins(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setDailyWins(event.target.value.trim());

            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 1000000) {
                setDailyWinsValueError(false)


                if (event.target.value.trim().length > 0) {

                    if (Number(event.target.value.trim()) > Number(totalWins.trim())) {
                        setWinsMaxGreaterThanMinError(true)
                    }
                    else {
                        setWinsMaxGreaterThanMinError(false)
                    }
                }
                else {
                    setWinsMaxGreaterThanMinError(false)
                }

            }
            else {
                setDailyWinsValueError(true)
            }


            if (event.target.value.trim()?.length === 0) {
                setDailyWinsValueError(false)
                setWinsMaxGreaterThanMinError(false)
            }

        }
    }


    const [dailyClicks, setDailyClicks] = useState("");
    const [dailyClicksValidError, setDailyClicksValidError] = useState(false);

    function onChangeDailyClicks(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setDailyClicks(event.target.value.trim());

            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 1000000) {
                setDailyClicksValidError(false)
            }
            else {
                setDailyClicksValidError(true)
            }
        }

        if (event.target.value.trim()?.length === 0) {
            setDailyClicksValidError(false)
        }
    }



    const [selectedBudgetTypeOption, setSelectedBudgetTypeOption] =
        useState("Evenly");

    function onChangeBudgetTypeOption(event) {
        if (event.target.value === "Evenly") {
            setCheckboxSmartBidOptimizationValueError(false)
        }
        setSelectedBudgetTypeOption(event.target.value);
    }

    const [checkboxSmartBidOptimization, setCheckboxSmartBidOptimization] = useState(true);
    const [checkboxSmartBidOptimizationValueError, setCheckboxSmartBidOptimizationValueError] = useState(false);
    function onChangeCheckbox_smartBidOptimization(event) {
        if (!event.target.checked) {
            setCheckboxSmartBidOptimizationValueError(false)
        }
        setCheckboxSmartBidOptimization(event.target.checked);
    }




    const [exchangeMappingData, setExchangeMappingData] = useState([])
    const [exchangeMappingDataLoader, setExchangeMappingDataLoader] = useState(false)
    const [exchangeMappingDataIsRequiredError, setExchangeMappingDataIsRequiredError] = useState(false)
    const [exchangeMappingDataMappingError, setExchangeMappingDataMappingError] = useState(false)

    const [searchExchangeMapping, setSearchExchangeMapping] = useState("");
    const [loadingExchangeMapping, setLoadingExchangeMapping] = useState(true);

    const filterExchangeMappingData = useMemo(() => {
        if (searchExchangeMapping === "") {
            return exchangeMappingData
        }
        else {
            return exchangeMappingData.filter(item => (item['name']?.toLowerCase().includes(searchExchangeMapping.toLowerCase()) ||
                item['id']?.toString().toLowerCase().includes(searchExchangeMapping.toLowerCase()))
            );
        }
    }, [exchangeMappingData, searchExchangeMapping]);

    function validateExchangeMappingArray() {
        const hasChecked = exchangeMappingData.some(obj => obj.check);
        const validSsplist = exchangeMappingData.every(obj => {
            if (obj.check) {
                return obj.ssplist !== '';
            }
            return true;
        });
        return hasChecked && validSsplist;
    }

    function validateExchangeMappingArrayMappingRequest() {
        const allValid = exchangeMappingData.every(obj => {
            if (obj.check) {
                return obj.validate === true;
            }
            return true;
        });
        return allValid;
    }


    const exchangeMappingColumns = [
        {
            title: (
                <Checkbox
                    className='table_checkbox_d2'
                    indeterminate={exchangeMappingData.some(item => item.check) && !exchangeMappingData.every(item => item.check)}
                    checked={exchangeMappingData.every(item => item.check)}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        let tempData = exchangeMappingData.map(obj => ({
                            ...obj,
                            check: checked,
                            validate: checked === false ? false : obj.validate === true ? true : false,
                            ssplist: checked === false ? "" : obj.ssplist
                        }));

                        setExchangeMappingDataMappingError(false)
                        setExchangeMappingDataIsRequiredError(false)
                        setExchangeMappingData(tempData);
                    }}
                />
            ),
            dataIndex: 'check',
            key: 'check',
            width: 50,
            fixed: 'left',
            render: (text, record) => (
                <Checkbox
                    className='table_checkbox_d2'
                    checked={text}
                    onChange={(e) => {
                        setExchangeMappingDataIsRequiredError(false)
                        setExchangeMappingDataMappingError(false)
                        const checked = e.target.checked;
                        let tempData = exchangeMappingData.map(obj =>
                            obj.id === record.id ? { ...obj, check: checked, ssplist: checked === false ? "" : obj.ssplist, validate: false } : obj

                        );

                        setExchangeMappingData(tempData);

                    }}
                />
            ),
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 50,
            // sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: (a, b) => a.id - b.id,
            render: (text, record) => <div className="text_dark_800">{record.id}</div>,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 320,
            render: (text, record) => <Tooltip title={record.name}><div className="text_dark text_ellipsis text_black_d2 d-block">{record.name}</div></Tooltip>,
        },
        // {
        //     title: 'Validate',
        //     dataIndex: 'validate',
        //     key: 'validate',
        //     width: 350,
        //     render: (text) => <div className="text_dark_800">{text.toString()}</div>,
        // },
        {
            title: 'SSPs list',
            dataIndex: 'ssplist',
            key: 'ssplist',
            render: (text, record) => (
                <>
                    {record.check ?

                        <div className='position-relative input_with_checked_icon'>
                            <Input className='form_control table_input_d2'
                                placeholder='Zone ID comma separated'
                                disabled={!record.check}
                                value={text}
                                onChange={(e) => {
                                    setExchangeMappingDataIsRequiredError(false)
                                    setExchangeMappingDataMappingError(false)
                                    if (/^[0-9,]+$/.test(e.target.value.trim())) {
                                        const tempSspData = e.target.value.trim();
                                        let tempData = exchangeMappingData.map(obj =>
                                            obj.id === record.id ? { ...obj, ssplist: tempSspData, validate: false } : obj
                                        );

                                        setExchangeMappingData(tempData);
                                    }
                                    else {
                                        if (e.target.value.trim().length === 0) {

                                            let tempData = exchangeMappingData.map(obj =>
                                                obj.id === record.id ? { ...obj, ssplist: "", validate: false } : obj
                                            );

                                            setExchangeMappingData(tempData);

                                        }
                                    }
                                }}
                            />
                            {record.loading ?

                                <div className='table_btn_loader_d2'>
                                    <button className="new_integrate_btn_d2 remove_outline_focus_d2 btn btn_primary loader loader_btn_with_icon">
                                        <span> Loader</span>
                                        <img src={FullLoader} alt="USP" className="" />
                                    </button>
                                </div>
                                :
                                <div className='table_btn_loader_d2'>
                                    <button className=""
                                        disabled={record.validate}
                                        onClick={() => {
                                            if (record.ssplist.trim().length > 0) {
                                                setExchangeMappingDataLoader(true)
                                                handleSspListButton(record)
                                            }
                                        }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M13.3327 4L5.99935 11.3333L2.66602 8" stroke={record.validate ? "green" : "#7434DB"} stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </button>
                                </div>


                            }

                        </div>
                        :


                        <Input className='form_control px-3 table_input_d2'
                            placeholder='Zone ID comma separated'
                            disabled
                            value=""
                        />
                    }
                </>
            ),
        },




    ];

    const localeExchangeMapping = {
        emptyText:
            <>{
                loadingExchangeMapping &&
                <div className='no_data_screen'>
                    <div className='text-center'>
                        <img src={FullLoader} width={30} height={30} alt="USP" className="" />
                    </div>
                </div>
            }
            </>

    };



    const handleSspListButton = (record) => {
        setExchangeMappingDataMappingError(false)
        setExchangeMappingData(prevData =>
            prevData.map(obj => {
                if (obj["id"] === record["id"]) {
                    return { ...obj, loading: true };
                }
                return obj;
            })
        );


        setMinCpmValueError(false);
        setMinCpmIsRequiredError(false);
        setMaxCpmValueError(false);
        setMaxGreaterThanMinError(false);
        setMaxCpmIsRequiredError(false);

        setMinCpm("")
        setMaxCpm("")

        axios
            .post(configData.SERVER_URL + "ops/gam/bidfloorDataByZoneId?publisherId=" + publisher, {
                "zoneIds": record.ssplist,
                "exchange": record.id
            },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((response) => {


                if (Object.keys(response.data.data).length > 0) {
                    setMinCpm(response.data.data.min_eCPM)
                    setMaxCpm(response.data.data.max_eCPM)


                    if (!(response.data.data.min_eCPM > 0 && response.data.data.min_eCPM <= 50)) {
                        setMinCpmValueError(true)
                    }



                    if (!(response.data.data.max_eCPM > 0 && response.data.data.max_eCPM <= 50)) {
                        setMaxCpmValueError(true)
                    }


                }

                if (response.data.error) {
                    notifyfailure(response.data.message)
                }
                else {
                    notifysuccess(response.data.message)
                }

                setExchangeMappingData(prevData =>
                    prevData.map(obj => {
                        if (obj["id"] === record["id"]) {
                            return { ...obj, loading: false, rfData: response.data.rfData, newZone: response.data.newZone, delZones: response.data.delZones, zoneFlag: response.data.zoneFlag, validate: true };
                        }
                        return obj;
                    })
                );

                setExchangeMappingDataLoader(false)


            })
            .catch((error) => {
                if (error?.response) {
                    if (error?.response?.data?.message?.length !== 0) {
                        notifyfailure(error.response.data.message)
                    }
                } else {
                    notifycatch()
                }

                setExchangeMappingData(prevData =>
                    prevData.map(obj => {
                        if (obj["id"] === record["id"]) {
                            return { ...obj, loading: false, rfData: [], newZone: [], delZones: [], zoneFlag: {}, validate: false };
                        }
                        return obj;
                    })
                );

                setExchangeMappingDataLoader(false)

            });


    }


    const [minCpm, setMinCpm] = useState("");
    const [minCpmIsRequiredError, setMinCpmIsRequiredError] = useState(false);
    const [minCpmValueError, setMinCpmValueError] = useState(false);
    const [maxCpm, setMaxCpm] = useState("");
    const [maxCpmIsRequiredError, setMaxCpmIsRequiredError] = useState(false);
    const [maxCpmValueError, setMaxCpmValueError] = useState(false);
    const [maxGreaterThanMinError, setMaxGreaterThanMinError] = useState(false);


    function onChangeMinCpm(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {

            setMinCpm(event.target.value.trim());

            if (event.target.value.trim().length === 0) {
                setMinCpmValueError(false);
                setMaxGreaterThanMinError(false);
                setMinCpmIsRequiredError(true);
            } else {
                let minValCheck = 0;
                let maxValCheck = 50;

                if (
                    !(
                        event.target.value.trim() > minValCheck && event.target.value.trim() <= maxValCheck
                    )
                ) {
                    setMinCpmIsRequiredError(false);
                    setMaxGreaterThanMinError(false);
                    setMinCpmValueError(true);
                } else {
                    setMinCpmIsRequiredError(false);
                    setMaxGreaterThanMinError(false);
                    setMinCpmValueError(false);

                    if (maxCpm !== "") {
                        if (parseFloat(maxCpm) < parseFloat(event.target.value.trim())) {
                            setMinCpmIsRequiredError(false);
                            setMinCpmValueError(false);
                            setMaxGreaterThanMinError(true);
                        } else {
                            setMaxGreaterThanMinError(false);
                        }
                    }
                }
            }
        }
    }


    function onChangeMaxCpm(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setMaxCpm(event.target.value.trim());

            if (event.target.value.trim().length === 0) {
                setMaxCpmValueError(false);
                setMaxGreaterThanMinError(false);
                setMaxCpmIsRequiredError(true);
            } else {
                let minValCheck = 0;
                let maxValCheck = 50;

                if (
                    !(
                        event.target.value.trim() > minValCheck && event.target.value.trim() <= maxValCheck
                    )
                ) {
                    setMaxCpmIsRequiredError(false);
                    setMaxGreaterThanMinError(false);
                    setMaxCpmValueError(true);
                } else {
                    setMaxCpmIsRequiredError(false);
                    setMaxGreaterThanMinError(false);
                    setMaxCpmValueError(false);

                    if (minCpm !== "") {
                        if (parseFloat(minCpm) > parseFloat(event.target.value.trim())) {
                            setMaxCpmIsRequiredError(false);
                            setMaxCpmValueError(false);
                            setMaxGreaterThanMinError(true);
                        } else {
                            setMaxGreaterThanMinError(false);
                        }
                    }
                }
            }
        }
    }



    const campaignNameRef = useRef(null)
    const totalBudgetRef = useRef(null)
    const totalWinsRef = useRef(null)

    const errorDetectBudget = () => {

        if (campaignName.trim() === "" || campaignCategoryIsRequiredError || selectedCampaignCategory === "" || campaignCategoryIsRequiredError || publisher === "" || publisherIsRequiredError) {
            scrollToItem(campaignNameRef);
            return
        }

        if (
            selectedRunTimeOption === "Setup start and end date and time" &&
            startDate === null
        ) {
            scrollToItem(campaignNameRef);
            return
        }

        if (totalBudget === "" || totalBudgetIsRequiredError || totalBudgetValueError || budgetMaxGreaterThanMinError || monthlyBudgetValueError || dailyBudgetValueError) {
            scrollToItem(totalBudgetRef);
            return
        }

        if (totalWinsValueError || dailyClicksValidError || dailyWinsValueError || winsMaxGreaterThanMinError) {
            scrollToItem(totalWinsRef);
            return
        }

        if (selectedBudgetTypeOption !== "Evenly" && checkboxSmartBidOptimization) {
            scrollToItem(totalWinsRef);
            return
        }

    }

    const handleBudgetValidations = () => {
        errorDetectBudget()

        if (
            publisher !== "" &&
            campaignName.trim() !== "" &&
            selectedCampaignCategory !== "" &&
            totalBudget !== "" &&
            minCpm !== "" &&
            maxCpm !== "" &&
            (selectedRunTimeOption !== "Setup start and end date and time" ||
                startDate !== null) &&
            validateExchangeMappingArray() &&
            validateExchangeMappingArrayMappingRequest() &&
            (selectedBudgetTypeOption === "Evenly" ? true : checkboxSmartBidOptimization ? false : true)
        ) {

            if (
                publisherIsRequiredError === false &&
                campaignNameIsRequiredError === false &&
                campaignCategoryIsRequiredError === false &&
                minCpmIsRequiredError === false &&
                minCpmValueError === false &&
                maxCpmIsRequiredError === false &&
                maxCpmValueError === false &&
                maxGreaterThanMinError === false &&
                dailyBudgetValueError === false &&
                monthlyBudgetValueError === false &&
                totalBudgetIsRequiredError === false &&
                totalBudgetValueError === false &&
                budgetMaxGreaterThanMinError === false &&
                totalWinsValueError === false &&
                dailyWinsValueError === false &&
                winsMaxGreaterThanMinError === false &&
                dailyClicksValidError === false &&
                startDateValidation === false
            ) {
                handleBackView(1);


                // let payload1 = {
                //     type: campaignType,
                //     publisher: publisher,
                //     advertiser: advertiser,
                //     campaign_name: campaignName,
                //     campaign_category: selectedCampaignCategory,
                //     selectedRunTimeOption: selectedRunTimeOption,
                //     startDate: selectedRunTimeOption === "Setup start and end date and time" ? startDateString : "",
                //     endDate: selectedRunTimeOption === "Setup start and end date and time" ? endDateString : "",
                //     budget_type: selectedBudgetTypeOption,
                //     total_budget: totalBudget,
                //     monthly_budget: monthlyBudget,
                //     daily_budget: dailyBudget,
                //     total_wins: totalWins,
                //     daily_wins: dailyWins,
                //     daily_clicks: dailyClicks,
                //     min_eCPM: minCpm,
                //     max_eCPM: maxCpm,
                //     exchanges: exchangeMappingData.filter(item => item.check === true).map(({ check, loading, ...rest }) => rest),
                //     bidOptimize: checkboxSmartBidOptimization
                // }


            }
        } else {
            if (publisher === "") {
                setPublisherIsRequiredError(true)
            }
            if (campaignName.trim() === "") {
                setCampaignNameIsRequiredError(true);
            }
            if (
                selectedRunTimeOption === "Setup start and end date and time" &&
                startDate === null
            ) {
                setStartDateValidation(true);
            }
            if (selectedCampaignCategory === "") {
                setCampaignCategoryIsRequiredError(true);
            }
            if (totalBudget === "") {
                setTotalBudgetIsRequiredError(true);
            }
            if (minCpm === "") {
                setMinCpmIsRequiredError(true);
            }
            if (maxCpm === "") {
                setMaxCpmIsRequiredError(true);
            }
            if (!validateExchangeMappingArray()) {
                setExchangeMappingDataIsRequiredError(true)
            }
            if (!validateExchangeMappingArrayMappingRequest()) {
                setExchangeMappingDataMappingError(true)
            }

            if (selectedBudgetTypeOption !== "Evenly" && checkboxSmartBidOptimization) {
                setCheckboxSmartBidOptimizationValueError(true)
            }
        }

    };



    // ---------------------------------------------------------------------------------------------------------------------------------------//
    // -----------------------------------------  Optimization Code Starts ---------------------------------------------------------------------------//
    // ---------------------------------------------------------------------------------------------------------------------------------------//

    // //////////////////////////////////////////////////// create Optimization starts  //////////////////////////////////////////



    const [unitAdTypeOption, setUnitAdTypeOption] = useState(
        "Show all ads per publish page"
    );

    function onChangeUnitAdTypeOption(event) {
        setUnitAdTypeOption(event.target.value);
    }

    const [selectedCreativeOption, setSelectedCreativeOption] = useState("RANDOM");
    const [creativeRotationOption] = useState([{ label: "Random", value: "RANDOM" }, { label: "CTR", value: "CTR" }, { label: "CR", value: "CR" }, { label: "Weighted random", value: "WEIGHTED_RANDOM" }]);

    function onChangeCreativeOption(event) {
        setSelectedCreativeOption(event);
    }


    const [minBidding, setMinBidding] = useState("");
    const [minBiddingValidError, setMinBiddingValidError] = useState(false);

    function onChangeMinBidding(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setMinBidding(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 10 && Number(event.target.value.trim()) <= 100000) {
                setMinBiddingValidError(false)
            }
            else {
                setMinBiddingValidError(true)
            }
        }

        if (event.target.value.trim()?.length === 0) {
            setMinBiddingValidError(false)
        }
    }


    const [maxClicks, setMaxClicks] = useState("");
    const [maxClicksValidError, setMaxClicksValidError] = useState(false);

    function onChangeMaxClicks(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setMaxClicks(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 1 && Number(event.target.value.trim()) <= 1000) {
                setMaxClicksValidError(false)
            }
            else {
                setMaxClicksValidError(true)
            }
        }

        if (event.target.value.trim()?.length === 0) {
            setMaxClicksValidError(false)
        }
    }


    const [minViewability, setMinViewability] = useState("");
    // const [minViewabilityIsRequiredError, setMinViewabilityIsRequiredError] = useState(false);
    const [minViewabilityValidError, setMinViewabilityValidError] = useState(false);

    function onChangeMinViewability(event) {
        if (event.target.value.trim()?.length === 0) {
            setMinViewabilityValidError(false)
            // setMinViewabilityIsRequiredError(true)
            setMinViewability(event.target.value.trim());
        }
        else {
            // setMinViewabilityIsRequiredError(false)
            if (/^\d*$/.test(event.target.value.trim())) {
                setMinViewability(event.target.value.trim());

                if (Number(event.target.value.trim()) >= 1 && Number(event.target.value.trim()) <= 99) {
                    setMinViewabilityValidError(false)
                }
                else {
                    setMinViewabilityValidError(true)
                }
            }
        }
    }






    const [selectedListTypeOption, setSelectedListTypeOption] = useState("System-based");
    const [listTypeOption] = useState([{ "label": "IP-based", "value": "IP-based" },
    { "label": "Device ID-based", "value": "Device ID-based" },
    { "label": "System-based", "value": "System-based" }]);

    function onChangeListTypeOption(event) {
        setSelectedListTypeOption(event);
    }

    const [selectedListTypeFrequencyOption, setSelectedListTypeFrequencyOption] =
        useState("per 24 hours");
    const [ListTypeFrequencyOption] =
        useState([
            { "label": "per hour", "value": "per hour" },
            { "label": "per 24 hours", "value": "per 24 hours" },
            { "label": "per 48 hours", "value": "per 48 hours" },
            { "label": "per week", "value": "per week" },
            { "label": "per month", "value": "per month" }
        ]);

    function onChangeListTypeFrequencyOption(event) {
        setSelectedListTypeFrequencyOption(event);
    }


    const [frequencyValue, setFrequencyValue] = useState("1");
    const [frequencyValueValidError, setFrequencyValueValidError] = useState(false);

    function onChangeFrequencyValue(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setFrequencyValue(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100) {
                setFrequencyValueValidError(false)
            }
            else {
                setFrequencyValueValidError(true)
            }
        }

        if (event.target.value.trim()?.length === 0) {
            setFrequencyValueValidError(false)
        }
    }


    const [selectedBidOptimizationMode, setSelectedBidOptimizationMode] = useState("BIDFLOOR_PLUS_PERCENT_MARGIN");
    const [bidOptimizationModeOption] = useState([{ "label": "Bidfloor + % Margin", "value": "BIDFLOOR_PLUS_PERCENT_MARGIN" },
    { "label": "Bidfloor + $ Margin", "value": "BIDFLOOR_PLUS_FIXED_MARGIN" },
    { "label": "Random (Above Bid Floor)", "value": "BIDFLOOR_TO_MAX_RANDOM" }]);

    function onChangeBidOptimizationMode(event) {
        setSelectedBidOptimizationMode(event);

        setBidOptiomizationValue("");
        setBidOptiomizationValueIsRequiredError(false);
        setBidOptiomizationValueValidError(false);
    }



    const [bidOptiomizationValue, setBidOptiomizationValue] = useState("10");
    const [bidOptiomizationValueIsRequiredError, setBidOptiomizationValueIsRequiredError] = useState(false);
    const [bidOptiomizationValueValidError, setBidOptiomizationValueValidError] = useState(false);

    function onChangeBidOptiomizationValue(event) {
        if (event.target.value.trim()?.length === 0) {
            setBidOptiomizationValueValidError(false)
            setBidOptiomizationValueIsRequiredError(true)
            setBidOptiomizationValue(event.target.value.trim());
        }
        else {
            setBidOptiomizationValueIsRequiredError(false)
            if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
                setBidOptiomizationValue(event.target.value.trim());

                if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 100) {
                    setBidOptiomizationValueValidError(false)
                }
                else {
                    setBidOptiomizationValueValidError(true)
                }
            }
        }
    }

    const [checkbox_ipBasedConversion, setCheckbox_ipBasedConversion] = useState(false);

    function onChangeCheckbox_ipBasedconversion(event) {
        setCheckbox_ipBasedConversion(event.target.checked)
    }


    const [maxVCR, setMaxVCR] = useState("100");
    const [maxVCRIsRequiredError, setMaxVCRIsRequiredError] = useState(false);
    const [maxVCRValueError, setMaxVCRValueError] = useState(false);
    const [VCRMaxGreaterThanMinError, setVCRMaxGreaterThanMinError] =
        useState(false);

    function onChangeMaxVCR(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setMaxVCR(event.target.value.trim());

            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 100) {
                setMaxVCRValueError(false)



                if (minVCR.trim().length > 0) {
                    setMinVCRValueError(false)
                    if (Number(event.target.value.trim()) <= Number(minVCR.trim())) {
                        setVCRMaxGreaterThanMinError(true)
                    }
                    else {
                        setVCRMaxGreaterThanMinError(false)
                    }
                }
                else {
                    setVCRMaxGreaterThanMinError(false)
                }

            }
            else {
                setVCRMaxGreaterThanMinError(false)
                setMaxVCRValueError(true)
            }


        }

        if (event.target.value.trim().length === 0) {
            setVCRMaxGreaterThanMinError(false)
            setMaxVCRValueError(false)
            setMaxVCRIsRequiredError(true)
        }
        else {
            setMaxVCRIsRequiredError(false)
        }
    }



    const [minVCR, setMinVCR] = useState("0");
    const [minVCRIsRequiredError, setMinVCRIsRequiredError] = useState(false);
    const [minVCRValueError, setMinVCRValueError] = useState(false);

    function onChangeMinVCR(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setMinVCR(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) < 100) {
                setMinVCRValueError(false)


                if (maxVCR.trim().length > 0) {

                    if (Number(event.target.value.trim()) >= Number(maxVCR.trim())) {
                        setVCRMaxGreaterThanMinError(true)
                    }
                    else {
                        setVCRMaxGreaterThanMinError(false)
                    }
                }
                else {
                    setVCRMaxGreaterThanMinError(false)
                }

            }
            else {
                setMinVCRValueError(true)
            }

        }

        if (event.target.value.trim()?.length === 0) {
            setMinVCRValueError(false)
            setVCRMaxGreaterThanMinError(false)
            setMinVCRIsRequiredError(true)
        }
        else {
            setMinVCRIsRequiredError(false)
        }

    }



    const minBiddingRef = useRef(null)


    const errorDetctOptimization = () => {

        if (minBiddingValidError || maxClicksValidError || minViewabilityValidError) {
            scrollToItem(minBiddingRef);
            return
        }


    }

    const handleOptimizationValidations = () => {
        errorDetctOptimization()


        if (
            // minViewability !== "" &&
            minVCR.trim() !== "" &&
            maxVCR.trim() !== "" &&
            (selectedBidOptimizationMode === "BIDFLOOR_TO_MAX_RANDOM" ? true : bidOptiomizationValue !== "")
        ) {

            if (
                minBiddingValidError === false &&
                maxClicksValidError === false &&
                // minViewabilityIsRequiredError === false &&
                minViewabilityValidError === false &&
                frequencyValueValidError === false &&
                minVCRValueError === false &&
                minVCRIsRequiredError === false &&
                maxVCRValueError === false &&
                maxVCRIsRequiredError === false &&
                VCRMaxGreaterThanMinError === false &&
                (selectedBidOptimizationMode === "BIDFLOOR_TO_MAX_RANDOM" ? true : !bidOptiomizationValueIsRequiredError) &&
                (selectedBidOptimizationMode === "BIDFLOOR_TO_MAX_RANDOM" ? true : !bidOptiomizationValueValidError)
            ) {


                // let payload2 = {
                //     multipleAd_per_page: unitAdTypeOption,

                //     creatives_rotation: selectedCreativeOption,
                //     freqType: selectedListTypeOption,
                //     freqCapping: selectedListTypeFrequencyOption,
                //     freqValue: frequencyValue,
                //     minBiddingUniqueIP: minBidding,
                //     maxClicks: maxClicks,
                //     viewability: minViewability,
                //     optimizationType: selectedBidOptimizationMode,
                //     bidfloorMarginValue: selectedBidOptimizationMode === "BIDFLOOR_TO_MAX_RANDOM" ? "" : bidOptiomizationValue,
                //     vcrMin: minVCR,
                //     vcrMax: maxVCR,
                //     viewThroughConversionIp: checkbox_ipBasedConversion
                // }


                handleBackView(2);

            }
        } else {

            // if (minViewability === "") {
            //     setMinViewabilityIsRequiredError(true);
            // }

            if (minVCR.trim() === "") {
                setMinVCRIsRequiredError(true);
            }
            if (maxVCR.trim() === "") {
                setMaxVCRIsRequiredError(true);
            }

            if (selectedBidOptimizationMode !== "BIDFLOOR_TO_MAX_RANDOM" && bidOptiomizationValue === "") {
                setBidOptiomizationValueIsRequiredError(true);
            }

        }

    };


    // ---------------------------------------------------------------------------------------------------------------------------------------//
    // -----------------------------------------  Optimization Code Ends ---------------------------------------------------------------------------//
    // ---------------------------------------------------------------------------------------------------------------------------------------//



    // ---------------------------------------------------------------------------------------------------------------------------------------//
    // -----------------------------------------  Targeting Code Starts ---------------------------------------------------------------------------//
    // ---------------------------------------------------------------------------------------------------------------------------------------//




    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "ops/gam/excludedCategories", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setExcludedcategoryListOptions(response.data.data)
            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/rtbSensitiveCat", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setSensitiveCategoryListOptions(response.data.data)
            })
            .catch((error) => { });


        axios
            .get(configData.SERVER_URL + "ops/gam/countryList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setCountryListOptions(response.data.data)
                setCountryList(["us", "gb", "ca", "au"])

            })
            .catch((error) => { });


        axios
            .get(configData.SERVER_URL + "ops/gam/stateList?country=" + JSON.stringify(["us", "gb", "ca", "au"]), {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setStateListOptions(response.data.data)
            })
            .catch((error) => { });


        axios
            .get(configData.SERVER_URL + "ops/gam/oslist", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setOsListOptions(response.data.data)
                setOsList(response.data.data?.map(item => item.value))

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/browserlist", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setBrowserListOptions(response.data.data)
                setBrowserList(response.data.data?.map(item => item.value))

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/devicebrandsList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setDeviceBrandListOptions(response.data.data)
                setDeviceBrandList(response.data.data?.map(item => item.value))

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/devicetypeList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setDeviceListOptions(response.data.data)
                setDeviceList(response.data.data?.map(item => item.value))

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/ipminifiedlist", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setIpListOptions(response.data.data)
            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/bundleminifiedlist", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setAppBundleListOptions(response.data.data)
            })
            .catch((error) => { });


        axios
            .get(configData.SERVER_URL + "ops/gam/extendedusers", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setExtendedUserListOptions(response.data.data)
            })
            .catch((error) => { });





    }, [])

    const [data1, setData1] = useState("");
    const [isLoading1, setIsLoading1] = useState(false);

    React.useEffect(() => {
        const handleStorage1 = () => {
            const newData1 = localStorage.getItem("ipReload") || "";
            if (newData1 !== data1 && newData1 !== "") {
                setData1(newData1);
                setIsLoading1(true);
                // localStorage.removeItem('ipReload');
            }
        };

        window.addEventListener("storage", handleStorage1);

        return () => {
            window.removeEventListener("storage", handleStorage1);
        };
    }, [data1]);


    const [data2, setData2] = useState("");
    const [isLoading2, setIsLoading2] = useState(false);

    React.useEffect(() => {
        const handleStorage2 = () => {
            const newData2 = localStorage.getItem("appBundleReload") || "";
            if (newData2 !== data2 && newData2 !== "") {
                setData2(newData2);
                setIsLoading2(true);
                // localStorage.removeItem('appBundleReload');
            }
        };

        window.addEventListener("storage", handleStorage2);

        return () => {
            window.removeEventListener("storage", handleStorage2);
        };
    }, [data2]);

    const [data3, setData3] = useState("");
    const [isLoading3, setIsLoading3] = useState(false);

    React.useEffect(() => {
        const handleStorage3 = () => {
            const newData3 = localStorage.getItem("extendedUserReload") || "";
            if (newData3 !== data3 && newData3 !== "") {
                setData3(newData3);
                setIsLoading3(true);
                // localStorage.removeItem('extendedUserReload');
            }
        };

        window.addEventListener("storage", handleStorage3);

        return () => {
            window.removeEventListener("storage", handleStorage3);
        };
    }, [data3]);

    const [data4, setData4] = useState("");
    const [isLoading4, setIsLoading4] = useState(false);

    React.useEffect(() => {
        const handleStorage4 = () => {
            const newData4 = localStorage.getItem("categoryReload") || "";
            if (newData4 !== data4 && newData4 !== "") {
                setData4(newData4);
                setIsLoading4(true);
                // localStorage.removeItem('categoryReload');
            }
        };

        window.addEventListener("storage", handleStorage4);

        return () => {
            window.removeEventListener("storage", handleStorage4);
        };
    }, [data4]);


    React.useEffect(() => {

        if (isLoading1) {

            axios
                .get(configData.SERVER_URL + "ops/gam/ipminifiedlist", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        setIsLoading1(false);
                        setIpListOptions(response.data.data);
                        setIpList([]);
                        setIpListIsRequiredError(false)
                    }
                })
                .catch((error) => { });

        }
    }, [isLoading1])

    React.useEffect(() => {

        if (isLoading2) {

            axios
                .get(configData.SERVER_URL + "ops/gam/bundleminifiedlist", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        setIsLoading2(false);
                        setAppBundleListOptions(response.data.data);
                        setAppBundleList([]);
                        setAppBundleListIsRequiredError(false)
                    }
                })
                .catch((error) => { });

        }
    }, [isLoading2])

    React.useEffect(() => {

        if (isLoading3) {

            axios
                .get(configData.SERVER_URL + "ops/gam/extendedusers", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        setIsLoading3(false);
                        setExtendedUserListOptions(response.data.data);
                        setExtendedUserList([]);
                        setExtendedUserListIsRequiredError(false)
                    }
                })
                .catch((error) => { });

        }
    }, [isLoading3])

    React.useEffect(() => {

        if (isLoading4) {

            axios
                .get(configData.SERVER_URL + "ops/gam/excludedCategories", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        setIsLoading4(false);
                        setExcludedcategoryListOptions(response.data.data);
                        setExcludedcategoryList([]);
                    }
                })
                .catch((error) => { });

        }
    }, [isLoading4])



    const [excludedcategoryList, setExcludedcategoryList] = useState([]);
    const [excludedcategoryListOptions, setExcludedcategoryListOptions] = useState([]);



    const [searchExcludedcategoryList, setSearchExcludedcategoryList] = useState('');

    const handleSearchExcludedcategoryList = (e) => {
        setSearchExcludedcategoryList(e.target.value.toLowerCase());
    };

    const filterExcludedcategoryList = excludedcategoryListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchExcludedcategoryList)
    );

    function handleSelectAllExcludedcategoryList() {
        const allValues = excludedcategoryListOptions.map(option => option.value);
        let tempExcludedcategoryList = [];
        if (excludedcategoryList?.length !== excludedcategoryListOptions?.length) {
            tempExcludedcategoryList = [...allValues];
        } else {
            tempExcludedcategoryList = [];
        }

        setExcludedcategoryList(tempExcludedcategoryList);
    }



    function handleExcludedcategoryList(value) {
        let tempExcludedcategoryList = [...excludedcategoryList]

        let newValue = [];
        if (tempExcludedcategoryList?.includes(value)) {
            newValue = tempExcludedcategoryList.filter((item) => item !== value);
        } else {
            newValue = [...tempExcludedcategoryList, value];
        }
        tempExcludedcategoryList = newValue

        setExcludedcategoryList(tempExcludedcategoryList)

    }


    const [sensitiveCategoryList, setSensitiveCategoryList] = useState([]);
    const [sensitiveCategoryListOptions, setSensitiveCategoryListOptions] = useState([]);



    const [searchSensitiveCategoryList, setSearchSensitiveCategoryList] = useState('');

    const handleSearchSensitiveCategoryList = (e) => {
        setSearchSensitiveCategoryList(e.target.value.toLowerCase());
    };

    const filterSensitiveCategoryList = sensitiveCategoryListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchSensitiveCategoryList)
    );

    function handleSelectAllSensitiveCategoryList() {
        const allValues = sensitiveCategoryListOptions.map(option => option.value);
        let tempSensitiveCategoryList = [];
        if (sensitiveCategoryList?.length !== sensitiveCategoryListOptions?.length) {
            tempSensitiveCategoryList = [...allValues];
        } else {
            tempSensitiveCategoryList = [];
        }


        setSensitiveCategoryList(tempSensitiveCategoryList);
    }



    function handleSensitiveCategoryList(value) {
        let tempSensitiveCategoryList = [...sensitiveCategoryList]

        let newValue = [];
        if (tempSensitiveCategoryList?.includes(value)) {
            newValue = tempSensitiveCategoryList.filter((item) => item !== value);
        } else {
            newValue = [...tempSensitiveCategoryList, value];
        }
        tempSensitiveCategoryList = newValue

        setSensitiveCategoryList(tempSensitiveCategoryList)

    }

    // country---------------------------------------------------------------------------------------------------------------------------------------

    const [countryList, setCountryList] = useState([]);
    const [countryListOptions, setCountryListOptions] = useState([]);
    const [countryListIsRequiredError, setCountryListIsRequiredError] = useState(false);



    const [searchCountryList, setSearchCountryList] = useState('');

    const handleSearchCountryList = (e) => {
        setSearchCountryList(e.target.value.toLowerCase());
    };

    const filterCountryList = countryListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchCountryList)
    );

    function handleSelectAllCountryList() {
        const allValues = countryListOptions.map(option => option.value);
        let tempCountryList = [];
        if (countryList?.length !== countryListOptions?.length) {
            tempCountryList = [...allValues];
        } else {
            tempCountryList = [];
        }



        setCityListOptions([])
        setCityList([])
        setStateList([])

        if (tempCountryList?.length === 0) {
            setCountryListIsRequiredError(true)

            setStateListOptions([])
        }
        else {
            setCountryListIsRequiredError(false)
            setStateListOptionsLoader(true)

            axios
                .get(configData.SERVER_URL + "ops/gam/stateList?country=" + JSON.stringify(tempCountryList), {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    setStateListOptions(response.data.data)
                    setStateListOptionsLoader(false)
                })
                .catch((error) => {

                    setStateListOptionsLoader(false)
                });
        }

        setCountryList(tempCountryList);
    }



    function handleCountryList(value) {
        let tempCountryList = [...countryList]

        let newValue = [];
        if (tempCountryList?.includes(value)) {
            newValue = tempCountryList.filter((item) => item !== value);
        } else {
            newValue = [...tempCountryList, value];
        }
        tempCountryList = newValue


        if (tempCountryList?.length === 0) {
            setCountryListIsRequiredError(true)
        }
        else {
            setCountryListIsRequiredError(false)
        }
        setCountryList(tempCountryList)




        setCityListOptions([])
        setCityList([])
        setStateList([])

        setStateListOptionsLoader(true)

        axios
            .get(configData.SERVER_URL + "ops/gam/stateList?country=" + JSON.stringify(tempCountryList), {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setStateListOptions(response.data.data)
                setStateListOptionsLoader(false)
            })
            .catch((error) => {
                setStateListOptionsLoader(false)
            });

    }



    const [stateList, setStateList] = useState([]);
    const [stateListOptions, setStateListOptions] = useState([]);
    const [stateListOptionsLoader, setStateListOptionsLoader] = useState(false);



    const [searchStateList, setSearchStateList] = useState('');

    const handleSearchStateList = (e) => {
        setSearchStateList(e.target.value.toLowerCase());
    };

    const filterStateList = stateListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchStateList)
    );

    function handleSelectAllStateList() {
        const allValues = stateListOptions.map(option => option.value);
        let tempStateList = [];


        setCityList([])
        if (stateList?.length !== stateListOptions?.length) {
            tempStateList = [...allValues];

            setCityListOptionsLoader(true)
            axios
                .get(configData.SERVER_URL + "ops/gam/cityList?state=" + JSON.stringify(tempStateList), {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    setCityListOptions(response.data.data)
                    setCityListOptionsLoader(false)
                })
                .catch((error) => {
                    setCityListOptionsLoader(false)
                });

        } else {
            tempStateList = [];
            setCityListOptions([])
        }

        setStateList(tempStateList);


    }



    function handleStateList(value) {
        let tempStateList = [...stateList]

        let newValue = [];
        if (tempStateList?.includes(value)) {
            newValue = tempStateList.filter((item) => item !== value);
        } else {
            newValue = [...tempStateList, value];
        }
        tempStateList = newValue

        setStateList(tempStateList)

        setCityList([])
        setCityListOptionsLoader(true)
        axios
            .get(configData.SERVER_URL + "ops/gam/cityList?state=" + JSON.stringify(tempStateList), {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setCityListOptions(response.data.data)
                setCityListOptionsLoader(false)
            })
            .catch((error) => {
                setCityListOptionsLoader(false)
            });

    }


    const [cityList, setCityList] = useState([]);
    const [cityListOptions, setCityListOptions] = useState([]);
    const [cityListOptionsLoader, setCityListOptionsLoader] = useState(false);


    const [searchCityList, setSearchCityList] = useState('');

    const handleSearchCityList = (e) => {
        setSearchCityList(e.target.value.toLowerCase());
    };

    const filterCityList = cityListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchCityList)
    );

    function handleSelectAllCityList() {
        const allValues = cityListOptions.map(option => option.value);
        let tempCityList = [];
        if (cityList?.length !== cityListOptions?.length) {
            tempCityList = [...allValues];
        } else {
            tempCityList = [];
        }

        setCityList(tempCityList);
    }



    function handleCityList(value) {
        let tempCityList = [...cityList]

        let newValue = [];
        if (tempCityList?.includes(value)) {
            newValue = tempCityList.filter((item) => item !== value);
        } else {
            newValue = [...tempCityList, value];
        }
        tempCityList = newValue

        setCityList(tempCityList)

    }


    // devices and browsers---------------------------------------------------------------------------------------------------------------------------------------

    const [appSites, setAppSites] = useState(
        "Show on sites"
    );

    function onChangeAppSites(event) {
        setAppSites(event.target.value);
    }

    const [checkbox_non_empty_device_id, setCheckbox_non_empty_device_id] = useState(
        false
    );

    function onChangeCheckbox_non_empty_device_id(event) {
        setCheckbox_non_empty_device_id(event.target.checked);
    }



    const [browserList, setBrowserList] = useState([]);
    const [browserListOptions, setBrowserListOptions] = useState([]);
    const [browserListIsRequiredError, setBrowserListIsRequiredError] = useState(false);



    const [searchBrowserList, setSearchBrowserList] = useState('');

    const handleSearchBrowserList = (e) => {
        setSearchBrowserList(e.target.value.toLowerCase());
    };

    const filterBrowserList = browserListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchBrowserList)
    );

    function handleSelectAllBrowserList() {
        const allValues = browserListOptions.map(option => option.value);
        let tempBrowserList = [];
        if (browserList?.length !== browserListOptions?.length) {
            tempBrowserList = [...allValues];
        } else {
            tempBrowserList = [];
        }

        if (tempBrowserList?.length === 0) {
            setBrowserListIsRequiredError(true)
        }
        else {
            setBrowserListIsRequiredError(false)
        }

        setBrowserList(tempBrowserList);
    }



    function handleBrowserList(value) {
        let tempBrowserList = [...browserList]

        let newValue = [];
        if (tempBrowserList?.includes(value)) {
            newValue = tempBrowserList.filter((item) => item !== value);
        } else {
            newValue = [...tempBrowserList, value];
        }
        tempBrowserList = newValue


        if (tempBrowserList?.length === 0) {
            setBrowserListIsRequiredError(true)
        }
        else {
            setBrowserListIsRequiredError(false)
        }

        setBrowserList(tempBrowserList)

    }


    const [osList, setOsList] = useState([]);
    const [osListOptions, setOsListOptions] = useState([]);
    const [osListIsRequiredError, setOsListIsRequiredError] = useState(false);
    // const [searchOsList, setSearchOsList] = useState('');

    // const handleSearchOsList = (e) => {
    //     setSearchOsList(e.target.value?.toLowerCase());
    // };

    // const filterOsist = osListOptions.filter(option =>
    //     option?.title?.toLowerCase()?.includes(searchOsList)
    // );

    const handleOsList = (newValue) => {
        setOsList(newValue);

        if (Array.isArray(newValue)) {
            if (newValue?.length === 0) {
                setOsListIsRequiredError(true)
            }
            else {
                setOsListIsRequiredError(false)
            }
        }

    };


    const handleSelectAllOsList = () => {
        if (osList.length === osListOptions.length) {
            setOsList([]);
            setOsListIsRequiredError(true)
        } else {
            setOsList(osListOptions.map((os) => os.value));
            setOsListIsRequiredError(false)
        }
    };


    const tPropsOs = {
        treeData: osListOptions,
        value: osList,
        onChange: handleOsList,
        treeCheckable: true,
        showCheckedStrategy: SHOW_PARENT,
        placeholder: "-Select-",
        displayRender: () => null,
        style: {
            width: "100%",
        },
        dropdownRender: (menu) => (
            <>
                {/* <div className="custom_inside_searchbar_d2">
                    <Input placeholder="Search" value={searchOsList} onChange={handleSearchOsList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                </div> */}
                <div className='select_all_d2'

                    onClick={() => handleSelectAllOsList()}
                >
                    <Checkbox
                        checked={osList?.length === osListOptions?.length}
                        onClick={(e) => e.stopPropagation()}
                    >
                        Select All
                    </Checkbox>
                </div>

                {menu}
            </>
        ),

        filterTreeNode: (inputValue, treeNode) => {
            const title = treeNode?.title?.toLowerCase();
            const searchValueLowerCase = inputValue?.toLowerCase();
            // const isSelected = selectedOsList.includes(treeNode.value);

            return title?.includes(searchValueLowerCase);
            //  || isSelected
        },

        // inputValue: searchOsList,
        // onSearch: (value) => setSearchOsList(value),
    };


    const [deviceList, setDeviceList] = useState([]);
    const [deviceListOptions, setDeviceListOptions] = useState([]);
    const [deviceListIsRequiredError, setDeviceListIsRequiredError] = useState(false);



    const [searchDeviceList, setSearchDeviceList] = useState('');

    const handleSearchDeviceList = (e) => {
        setSearchDeviceList(e.target.value.toLowerCase());
    };

    const filterDeviceList = deviceListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchDeviceList)
    );

    function handleSelectAllDeviceList() {
        const allValues = deviceListOptions.map(option => option.value);
        let tempDeviceList = [];
        if (deviceList?.length !== deviceListOptions?.length) {
            tempDeviceList = [...allValues];
        } else {
            tempDeviceList = [];
        }

        if (tempDeviceList?.length === 0) {
            setDeviceListIsRequiredError(true)
        }
        else {
            setDeviceListIsRequiredError(false)
        }
        setDeviceList(tempDeviceList);
    }



    function handleDeviceList(value) {
        let tempDeviceList = [...deviceList]

        let newValue = [];
        if (tempDeviceList?.includes(value)) {
            newValue = tempDeviceList.filter((item) => item !== value);
        } else {
            newValue = [...tempDeviceList, value];
        }
        tempDeviceList = newValue


        if (tempDeviceList?.length === 0) {
            setDeviceListIsRequiredError(true)
        }
        else {
            setDeviceListIsRequiredError(false)
        }
        setDeviceList(tempDeviceList)

    }



    const [deviceBrandList, setDeviceBrandList] = useState([]);
    const [deviceBrandListOptions, setDeviceBrandListOptions] = useState([]);
    const [deviceBrandListIsRequiredError, setDeviceBrandListIsRequiredError] = useState(false);



    const [searchDeviceBrandList, setSearchDeviceBrandList] = useState('');

    const handleSearchDeviceBrandList = (e) => {
        setSearchDeviceBrandList(e.target.value.toLowerCase());
    };

    const filterDeviceBrandList = deviceBrandListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchDeviceBrandList)
    );

    function handleSelectAllDeviceBrandList() {
        const allValues = deviceBrandListOptions.map(option => option.value);
        let tempDeviceBrandList = [];
        if (deviceBrandList?.length !== deviceBrandListOptions?.length) {
            tempDeviceBrandList = [...allValues];
        } else {
            tempDeviceBrandList = [];
        }

        if (tempDeviceBrandList?.length === 0) {
            setDeviceBrandListIsRequiredError(true)
        }
        else {
            setDeviceBrandListIsRequiredError(false)
        }

        setDeviceBrandList(tempDeviceBrandList);
    }



    function handleDeviceBrandList(value) {
        let tempDeviceBrandList = [...deviceBrandList]

        let newValue = [];
        if (tempDeviceBrandList?.includes(value)) {
            newValue = tempDeviceBrandList.filter((item) => item !== value);
        } else {
            newValue = [...tempDeviceBrandList, value];
        }
        tempDeviceBrandList = newValue

        if (tempDeviceBrandList?.length === 0) {
            setDeviceBrandListIsRequiredError(true)
        }
        else {
            setDeviceBrandListIsRequiredError(false)
        }

        setDeviceBrandList(tempDeviceBrandList)

    }

    // list targeting---------------------------------------------------------------------------------------------------------------------------------------

    const [ipListMode, setIpListMode] = useState("DISABLED");
    const [ipListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeIpListMode(event) {
        setIpListMode(event);
    };


    const [ipList, setIpList] = useState([]);
    const [ipListOptions, setIpListOptions] = useState([]);
    const [ipListIsRequiredError, setIpListIsRequiredError] = useState(false);



    const [searchIpList, setSearchIpList] = useState('');

    const handleSearchIpList = (e) => {
        setSearchIpList(e.target.value.toLowerCase());
    };

    const filterIpList = ipListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchIpList)
    );

    function handleSelectAllIpList() {
        const allValues = ipListOptions.map(option => option.value);
        let tempIpList = [];
        if (ipList?.length !== ipListOptions?.length) {
            tempIpList = [...allValues];
            setIpListIsRequiredError(false)
        } else {
            tempIpList = [];
            setIpListIsRequiredError(true)
        }

        setIpList(tempIpList);
    }



    function handleIpList(value) {
        let tempIpList = [...ipList]

        let newValue = [];
        if (tempIpList?.includes(value)) {
            newValue = tempIpList.filter((item) => item !== value);
        } else {
            newValue = [...tempIpList, value];
        }
        tempIpList = newValue

        if (tempIpList.length === 0) {
            setIpListIsRequiredError(true)
        }
        else {
            setIpListIsRequiredError(false)
        }

        setIpList(tempIpList)

    }


    const [domainListMode, setDomainListMode] = useState("DISABLED");
    const [domainListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeDomainListMode(event) {
        setDomainListMode(event);
    };


    const [domainList, setDomainList] = useState([]);
    const [domainListOptions] = useState([]);
    const [domainListIsRequiredError, setDomainListIsRequiredError] = useState(false);



    const [searchDomainList, setSearchDomainList] = useState('');

    const handleSearchDomainList = (e) => {
        setSearchDomainList(e.target.value.toLowerCase());
    };

    const filterDomainList = domainListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchDomainList)
    );

    function handleSelectAllDomainList() {
        const allValues = domainListOptions.map(option => option.value);
        let tempDomainList = [];
        if (domainList?.length !== domainListOptions?.length) {
            tempDomainList = [...allValues];
        } else {
            tempDomainList = [];
        }

        if (tempDomainList?.length === 0) {
            setDomainListIsRequiredError(true)
        }
        else {
            setDomainListIsRequiredError(false)
        }

        setDomainList(tempDomainList);
    }



    function handleDomainList(value) {
        let tempDomainList = [...domainList]

        let newValue = [];
        if (tempDomainList?.includes(value)) {
            newValue = tempDomainList.filter((item) => item !== value);
        } else {
            newValue = [...tempDomainList, value];
        }
        tempDomainList = newValue

        if (tempDomainList?.length === 0) {
            setDomainListIsRequiredError(true)
        }
        else {
            setDomainListIsRequiredError(false)
        }


        setDomainList(tempDomainList)

    }



    const [extendedUserListMode, setExtendedUserListMode] = useState("DISABLED");
    const [extendedUserListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeExtendedUserListMode(event) {
        setExtendedUserListMode(event);
    };

    const [extendedUserList, setExtendedUserList] = useState([]);
    const [extendedUserListOptions, setExtendedUserListOptions] = useState([]);
    const [extendedUserListIsRequiredError, setExtendedUserListIsRequiredError] = useState(false);



    const [searchExtendedUserList, setSearchExtendedUserList] = useState('');

    const handleSearchExtendedUserList = (e) => {
        setSearchExtendedUserList(e.target.value.toLowerCase());
    };

    const filterExtendedUserList = extendedUserListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchExtendedUserList)
    );

    function handleSelectAllExtendedUserList() {
        const allValues = extendedUserListOptions.map(option => option.value);
        let tempExtendedUserList = [];
        if (extendedUserList?.length !== extendedUserListOptions?.length) {
            tempExtendedUserList = [...allValues];
            setExtendedUserListIsRequiredError(false)
        } else {
            tempExtendedUserList = [];
            setExtendedUserListIsRequiredError(true)
        }

        setExtendedUserList(tempExtendedUserList);
    }



    function handleExtendedUserList(value) {
        let tempExtendedUserList = [...extendedUserList]

        let newValue = [];
        if (tempExtendedUserList?.includes(value)) {
            newValue = tempExtendedUserList.filter((item) => item !== value);
        } else {
            newValue = [...tempExtendedUserList, value];
        }
        tempExtendedUserList = newValue

        if (tempExtendedUserList.length === 0) {
            setExtendedUserListIsRequiredError(true)
        }
        else {
            setExtendedUserListIsRequiredError(false)
        }

        setExtendedUserList(tempExtendedUserList)

    }



    const [appBundleListMode, setAppBundleListMode] = useState("DISABLED");
    const [appBundleListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeAppBundleListMode(event) {
        setAppBundleListMode(event);
    };


    const [appBundleList, setAppBundleList] = useState([]);
    const [appBundleListOptions, setAppBundleListOptions] = useState([]);
    const [appBundleListIsRequiredError, setAppBundleListIsRequiredError] = useState(false);



    const [searchAppBundleList, setSearchAppBundleList] = useState('');

    const handleSearchAppBundleList = (e) => {
        setSearchAppBundleList(e.target.value.toLowerCase());
    };

    const filterAppBundleList = appBundleListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchAppBundleList)
    );

    function handleSelectAllAppBundleList() {
        const allValues = appBundleListOptions.map(option => option.value);
        let tempAppBundleList = [];
        if (appBundleList?.length !== appBundleListOptions?.length) {
            tempAppBundleList = [...allValues];
            setAppBundleListIsRequiredError(false)
        } else {
            tempAppBundleList = [];
            setAppBundleListIsRequiredError(true)
        }

        setAppBundleList(tempAppBundleList);
    }



    function handleAppBundleList(value) {
        let tempAppBundleList = [...appBundleList]

        let newValue = [];
        if (tempAppBundleList?.includes(value)) {
            newValue = tempAppBundleList.filter((item) => item !== value);
        } else {
            newValue = [...tempAppBundleList, value];
        }
        tempAppBundleList = newValue

        if (tempAppBundleList.length === 0) {
            setAppBundleListIsRequiredError(true)
        }
        else {
            setAppBundleListIsRequiredError(false)
        }


        setAppBundleList(tempAppBundleList)

    }



    const [siteIdListMode, setSiteIdListMode] = useState("DISABLED");
    const [siteIdListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeSiteIdListMode(event) {
        setSiteIdListMode(event);
    };

    const [siteIdList, setSiteIdList] = useState("");
    const [siteIdListIsRequiredError, setSiteIdListIsRequiredError] = useState(false);

    function onChangeSiteIdList(event) {
        setSiteIdListIsRequiredError(false)
        setSiteIdList(event.target.value);
    };

    function onBlurSiteIdList(event) {
        if (siteIdListMode !== "DISABLED" && event.target.value.trim().length === 0) {
            setSiteIdListIsRequiredError(true)
        }
        setSiteIdList(event.target.value.trim());
    };

    const [appBundleTextListMode, setAppBundleTextListMode] = useState("DISABLED");
    const [appBundleTextListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeAppBundleTextListMode(event) {
        setAppBundleTextListMode(event);
    };

    const [appBundleTextList, setAppBundleTextList] = useState("");
    const [appBundleTextListIsRequiredError, setAppBundleTextListIsRequiredError] = useState(false);
    const [appBundleTextListValidError, setAppBundleTextListValidError] = useState(false);

    function onChangeAppBundleTextList(event) {
        setAppBundleTextListIsRequiredError(false)
        setAppBundleTextListValidError(false)
        setAppBundleTextList(event.target.value);
    };

    function validateUrlsBundleList(urls) {
        const urlsArr = urls.trim().split("\n");
        for (let i = 0; i < urlsArr.length; i++) {
            if (isNaN(urlsArr[i])) {
                if (!regexBundle.test(urlsArr[i])) {
                    return false;
                }
            }
        }
        return true;
    }

    function onBlurAppBundleTextList(event) {
        if (appBundleTextListMode !== "DISABLED" && event.target.value.trim().length === 0) {
            setAppBundleTextListValidError(false)
            setAppBundleTextListIsRequiredError(true)
        }
        else if (appBundleTextListMode !== "DISABLED" && event.target.value.trim().length !== 0) {
            setAppBundleTextListValidError(!validateUrlsBundleList(event.target.value.trim()));
        }

        setAppBundleTextList(event.target.value.trim());

    };


    const [appIdListMode, setAppIdListMode] = useState("DISABLED");
    const [appIdListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeAppIdListMode(event) {
        setAppIdListMode(event);
    };

    const [appIdList, setAppIdList] = useState("");
    const [appIdListIsRequiredError, setAppIdListIsRequiredError] = useState(false);

    function onChangeAppIdList(event) {
        setAppIdListIsRequiredError(false)
        setAppIdList(event.target.value);
    };

    function onBlurAppIdList(event) {
        if (appIdListMode !== "DISABLED" && event.target.value.trim().length === 0) {
            setAppIdListIsRequiredError(true)
        }
        setAppIdList(event.target.value.trim());
    };


    const [publisherIdListMode, setPublisherIdListMode] = useState("DISABLED");
    const [publisherIdListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangePublisherIdListMode(event) {
        setPublisherIdListMode(event);
    };

    const [publisherIdList, setPublisherIdList] = useState("");
    const [publisherIdListIsRequiredError, setPublisherIdListIsRequiredError] = useState(false);

    function onChangePublisherIdList(event) {
        setPublisherIdListIsRequiredError(false)
        setPublisherIdList(event.target.value);
    };

    function onBlurPublisherIdList(event) {
        if (publisherIdListMode !== "DISABLED" && event.target.value.trim().length === 0) {
            setPublisherIdListIsRequiredError(true)
        }
        setPublisherIdList(event.target.value.trim());
    };


    const [checkbox_non_empty_publisher_id, setCheckbox_non_empty_publisher_id] = useState(
        false
    );

    function onChangeCheckbox_non_empty_publisher_id(event) {
        setCheckbox_non_empty_publisher_id(event.target.checked);
    }




    const [tagIdListMode, setTagIdListMode] = useState("DISABLED");
    const [tagIdListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeTagIdListMode(event) {
        setTagIdListMode(event);
    };

    const [tagIdList, setTagIdList] = useState("");
    const [tagIdListIsRequiredError, setTagIdListIsRequiredError] = useState(false);

    function onChangeTagIdList(event) {
        setTagIdListIsRequiredError(false)
        setTagIdList(event.target.value);
    };

    function onBlurTagIdList(event) {
        if (tagIdListMode !== "DISABLED" && event.target.value.trim().length === 0) {
            setTagIdListIsRequiredError(true)
        }
        setTagIdList(event.target.value.trim());
    };



    const countryListRef = useRef(null)
    const deviceListRef = useRef(null)
    const ipListRef = useRef(null)


    const errorDetectTargeting = () => {

        if (countryListIsRequiredError || countryList.length === 0) {
            scrollToItem(countryListRef);
            return
        }

        if (deviceListIsRequiredError || deviceList.length === 0) {
            scrollToItem(deviceListRef);
            return
        }


        if (deviceBrandListIsRequiredError || deviceBrandList.length === 0) {
            scrollToItem(deviceListRef);
            return
        }

        if (browserListIsRequiredError || browserList.length === 0) {
            scrollToItem(deviceListRef);
            return
        }

        if (osListIsRequiredError || osList.length === 0) {
            scrollToItem(deviceListRef);
            return
        }

        if ((ipListMode === "DISABLED" ? false : ipList.length === 0) || (extendedUserListMode === "DISABLED" ? false : extendedUserList.length === 0) || (appBundleListMode === "DISABLED" ? false : appBundleList.length === 0) || (domainListMode === "DISABLED" ? false : domainList.length === 0)) {
            scrollToItem(ipListRef);
            return
        }

    }

    const handleTargetingValidations = () => {
        errorDetectTargeting()

        if (
            countryList.length !== 0 &&
            deviceList.length !== 0 &&
            osList.length !== 0 &&
            deviceBrandList.length !== 0 &&
            browserList.length !== 0
            && (ipListMode === "DISABLED" ? true : ipList.length !== 0)
            && (extendedUserListMode === "DISABLED" ? true : extendedUserList.length !== 0)
            && (appBundleListMode === "DISABLED" ? true : appBundleList.length !== 0)
            && (domainListMode === "DISABLED" ? true : domainList.length !== 0)
            && (siteIdListMode === "DISABLED" ? true : siteIdList.trim().length !== 0)
            && (publisherIdListMode === "DISABLED" ? true : publisherIdList.trim().length !== 0)
            && (appIdListMode === "DISABLED" ? true : appIdList.trim().length !== 0)
            && (tagIdListMode === "DISABLED" ? true : tagIdList.trim().length !== 0)
            && (appBundleTextListMode === "DISABLED" ? true : appBundleTextList.trim().length !== 0)

        ) {

            if (
                countryListIsRequiredError === false &&
                deviceListIsRequiredError === false &&
                deviceBrandListIsRequiredError === false &&
                osListIsRequiredError === false &&
                browserListIsRequiredError === false
                && (ipListMode === "DISABLED" ? true : !ipListIsRequiredError)
                && (extendedUserListMode === "DISABLED" ? true : !extendedUserListIsRequiredError)
                && (appBundleListMode === "DISABLED" ? true : !appBundleListIsRequiredError)
                && (domainListMode === "DISABLED" ? true : !domainListIsRequiredError)
                && (siteIdListMode === "DISABLED" ? true : !siteIdListIsRequiredError)
                && (publisherIdListMode === "DISABLED" ? true : !publisherIdListIsRequiredError)
                && (appIdListMode === "DISABLED" ? true : !appIdListIsRequiredError)
                && (tagIdListMode === "DISABLED" ? true : !tagIdListIsRequiredError)
                && (appBundleTextListMode === "DISABLED" ? true : !appBundleTextListIsRequiredError)
                && (appBundleTextListMode === "DISABLED" ? true : !appBundleTextListValidError)

            ) {



                // let payload3 = {
                //     exCategories: excludedcategoryList,
                //     adxSensitiveCategories: sensitiveCategoryList,
                //     country: countryList,
                //     state: stateList,
                //     city: cityList,
                //     site_app_option: appSites,
                //     os: osList,
                //     browser: browserList,
                //     deviceBrands: deviceBrandList,
                //     deviceTypes: deviceList,
                //     nonEmptyDeviceID: checkbox_non_empty_device_id,
                //     iplist_option: ipListMode,
                //     ipList: ipList,
                //     domainlist_option: domainListMode,
                //     domainList: domainList,
                // extendedUsers_option: extendedUserListMode,
                // extendedUsers: extendedUserListMode === "DISABLED" ? [] : extendedUserList,
                // appBundle_option: appBundleListMode,
                // appBundle: appBundleListMode === "DISABLED" ? [] : appBundleList,
                //     siteIdList_option: siteIdListMode,
                //     sitelist: siteIdList,
                //     bundlelist_option: appBundleTextListMode,
                //     bundlelist: appBundleTextList,
                //     appIdList_option: appIdListMode,
                //     appIdList: appIdList,
                //     publisherlist_option: publisherIdListMode,
                //     publisherlist: publisherIdList,
                //     nonpublisherid: checkbox_non_empty_publisher_id,
                //     tagidlist_option: tagIdListMode,
                //     tagidlist: tagIdList,

                // }

                handleBackView(3);

            }
        } else {

            if (countryList.length === 0) {
                setCountryListIsRequiredError(true);
            }

            if (deviceList.length === 0) {
                setDeviceListIsRequiredError(true);
            }


            if (osList.length === 0) {
                setOsListIsRequiredError(true);
            }

            if (browserList.length === 0) {
                setBrowserListIsRequiredError(true);
            }

            if (deviceBrandList.length === 0) {
                setDeviceBrandListIsRequiredError(true);
            }

            if (ipListMode !== "DISABLED" && ipList.length === 0) {
                setIpListIsRequiredError(true)
            }

            if (extendedUserListMode !== "DISABLED" && extendedUserList.length === 0) {
                setExtendedUserListIsRequiredError(true)
            }

            if (appBundleListMode !== "DISABLED" && appBundleList.length === 0) {
                setAppBundleListIsRequiredError(true)
            }


            if (domainListMode !== "DISABLED" && domainList.length === 0) {
                setDomainListIsRequiredError(true)
            }


            if (siteIdListMode !== "DISABLED" && siteIdList?.trim().length === 0) {
                setSiteIdListIsRequiredError(true)
            }


            if (publisherIdListMode !== "DISABLED" && publisherIdList?.trim().length === 0) {
                setPublisherIdListIsRequiredError(true)
            }


            if (appIdListMode !== "DISABLED" && appIdList?.trim().length === 0) {
                setAppIdListIsRequiredError(true)
            }


            if (tagIdListMode !== "DISABLED" && tagIdList?.trim().length === 0) {
                setTagIdListIsRequiredError(true)
            }

            if (appBundleTextListMode !== "DISABLED" && appBundleTextList?.trim().length === 0) {
                setAppBundleTextListIsRequiredError(true)
            }



        }

    };



    // ---------------------------------------------------------------------------------------------------------------------------------------//
    // -----------------------------------------  Targeting Code Ends ---------------------------------------------------------------------------//
    // ---------------------------------------------------------------------------------------------------------------------------------------//




    //------------------------------------------------------------------------------------------------------------------------------------------------------//
    //------------------------------------------------------creative code starts ----------------------------------------------------------------------------//
    //-------------------------------------------------------------------------------------------------------------------------------------------------------//

    useEffect(() => {
        axios
            .get(configData.SERVER_URL + "ops/gam/bannerSizes", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setSizeOptions_html(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/bannerTemplates", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setTemplateOptions_html(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/ivbTemplates", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setTemplateOptions_ibv_html(response.data.data)

            })
            .catch((error) => { });

    }, [])


    //modal opening template  ------
    const [isTemplateModalOpen, setTemplateModalOpen] = useState(false);
    const [isDropdownOpenTemplate, setIsDropdownOpenTemplate] = useState(false); // Control dropdown open state

    const openTemplateModal = () => {
        setTemplateModalOpen(true);
        setIsDropdownOpenTemplate(false); // Close the Select dropdown
    };

    const closeTemplateModal = () => {
        setTemplateModalOpen(false);
        setNameTemplate_html("")
        setNameTemplate_htmlIsRequiredError(false)
        setTagTemplate_html("")
        setTagTemplate_htmlIsRequiredError(false)
    };



    const [nameTemplate_html, setNameTemplate_html] = useState("");
    const [nameTemplate_htmlIsRequiredError, setNameTemplate_htmlIsRequiredError] =
        useState(false);

    function onChangeNameTemplate_html(event) {
        setNameTemplate_htmlIsRequiredError(false);
        setNameTemplate_html(event.target.value);
    }

    function onBlurNameTemplate_html(event) {
        if (event.target.value.trim().length === 0) {
            setNameTemplate_htmlIsRequiredError(true);
        }
        setNameTemplate_html(event.target.value.trim());
    }

    const [tagTemplate_html, setTagTemplate_html] = useState("");
    const [tagTemplate_htmlIsRequiredError, setTagTemplate_htmlIsRequiredError] =
        useState(false);

    function onChangeTagTemplate_html(event) {
        setTagTemplate_htmlIsRequiredError(false);
        setTagTemplate_html(event.target.value);
    }

    function onBlurTagTemplate_html(event) {
        if (event.target.value.trim().length === 0) {
            setTagTemplate_htmlIsRequiredError(true);
        }
        setTagTemplate_html(event.target.value.trim());
    }

    function handleTemplateCreationValidation() {

        if (
            nameTemplate_html.trim().length !== 0 &&
            tagTemplate_html.trim().length !== 0
        ) {
            if (
                nameTemplate_htmlIsRequiredError === false &&
                tagTemplate_htmlIsRequiredError === false
            ) {

                let payload = {
                    name: nameTemplate_html.trim(),
                    template: tagTemplate_html.trim()
                }

                axios
                    .post(configData.SERVER_URL + `ops/gam/createTemplate`, payload, {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                    .then((response) => {
                        notifysuccess(response.data.message);

                        axios
                            .get(configData.SERVER_URL + "ops/gam/bannerTemplates", {
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            })
                            .then((response) => {
                                setTemplateOptions_html(response.data.data)

                            })
                            .catch((error) => { });

                        closeTemplateModal()
                    })
                    .catch((error) => {
                        if (error?.response) {
                            if (error.response.data.message?.length !== 0) {
                                notifyfailure(error.response.data.message);
                                // setButtonProcessing(false)
                            }
                        } else {
                            notifycatch();
                            // setButtonProcessing(false)
                        }

                    });


            }

        }
        else {

            if (nameTemplate_html.trim().length === 0) {
                setNameTemplate_htmlIsRequiredError(true);
            }

            if (tagTemplate_html.trim().length === 0) {
                setTagTemplate_htmlIsRequiredError(true);
            }

        }

    }

    //modal opening macros  ------
    const [isModalVisibleMacros, setIsModalVisibleMacros] = useState(false);
    const showModalMacros = () => {
        setIsModalVisibleMacros(true);
    };
    const closeModalMacros = () => {
        setIsModalVisibleMacros(false);
    };

    //modal opening creative code ------
    const [isModalCreativeVisible, setIsModalCreativeVisible] = useState(false);
    const [modalCreativeType, setModalCreativeType] = useState("");
    const [modalCreativeEditId, setModalCreativeEditId] = useState("");

    const showModalCreative = () => {
        setIsModalCreativeVisible(true);
    };

    const handleCancelCreativeModal = () => {
        setIsModalCreativeVisible(false);
        resetHtmlCreativeModal()
    };


    //creative table code 

    const [creativeMainTableColumnsBanner] = useState([
        {
            title: '',
            dataIndex: 'action',
            width: 50,
            render: (text, record) => (
                <div className='btn_group'>
                    <Tooltip title="Edit">
                        <button className='download_icon download_icon_d2'
                            onClick={() => { handleModalEditCloneFeature(record, "edit") }}
                        >
                            <img src={editIcon} alt='USP' />
                        </button>
                    </Tooltip>
                    <Tooltip title="Clone">
                        <button className='download_icon download_icon_d2'
                            onClick={() => { handleModalEditCloneFeature(record, "clone") }}
                        >
                            <img src={tablecopyIcon} alt='USP' />
                        </button>
                    </Tooltip>
                    {record.default === true ?
                        <button
                            className="download_icon download_icon_d2"
                            style={{ pointerEvents: "none" }}
                        >
                            <img src={DeleteIconDisabled} alt="Delete" />
                        </button>
                        :
                        <Tooltip title='Delete'>
                            <button className='download_icon download_icon_d2'
                                onClick={() => {

                                    setCreativeMainTableData((prevTableData) => {
                                        return prevTableData.filter(item => item.frontendId !== record.frontendId);
                                    });

                                }}
                            >
                                <img src={DeleteIcon} alt='Delete' />
                            </button>
                        </Tooltip>}
                </div >
            ),
        },

        {
            title: 'Status',
            dataIndex: 'isCreativeActive',
            key: 'isCreativeActive',
            width: 50,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text, record) => <div className='w_100 position-relative'>
                <div className="form_content_block--group">
                    <Switch checked={text}
                        onChange={(event) => {
                            setCreativeMainTableData((prevTableData) => {
                                return prevTableData.map(item => {
                                    if (item.frontendId === record.frontendId) {
                                        return { ...item, isCreativeActive: !item.isCreativeActive };
                                    }
                                    return item;
                                });
                            });

                        }} />
                </div>
            </div>
        },
        {
            title: 'Name',
            dataIndex: "name",
            key: "name",
            // width: 180,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: (a, b) => a.name.localeCompare(b.name),

            render: (text, record, index) => {
                if (record.default === true) {
                    return (
                        <div style={{ display: "flex", justifyContent: "space-between" }}>

                            <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className='text_dark_800 '>{record.creativeId ? <>{record.creativeId}-</> : <></>} {text.length > 120
                                ? <Tooltip title={record.creativeId ? `${record.creativeId}-${text}` : text}>{text.slice(0, 120)}...</Tooltip>
                                : text}</div>
                            <span style={{ color: "grey", fontStyle: "italic", paddingLeft: "5px" }}>(Default)</span>
                        </div>
                    )
                }
                else {
                    return (
                        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className='text_dark_800 '>{record.creativeId ? <>{record.creativeId}-</> : <></>} {text.length > 130
                            ? <Tooltip title={record.creativeId ? `${record.creativeId}-${text}` : text}> {text.slice(0, 130)}...</Tooltip>
                            : text}</div>
                    )

                }
            }
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            width: 90,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text) => <div className="text_dark_800">{text?.toUpperCase()}</div>,
        },
        {
            title: 'Size',
            dataIndex: 'creative',
            width: 90,
            key: 'creative?.size?.label',

            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text) => <div className="text_dark_800">{text?.size?.label}</div>,

        },


    ]);

    const [creativeMainTableColumnsIBV] = useState([
        {
            title: '',
            dataIndex: 'action',
            width: 80,
            render: (text, record) => (
                <div className='btn_group'>
                    <Tooltip title="Edit">
                        <button className='download_icon download_icon_d2'
                            onClick={() => { handleModalEditCloneFeature(record, "edit") }}
                        >
                            <img src={editIcon} alt='USP' />
                        </button>
                    </Tooltip>
                    <Tooltip title="Clone">
                        <button className='download_icon download_icon_d2'
                            onClick={() => { handleModalEditCloneFeature(record, "clone") }}
                        >
                            <img src={tablecopyIcon} alt='USP' />
                        </button>
                    </Tooltip>
                    {record.default === true ?
                        <button
                            className="download_icon download_icon_d2"
                            style={{ pointerEvents: "none" }}
                        >
                            <img src={DeleteIconDisabled} alt="Delete" />
                        </button>
                        :
                        <Tooltip title='Delete'>
                            <button
                                className="download_icon download_icon_d2"
                                onClick={() => {

                                    setCreativeMainTableData((prevTableData) =>
                                        prevTableData.filter((item) => item.frontendId !== record.frontendId)
                                    );

                                }}
                            >
                                <img src={DeleteIcon} alt="Delete" />
                            </button>
                        </Tooltip>}

                </div >
            ),
        },

        {
            title: 'Status',
            dataIndex: 'isCreativeActive',
            key: 'isCreativeActive',
            width: 50,
            // sortDirections: ['ascend', 'descend', 'ascend'],
            // sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text, record) => <div className='w_100 position-relative'>
                <div className="form_content_block--group">
                    <Switch checked={text}
                        onChange={(event) => {
                            setCreativeMainTableData((prevTableData) => {
                                return prevTableData.map(item => {
                                    if (item.frontendId === record.frontendId) {
                                        return { ...item, isCreativeActive: !item.isCreativeActive };
                                    }
                                    return item;
                                });
                            });

                        }} />
                </div>
            </div>
        },
        {
            title: 'Name',
            dataIndex: "name",
            key: "name",
            width: 300,
            // sortDirections: ['ascend', 'descend', 'ascend'],
            // sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text, record, index) => {
                if (record.default === true) {
                    return (
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className='text_dark_800 '>{record.creativeId ? <>{record.creativeId}-</> : <></>} {text.length > 36
                                ? <Tooltip title={record.creativeId ? `${record.creativeId}-${text}` : text}> {text.slice(0, 36)}...</Tooltip>
                                : text}</div>
                            <span style={{ color: "grey", fontStyle: "italic", paddingLeft: "5px" }}>(Default)</span>
                        </div>
                    )
                }
                else {
                    return (

                        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className='text_dark_800 '>{record.creativeId ? <>{record.creativeId}-</> : <></>} {text.length > 46
                            ? <Tooltip title={record.creativeId ? `${record.creativeId}-${text}` : text}>{text.slice(0, 46)}...</Tooltip>
                            : text}</div>

                    )

                }

            }
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            width: 70,
            // sortDirections: ['ascend', 'descend', 'ascend'],
            // sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text) => <div className="text_dark_800">{text?.toUpperCase()}</div>,
        },
        {
            title: 'Size',
            dataIndex: 'creative',
            width: 90,
            key: 'creative?.size?.label',

            // sortDirections: ['ascend', 'descend', 'ascend'],
            // sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text) => <div className="text_dark_800">{text?.size?.label}</div>,

        },
        {
            title: 'AdSource',
            width: 500,
            dataIndex: 'adSourceRefresh',
            key: 'adSourceRefresh',
            onCell: (record, index) => {
                return {
                    style: index === 0 ?
                        { borderLeft: "1px solid #f0f0f0", borderBottom: '0px' } :
                        !record.adSourceRefresh
                            ? { borderLeft: "1px solid #f0f0f0", borderBottom: '0px' }
                            : { borderTop: '1px solid #f0f0f0' },
                };
            },
            render: (text, record) => {

                if (!record.adSourceRefresh) {
                    return {
                        children:

                            record.default === true ? (
                                <div className='w_100 position-relative'>
                                    <div onClick={() => {
                                        setActiveCreativeIdModal_aniview(record.frontendId)
                                        setAdSourceRefreshIdModal_aniview(record.adSourceRefresh)
                                        if (record.adSource !== undefined) {
                                            if (Object.keys(record.adSource).length > 0) {
                                                setActiveAdSourceIdInModal_aniview(record.adSourceId !== undefined ? record.adSourceId : "")
                                                setProvider_aniview(record.adSource.provider_aniview !== undefined ? record.adSource.provider_aniview : "Google")
                                                setSourceType_aniview(record.adSource.sourceType_aniview !== undefined ? record.adSource.sourceType_aniview : "Platform Link")
                                                setAdvertiser_aniview(record.adSource.advertiser_aniview !== undefined ? record.adSource.advertiser_aniview : "GAM")
                                                setName_aniview(record.adSource.name_aniview !== undefined ? record.adSource.name_aniview : "")
                                                setStatus_aniview(record.adSource.status_aniview !== undefined ? record.adSource.status_aniview : 1)
                                                setOwnerType_aniview(record.adSource.ownerType_aniview !== undefined ? record.adSource.ownerType_aniview : 1)
                                                setEnvironment_aniview(record.adSource.environment_aniview !== undefined ? record.adSource.environment_aniview : 5)
                                                setECpm_aniview(record.adSource.eCpm_aniview !== undefined ? record.adSource.eCpm_aniview : "")
                                                setRevenueModel_aniview(record.adSource.revenueModel_aniview !== undefined ? record.adSource.revenueModel_aniview : 1)
                                            }
                                        }

                                        setModalShow_aniview(true)

                                    }}>
                                        {record.adSource && record.adSource?.name_aniview !== "" && record.adSource?.name_aniview !== undefined ?
                                            <div className='anchor_text_link_d2' style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} > {record.adSource?.name_aniview?.length > 100
                                                ? <Tooltip title={record.adSource?.name_aniview}> {record.adSource?.name_aniview?.slice(0, 100)}...</Tooltip>
                                                : record.adSource?.name_aniview}</div>



                                            :

                                            <button className="remote_plus_btn_d2"

                                            >

                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M8 3.33334V12.6667" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M3.3335 8H12.6668" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </button>
                                        }
                                    </div>
                                </div>
                            ) : null,
                        // props: { rowSpan: duplicates + 1 },
                    };
                } else {
                    return <div className='w_100 position-relative'>
                        <div onClick={() => {
                            setActiveCreativeIdModal_aniview(record.frontendId)
                            setAdSourceRefreshIdModal_aniview(record.adSourceRefresh)
                            if (record.adSource !== undefined) {
                                if (Object.keys(record.adSource).length > 0) {
                                    setActiveAdSourceIdInModal_aniview(record.adSourceId !== undefined ? record.adSourceId : "")
                                    setProvider_aniview(record.adSource.provider_aniview !== undefined ? record.adSource.provider_aniview : "Google")
                                    setSourceType_aniview(record.adSource.sourceType_aniview !== undefined ? record.adSource.sourceType_aniview : "Platform Link")
                                    setAdvertiser_aniview(record.adSource.advertiser_aniview !== undefined ? record.adSource.advertiser_aniview : "GAM")
                                    setName_aniview(record.adSource.name_aniview !== undefined ? record.adSource.name_aniview : "")
                                    setStatus_aniview(record.adSource.status_aniview !== undefined ? record.adSource.status_aniview : 1)
                                    setOwnerType_aniview(record.adSource.ownerType_aniview !== undefined ? record.adSource.ownerType_aniview : 1)
                                    setEnvironment_aniview(record.adSource.environment_aniview !== undefined ? record.adSource.environment_aniview : 5)
                                    setECpm_aniview(record.adSource.eCpm_aniview !== undefined ? record.adSource.eCpm_aniview : "")
                                    setRevenueModel_aniview(record.adSource.revenueModel_aniview !== undefined ? record.adSource.revenueModel_aniview : 1)
                                }
                            }

                            setModalShow_aniview(true)

                        }}>
                            {record.adSource && record.adSource?.name_aniview !== "" && record.adSource?.name_aniview !== undefined ?
                                <div className='anchor_text_link_d2' style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} > {record.adSource?.name_aniview?.length > 100
                                    ? <Tooltip title={record.adSource?.name_aniview}> {record.adSource?.name_aniview?.slice(0, 100)}...</Tooltip>
                                    : record.adSource?.name_aniview}</div>



                                :
                                <button className="remote_plus_btn_d2"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M8 3.33334V12.6667" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M3.3335 8H12.6668" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>

                            }
                        </div>
                    </div>
                }
            },
        },

    ]);

    const [creativeMainTableData, setCreativeMainTableData] = useState([]);

    const [creativeMainTableSearch, setCreativeMainTableSearch] = useState("")

    function handleCreativeMainTableSearch(event) {
        setCreativeMainTableSearch(event.target.value)
    }

    const filterDataCreativeMainTable = useMemo(() => {
        if (creativeMainTableSearch === "") {
            return creativeMainTableData?.sort((a, b) => {
                if (a.adSourceRefresh === b.adSourceRefresh) return 0;
                return a.adSourceRefresh ? 1 : -1; // `false` rows come before `true` rows
            })
        }
        else {
            return creativeMainTableData.filter(item => (item['name']?.toLowerCase().includes(creativeMainTableSearch.toLowerCase())))?.sort((a, b) => {
                if (a.adSourceRefresh === b.adSourceRefresh) return 0;
                return a.adSourceRefresh ? 1 : -1; // `false` rows come before `true` rows
            })
        }
    }, [creativeMainTableData, creativeMainTableSearch]);


    //modal adSourceRefresh code ------
    const [isModalVisibleAdSourceRefresh, setIsModalVisibleAdSourceRefresh] = useState(false)

    function modalOpenAdSourceRefresh() {
        setIsModalVisibleAdSourceRefresh(true)
    }

    function modalCloseAdSourceRefresh(data) {
        setIsModalVisibleAdSourceRefresh(false)
        setAdSourceRefresh(data)
        showModalCreative()
    }

    //modal creative code ------

    function resetHtmlCreativeModal() {
        setModalCreativeType("")
        setModalCreativeEditId("")
        setName_html("");
        setName_htmlIsRequiredError(false);

        setDestinationurl_html("");
        setDestinationurl_htmlValidError(false);

        setDomain_html("")
        setDomain_htmlIsRequiredError(false)
        setDomain_htmlValidError(false)

        setAppbundle_html("");
        setAppbundle_htmlCharError(false);
        setMsgNumberAppbundle("");

        setPosition_html(["Above the fold", "Below the fold", "Header", "Footer", "Sidebar", "Fullscreen"]);
        setPositionIsRequiredError_html(false)
        setSearchPosition_html('');
        setInterstitial_html(false);
        setAttribute_html([]);
        setSearchAttribute_html('');

        setImpressionpixel_html("");
        setImpressionpixel_htmlValidError(false);
        setImpressionpixel_htmlCharError(false);
        setMsgNumberImpression("");

        setJstracker_html("");
        setJstracker_htmlValidError(false);
        setJstracker_htmlCharError(false);
        setMsgNumberJstracker("");

        setSize_html("");
        setSize_htmlIsRequiredError(false);

        setThirdparty_html(true);
        setTemplate_html("");
        setTemplate_htmlIsRequiredError(false);

        setText_html("");
        setText_htmlIsRequiredError(false);
        setText_htmlValidError(false);

        setBundleList_htmlMode("DISABLED");
        setBundleList_html("");
        setBundleList_html_IsRequiredError(false);
        setBundleList_html_Error(false);

        setDomainList_htmlMode("DISABLED");
        setDomainList_html("");
        setDomainList_html_IsRequiredError(false);
        setDomainList_html_Error(false);
    }

    function handleModalEditCloneFeature(record, type) {
        setModalCreativeType(type)
        setModalCreativeEditId(record.frontendId)
        setName_html(record.name);
        setDestinationurl_html(record.destinationurl);
        setDomain_html(record.domain)
        setAppbundle_html(record.appbundle);
        setPosition_html(record.position);
        setInterstitial_html(record.interstitial);
        setAttribute_html(record.attributeList);
        setImpressionpixel_html(record.impressionpixel);
        setJstracker_html(record.jstracker);
        setSize_html(record.creative?.size?.value);
        setThirdparty_html(record.thirdparty);
        setTemplate_html(record.template?.value);
        setText_html(record.creative.preview);
        setBundleList_htmlMode(record.bundleListOption);
        setBundleList_html(record.bundleList);
        setDomainList_htmlMode(record.domainListOption);
        setDomainList_html(record.domainList);

        if (type === "edit") {
            showModalCreative()
        }
        else {
            modalOpenAdSourceRefresh()
        }
    }

    const [adSourceRefresh, setAdSourceRefresh] = useState(false);
    const [creativeType] = useState("html");
    const [creativeTypeOptions] = useState([{ label: "HTML", value: "html" }]);


    const regex = /^(https?|HTTPS?):\/\/[^\s/$.?#].[^\s]*$/;
    const regexHttps = /^https:\/\/[^\s/$.?#].[^\s]*$/;
    const regexDomain = /.+[.].+/;
    const regexBundle = /^[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*$/;

    const [name_html, setName_html] = useState("");
    const [name_htmlIsRequiredError, setName_htmlIsRequiredError] =
        useState(false);

    function onChangeName_html(event) {
        setName_htmlIsRequiredError(false);
        setName_html(event.target.value);
    }

    function onBlurName_html(event) {
        if (event.target.value.trim().length === 0) {
            setName_htmlIsRequiredError(true);
        }
        setName_html(event.target.value.trim());
    }

    const [destinationurl_html, setDestinationurl_html] = useState("");
    const [
        destinationurl_htmlIsRequiredError,
        setDestinationurl_htmlIsRequiredError,
    ] = useState(false);
    const [destinationurl_htmlValidError, setDestinationurl_htmlValidError] =
        useState(false);

    function onChangeDestinationurl_html(event) {
        if (event.target.value.length === 0) {
            setDestinationurl_htmlValidError(false);
            setDestinationurl_htmlIsRequiredError(true)

        } else {
            setDestinationurl_htmlIsRequiredError(false)

            if (!regex.test(event.target.value)) {
                setDestinationurl_htmlValidError(true);
            } else {
                setDestinationurl_htmlValidError(false);
            }
        }

        setDestinationurl_html(event.target.value);
    }

    function onBlurDestinationurl_html(event) {
        if (event.target.value.trim().length === 0) {
            setDestinationurl_htmlValidError(false);
            setDestinationurl_htmlIsRequiredError(true)
        }
        setDestinationurl_html(event.target.value.trim())
    }



    const [domain_html, setDomain_html] = useState("");
    const [domain_html_ViaCategory, setDomain_html_ViaCategory] = useState("");
    const [domain_htmlIsRequiredError, setDomain_htmlIsRequiredError] =
        useState(false);
    const [domain_htmlValidError, setDomain_htmlValidError] =
        useState(false);


    function validateUrlsDomain(urls) {
        const urlsArr = urls.split(",");
        for (let i = 0; i < urlsArr.length; i++) {
            if (!regexDomain.test(urlsArr[i].trim())) {
                return false;
            }
        }
        return true;
    }


    function onChangeDomain_html(event) {
        setDomain_htmlValidError(false);

        if (event.target.value === "") {
            setDomain_htmlIsRequiredError(true)
        }
        else {
            setDomain_htmlIsRequiredError(false);
        }

        setDomain_html(event.target.value);
    }

    function onBlurDomain_html(event) {
        if (event.target.value.trim().length === 0) {
            setDomain_htmlValidError(false);
            setDomain_htmlIsRequiredError(true);
        } else {
            setDomain_htmlIsRequiredError(false);
            setDomain_htmlValidError(
                !validateUrlsDomain(domain_html)
            );
        }



        setDomain_html(event.target.value.trim())
    }


    const [appbundle_html, setAppbundle_html] = useState("");
    const [appbundle_htmlCharError, setAppbundle_htmlCharError] = useState(false);

    const [MsgNumberAppbundle, setMsgNumberAppbundle] = useState("");

    function calculateTotalCharactersAppbundle(data) {
        let totalCharacters = data.length;
        if (totalCharacters > 255) {
            setMsgNumberAppbundle(255);
            return true;
        } else {
            setMsgNumberAppbundle("");
            return false;
        }

    }

    function onChangeAppbundle_html(event) {
        setAppbundle_htmlCharError(false);
        setAppbundle_html(event.target.value);
    }

    function onBlurAppbundle_html(event) {
        if (calculateTotalCharactersAppbundle(event.target.value.trim())) {
            setAppbundle_htmlCharError(true);
        } else {
            setAppbundle_htmlCharError(false);
        }

        setAppbundle_html(event.target.value.trim());
    }

    const [position_html, setPosition_html] = useState(["Above the fold", "Below the fold", "Header", "Footer", "Sidebar", "Fullscreen"]);
    const [positionIsRequiredError_html, setPositionIsRequiredError_html] = useState(false);
    const [position_htmlOptions] = useState(constantData.Position_Html);



    const [searchPosition_html, setSearchPosition_html] = useState('');

    const handleSearchPosition_html = (e) => {
        setSearchPosition_html(e.target.value.toLowerCase());
    };

    const filterPosition_html = position_htmlOptions?.filter(option =>
        option.label?.toLowerCase()?.includes(searchPosition_html)
    );

    function handleSelectAllPosition_html() {
        const allValues = position_htmlOptions?.map(option => option.value);
        let tempPosition_html = [];
        if (position_html?.length !== position_htmlOptions?.length) {
            tempPosition_html = [...allValues];
        } else {
            tempPosition_html = [];
        }

        if (tempPosition_html?.length === 0) {
            setPositionIsRequiredError_html(true)
        }
        else {
            setPositionIsRequiredError_html(false)
        }

        setPosition_html(tempPosition_html);
    }



    function handlePosition_html(value) {
        let tempPosition_html = [...position_html]

        let newValue = [];
        if (tempPosition_html?.includes(value)) {
            newValue = tempPosition_html.filter((item) => item !== value);
        } else {
            newValue = [...tempPosition_html, value];
        }
        tempPosition_html = newValue

        if (tempPosition_html?.length === 0) {
            setPositionIsRequiredError_html(true)
        }
        else {
            setPositionIsRequiredError_html(false)
        }

        setPosition_html(tempPosition_html)

    }


    const [attribute_html, setAttribute_html] = useState([]);
    const [attribute_htmlOptions] = useState(constantData.Attribute_Html);



    const [searchAttribute_html, setSearchAttribute_html] = useState('');

    const handleSearchAttribute_html = (e) => {
        setSearchAttribute_html(e.target.value.toLowerCase());
    };

    const filterAttribute_html = attribute_htmlOptions?.filter(option =>
        option.label?.toLowerCase()?.includes(searchAttribute_html)
    );

    function handleSelectAllAttribute_html() {
        const allValues = attribute_htmlOptions?.map(option => option.value);
        let tempAttribute_html = [];
        if (attribute_html?.length !== attribute_htmlOptions?.length) {
            tempAttribute_html = [...allValues];
        } else {
            tempAttribute_html = [];
        }

        setAttribute_html(tempAttribute_html);
    }



    function handleAttribute_html(value) {
        let tempAttribute_html = [...attribute_html]

        let newValue = [];
        if (tempAttribute_html?.includes(value)) {
            newValue = tempAttribute_html.filter((item) => item !== value);
        } else {
            newValue = [...tempAttribute_html, value];
        }
        tempAttribute_html = newValue

        setAttribute_html(tempAttribute_html)

    }



    const [impressionpixel_html, setImpressionpixel_html] = useState("");
    const [impressionpixel_htmlValidError, setImpressionpixel_htmlValidError] =
        useState(false);
    const [impressionpixel_htmlCharError, setImpressionpixel_htmlCharError] =
        useState(false);

    function validateUrlsImpressionTracker(urls) {
        const urlsArr = urls.split("\n");
        for (let i = 0; i < urlsArr.length; i++) {
            if (!regexHttps.test(urlsArr[i].trim())) {
                return false;
            }
        }
        return true;
    }

    const [MsgNumberImpression, setMsgNumberImpression] = useState("");
    function calculateTotalCharactersImpression(data) {
        let totalCharacters = data.length;
        if (totalCharacters > 1000) {
            setMsgNumberImpression(1000);
            return true;
        } else {
            setMsgNumberImpression("");
            return false;
        }

    }
    function onChangeImpressionpixel_html(event) {
        setImpressionpixel_htmlValidError(false);
        setImpressionpixel_htmlCharError(false);
        setImpressionpixel_html(event.target.value);
    }

    function onBlurImpressionpixel_html(event) {
        if (event.target.value.trim().length === 0) {
            setImpressionpixel_htmlValidError(false);
        } else {
            setImpressionpixel_htmlValidError(
                !validateUrlsImpressionTracker(impressionpixel_html.trim())
            );
        }

        if (calculateTotalCharactersImpression(event.target.value.trim())) {
            setImpressionpixel_htmlCharError(true);
        } else {
            setImpressionpixel_htmlCharError(false);
        }

        setImpressionpixel_html(event.target.value.trim())
    }


    const [jstracker_html, setJstracker_html] = useState("");
    const [jstracker_htmlValidError, setJstracker_htmlValidError] =
        useState(false);
    const [jstracker_htmlCharError, setJstracker_htmlCharError] =
        useState(false);

    const [MsgNumberJstracker, setMsgNumberJstracker] = useState("");
    function calculateTotalCharactersJstracker(data) {
        let totalCharacters = data.length;
        if (totalCharacters > 1000) {
            setMsgNumberJstracker(1000);
            return true;
        } else {
            setMsgNumberJstracker("");
            return false;
        }

    }
    function onChangeJstracker_html(event) {
        setJstracker_htmlValidError(false);
        setJstracker_htmlCharError(false);
        setJstracker_html(event.target.value);
    }

    function onBlurJstracker_html(event) {
        if (event.target.value.trim().length === 0) {
            setJstracker_htmlValidError(false);
        } else {
            setJstracker_htmlValidError(
                !validateUrlsImpressionTracker(jstracker_html.trim())
            );
        }

        if (calculateTotalCharactersJstracker(event.target.value.trim())) {
            setJstracker_htmlCharError(true);
        } else {
            setJstracker_htmlCharError(false);
        }

        setJstracker_html(event.target.value.trim())
    }

    const [size_html, setSize_html] = useState("");
    const [size_htmlIsRequiredError, setSize_htmlIsRequiredError] = useState(false);
    const [sizeOptions_html, setSizeOptions_html] = useState([]);

    function onChangeSize_html(event) {
        setSize_htmlIsRequiredError(false)
        setSize_html(event);
    }


    const [template_html, setTemplate_html] = useState("");
    const [template_htmlIsRequiredError, setTemplate_htmlIsRequiredError] = useState(false);
    const [templateOptions_html, setTemplateOptions_html] = useState([]);
    const [templateOptions_ibv_html, setTemplateOptions_ibv_html] = useState([]);

    function onChangeTemplate_html(event) {
        setTemplate_htmlIsRequiredError(false)
        setTemplate_html(event);

        let selectedTemplate
        if (campaignType === "IBV") {
            selectedTemplate = templateOptions_ibv_html?.find(
                (template) => template.value === event
            );
        }
        else {
            selectedTemplate = templateOptions_html?.find(
                (template) => template.value === event
            );
        }

        setText_htmlIsRequiredError(false)
        setText_html(selectedTemplate?.template)
    }


    const [interstitial_html, setInterstitial_html] = useState(false);
    function onChangeInterstitial_html(event) {
        setInterstitial_html(event.target.checked);
    }


    const [thirdparty_html, setThirdparty_html] = useState(true);
    function onChangeThirdparty_html(event) {
        setThirdparty_html(event.target.checked);
    }

    // const [secure_html, setSecure_html] = useState(false);
    // function onChangeSecure_html(event) {
    //     setSecure_html(event.target.checked);
    // }


    const regexScript = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
    const [text_html, setText_html] = useState("");
    const [text_htmlIsRequiredError, setText_htmlIsRequiredError] =
        useState(false);
    const [text_htmlValidError, setText_htmlValidError] = useState(false);

    function onChangeText_html(event) {
        if (event.target.value.length === 0) {
            setText_htmlValidError(false);
            setText_htmlIsRequiredError(true);
        } else {
            setText_htmlIsRequiredError(false);

            if (!regexScript.test(event.target.value) && !event.target.value?.toLowerCase().includes("iframe")) {
                setText_htmlValidError(true);
            } else {
                setText_htmlValidError(false);
            }
        }

        setText_html(event.target.value);
    }

    function onBlurText_html(event) {
        if (event.target.value.trim().length === 0) {
            setText_htmlValidError(false);
            setText_htmlIsRequiredError(true);
        }

        setText_html(event.target.value.trim())
    }


    //bundlelist

    const [bundleList_htmlMode, setBundleList_htmlMode] = useState("DISABLED");
    const [bundleList_htmlModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeBundleList_htmlMode(event) {
        setBundleList_htmlMode(event);
    };

    // function validateUrlsBundleList(urls) { // duplicate — defined earlier
    //     const urlsArr = urls.trim().split("\n");
    //     for (let i = 0; i < urlsArr.length; i++) {
    //         if (isNaN(urlsArr[i])) {
    //             if (!regexBundle.test(urlsArr[i])) {
    //                 return false;
    //             }
    //         }
    //     }
    //     return true;
    // }


    const [bundleList_html, setBundleList_html] = useState("");
    const [bundleList_html_IsRequiredError, setBundleList_html_IsRequiredError] = useState(false);
    const [bundleList_html_Error, setBundleList_html_Error] = useState(false);

    function onChangeBundleList_html(event) {
        setBundleList_html_IsRequiredError(false)
        setBundleList_html_Error(false)
        setBundleList_html(event.target.value);
    }

    function onBlurBundleList_html(event) {
        if (bundleList_htmlMode !== "DISABLED" && event.target.value.trim().length === 0) {
            setBundleList_html_Error(false)
            setBundleList_html_IsRequiredError(true)
        }
        else if (bundleList_htmlMode !== "DISABLED" && event.target.value.trim().length !== 0) {
            setBundleList_html_Error(!validateUrlsBundleList(event.target.value.trim()));
        }
        setBundleList_html(event.target.value.trim());
    }


    //domain


    const [domainList_htmlMode, setDomainList_htmlMode] = useState("DISABLED");
    const [domainList_htmlModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeDomainList_htmlMode(event) {
        setDomainList_htmlMode(event);
    };

    function validateUrlsDomainList(urls) {
        const urlsArr = urls.trim().split("\n");
        for (let i = 0; i < urlsArr.length; i++) {
            if (isNaN(urlsArr[i])) {
                if (!regexDomain.test(urlsArr[i])) {
                    return false;
                }
            }
        }
        return true;
    }

    const [domainList_html, setDomainList_html] = useState("");
    const [domainList_html_IsRequiredError, setDomainList_html_IsRequiredError] = useState(false);
    const [domainList_html_Error, setDomainList_html_Error] = useState(false);

    function onChangeDomainList_html(event) {
        setDomainList_html_IsRequiredError(false)
        setDomainList_html_Error(false)
        setDomainList_html(event.target.value);
    }

    function onBlurDomainList_html(event) {
        if (domainList_htmlMode !== "DISABLED" && event.target.value.trim().length === 0) {
            setDomainList_html_Error(false)
            setDomainList_html_IsRequiredError(true)
        }
        else if (domainList_htmlMode !== "DISABLED" && event.target.value.trim().length !== 0) {
            setDomainList_html_Error(!validateUrlsDomainList(event.target.value.trim()));
        }
        setDomainList_html(event.target.value.trim());

    }


    const creativeNameRef = useRef(null)
    const creativeDomainListRef = useRef(null)
    const creativeImpressionRef = useRef(null)

    const errorDetectCreative = () => {

        if (name_htmlIsRequiredError || name_html.trim().length === 0 || (!thirdparty_html && destinationurl_htmlValidError) || (!thirdparty_html && destinationurl_html?.trim() === "")) {
            scrollToItem(creativeNameRef);
            return
        }

        if (appbundle_htmlCharError || domain_htmlIsRequiredError || domain_htmlValidError || domain_html.trim() === "") {
            scrollToItem(creativeDomainListRef);
            return
        }


        if (position_html.length === 0 || positionIsRequiredError_html) {
            scrollToItem(creativeDomainListRef);
            return
        }


        if (impressionpixel_htmlValidError || impressionpixel_htmlCharError || jstracker_htmlCharError || jstracker_htmlValidError) {
            scrollToItem(creativeImpressionRef);
            return
        }
    }


    function handleCreativeValidations() {
        errorDetectCreative()
        if (
            name_html.trim() !== "" &&
            (thirdparty_html ? true : destinationurl_html.trim() !== "") &&
            domain_html.trim() !== "" &&
            position_html.length !== 0 &&
            size_html.length !== 0 &&
            text_html.trim() !== "" &&
            template_html.length !== 0
            && (bundleList_htmlMode === "DISABLED" ? true : bundleList_html?.trim().length !== 0)
            && (domainList_htmlMode === "DISABLED" ? true : domainList_html?.trim().length !== 0)
        ) {
            if (
                name_htmlIsRequiredError === false &&
                size_htmlIsRequiredError === false &&
                text_htmlIsRequiredError === false &&
                text_htmlValidError === false &&
                (thirdparty_html ? true : destinationurl_htmlIsRequiredError === false) &&
                (thirdparty_html ? true : destinationurl_htmlValidError === false) &&
                domain_htmlIsRequiredError === false &&
                domain_htmlValidError === false &&
                appbundle_htmlCharError === false &&
                impressionpixel_htmlValidError === false &&
                impressionpixel_htmlCharError === false &&
                jstracker_htmlCharError === false &&
                jstracker_htmlValidError === false &&
                template_htmlIsRequiredError === false &&
                positionIsRequiredError_html === false
                && (bundleList_htmlMode === "DISABLED" ? true : !bundleList_html_IsRequiredError)
                && (bundleList_htmlMode === "DISABLED" ? true : !bundleList_html_Error)
                && (domainList_htmlMode === "DISABLED" ? true : !domainList_html_IsRequiredError)
                && (domainList_htmlMode === "DISABLED" ? true : !domainList_html_Error)

            ) {

                if (modalCreativeType === "edit") {
                    setCreativeMainTableData((prevTableData) => {
                        return prevTableData.map(item => {
                            if (item.frontendId === Number(modalCreativeEditId)) {

                                return {
                                    ...item,
                                    type: creativeType,
                                    name: name_html?.trim(),
                                    destinationurl: thirdparty_html ? "" : destinationurl_html,
                                    domain: domain_html,
                                    appbundle: appbundle_html?.trim(),
                                    interstitial: interstitial_html,
                                    thirdparty: thirdparty_html,
                                    position: position_html,
                                    attributeList: attribute_html,
                                    impressionpixel: impressionpixel_html?.trim(),
                                    jstracker: jstracker_html?.trim(),
                                    bundleListOption: bundleList_htmlMode,
                                    bundleList: bundleList_htmlMode === "DISABLED" ? [] : bundleList_html?.trim(),
                                    domainListOption: domainList_htmlMode,
                                    domainList: domainList_htmlMode === "DISABLED" ? [] : domainList_html?.trim(),
                                    template: campaignType === "IBV" ? templateOptions_ibv_html?.find(item => item.value === template_html) : templateOptions_html?.find(item => item.value === template_html),
                                    // isCreativeActive: true,
                                    creative: {
                                        file: text_html?.trim(),
                                        preview: text_html?.trim(),
                                        filename: name_html?.trim(),
                                        size: sizeOptions_html?.find(item => item.value === size_html),
                                        type: creativeType
                                    }
                                };
                            }
                            return item;
                        });
                    });
                }
                else {


                    let tempTableArray = [...creativeMainTableData];

                    if (campaignType === "IBV" && modalCreativeType !== "create" && !adSourceRefresh) {
                        tempTableArray.push({

                            frontendId: Math.floor(Math.random() * 9000) + 1000,
                            type: creativeType,
                            name: name_html?.trim(),
                            destinationurl: thirdparty_html ? "" : destinationurl_html,
                            domain: domain_html,
                            appbundle: appbundle_html?.trim(),
                            interstitial: interstitial_html,
                            thirdparty: thirdparty_html,
                            position: position_html,
                            attributeList: attribute_html,
                            default: creativeMainTableData.length === 0 ? true : false,
                            impressionpixel: impressionpixel_html?.trim(),
                            jstracker: jstracker_html?.trim(),
                            bundleListOption: bundleList_htmlMode,
                            bundleList: bundleList_htmlMode === "DISABLED" ? [] : bundleList_html?.trim(),
                            domainListOption: domainList_htmlMode,
                            domainList: domainList_htmlMode === "DISABLED" ? [] : domainList_html?.trim(),
                            template: campaignType === "IBV" ? templateOptions_ibv_html?.find(item => item.value === template_html) : templateOptions_html?.find(item => item.value === template_html),
                            isCreativeActive: true,
                            adSourceRefresh: modalCreativeType === "create" ? false : adSourceRefresh,
                            adSource: creativeMainTableData[0].adSource,
                            creative: {
                                file: text_html?.trim(),
                                preview: text_html?.trim(),
                                filename: name_html?.trim(),
                                size: sizeOptions_html?.find(item => item.value === size_html),
                                type: creativeType,
                            }
                        })
                    }
                    else {
                        tempTableArray.push({

                            frontendId: Math.floor(Math.random() * 9000) + 1000,
                            type: creativeType,
                            name: name_html?.trim(),
                            destinationurl: thirdparty_html ? "" : destinationurl_html,
                            domain: domain_html,
                            appbundle: appbundle_html?.trim(),
                            interstitial: interstitial_html,
                            thirdparty: thirdparty_html,
                            position: position_html,
                            attributeList: attribute_html,
                            default: creativeMainTableData.length === 0 ? true : false,
                            impressionpixel: impressionpixel_html?.trim(),
                            jstracker: jstracker_html?.trim(),
                            bundleListOption: bundleList_htmlMode,
                            bundleList: bundleList_htmlMode === "DISABLED" ? [] : bundleList_html?.trim(),
                            domainListOption: domainList_htmlMode,
                            domainList: domainList_htmlMode === "DISABLED" ? [] : domainList_html?.trim(),
                            template: campaignType === "IBV" ? templateOptions_ibv_html?.find(item => item.value === template_html) : templateOptions_html?.find(item => item.value === template_html),
                            isCreativeActive: true,
                            adSourceRefresh: modalCreativeType === "create" ? false : adSourceRefresh,
                            creative: {
                                file: text_html?.trim(),
                                preview: text_html?.trim(),
                                filename: name_html?.trim(),
                                size: sizeOptions_html?.find(item => item.value === size_html),
                                type: creativeType,
                            }
                        })
                    }

                    setCreativeMainTableData(tempTableArray);
                }


                handleCancelCreativeModal()

            }
        } else {
            if (name_html.trim() === "") {
                setName_htmlIsRequiredError(true);
            }
            if (!thirdparty_html && destinationurl_html.trim() === "") {
                setDestinationurl_htmlIsRequiredError(true)
            }
            if (domain_html.trim() === "") {
                setDomain_htmlIsRequiredError(true)
            }
            if (size_html.length === 0) {
                setSize_htmlIsRequiredError(true);
            }


            if (position_html.length === 0) {
                setPositionIsRequiredError_html(true);
            }

            if (text_html.trim() === "") {
                setText_htmlIsRequiredError(true);
            }

            if (template_html.length === 0) {
                setTemplate_htmlIsRequiredError(true);
            }

            if (bundleList_htmlMode !== "DISABLED" && bundleList_html?.trim().length === 0) {
                setBundleList_html_IsRequiredError(true)
            }

            if (domainList_htmlMode !== "DISABLED" && domainList_html?.trim().length === 0) {
                setDomainList_html_IsRequiredError(true)
            }
        }
    }



    // function handleCreativeValidations_aniview() {
    //     if (creativeMainTableData.length > 0) {
    //         setTabView(4)
    //     }
    //     else {
    //         notifyfailure("Minimum 1 creative is required")
    //     }
    // }




    //------------------------------------------------------------------------------------------------------------------------------------------------------//
    //------------------------------------------------------creative code ends ----------------------------------------------------------------------------//
    //-------------------------------------------------------------------------------------------------------------------------------------------------------//

    // -----------------------------------------------------------------------------------------------------------------------//
    // ---------------------------------Aniview form related code starts ---------------- -------------------------------------//
    // -----------------------------------------------------------------------------------------------------------------------//
    const [modalShow_aniView, setModalShow_aniview] = useState(false)

    function handleHideModal_aniview() {
        setModalShow_aniview(false)
        resetFormData_aniview()
    }

    const [activeCreativeIdInModal_aniview, setActiveCreativeIdModal_aniview] = useState(null)
    const [/* activeAdSourceIdInModal_aniview */, setActiveAdSourceIdInModal_aniview] = useState("")
    const [activeAdSourceRefreshInModal_aniview, setAdSourceRefreshIdModal_aniview] = useState(false)

    function resetFormData_aniview() {
        setActiveCreativeIdModal_aniview(null)
        setActiveAdSourceIdInModal_aniview("")
        setAdSourceRefreshIdModal_aniview(false)
        setProvider_aniview("Google")
        setSourceType_aniview("Platform Link")
        setAdvertiser_aniview("GAM")
        setName_aniview(nameDependOnPublisher_aniview);
        setName_aniviewIsRequiredError(false);
        setOwnerType_aniview(1)
        setStatus_aniview(1)
        setEnvironment_aniview(5)
        setECpm_aniview("");
        setECpmIsRequiredError_aniview(false);
        setECpmValidError_aniview(false);
        setGrossRate_aniview("0")
        setGrossRate_aniviewIsRequiredError(false)
        setRevenueModel_aniview(1)
    }


    const [provider_aniview, setProvider_aniview] = useState("Google")
    const [providerOptions_aniview] = useState([{ label: "Google", value: "Google" }])

    const [nameDependOnPublisher_aniview, setNameDependOnPublisher_aniview] = useState("");
    const [name_aniview, setName_aniview] = useState("");
    const [name_aniviewIsRequiredError, setName_aniviewIsRequiredError] = useState(false);

    function onChangeName_aniview(event) {
        setName_aniviewIsRequiredError(false);
        setName_aniview(event.target.value);

        if (event.target.value.trim().length === 0) {
            setName_aniviewIsRequiredError(true)
        }

        else {
            setName_aniviewIsRequiredError(false)
        }
    }



    function onBlurName_aniview(event) {
        setName_aniview(event.target.value.trim())
        if (event.target.value.trim().length === 0) {
            setName_aniviewIsRequiredError(true)
        }

        else {
            setName_aniviewIsRequiredError(false)
        }
    }



    const [advertiser_aniview, setAdvertiser_aniview] = useState("GAM")
    const [advertiserOptions_aniview] = useState([{ label: "GAM", value: "GAM" }])


    const [sourceType_aniview, setSourceType_aniview] = useState("Platform Link")
    const [sourceTypeOptions_aniview] = useState([{ label: "Platform Link", value: "Platform Link" }])



    const [status_aniview, setStatus_aniview] = useState(1)
    const [statusOptions_aniview] = useState([{ label: "Active", value: 1 }, { label: "Pending", value: 0 }])

    function onChangeStatus_aniview(event) {
        setStatus_aniview(event)
    }





    const [ownerType_aniview, setOwnerType_aniview] = useState(1)
    const [ownerTypeOptions_aniview] = useState([{ label: "Network", value: 1 }, { label: "Publisher", value: 2 }, { label: "App/site", value: 3 }])

    function onChangeOwnerType_aniview(event) {
        setOwnerType_aniview(event)
    }



    const [environment_aniview, setEnvironment_aniview] = useState(5)
    const [environmentOptions_aniview] = useState([{ label: "InApp/CTV", value: 6 }, { label: "Web", value: 5 }, { label: "Mobile Web", value: 1 }, { label: "Desktop", value: 2 }, { label: "In App", value: 3 }, { label: "CTV", value: 4 }])

    function onChangeEnvironment_aniview(event) {
        setEnvironment_aniview(event)
    }

    const [eCpmDisabled_aniview, setECpmDisabled_aniview] = useState("");
    const [eCpm_aniview, setECpm_aniview] = useState("");
    const [eCpmIsRequiredError_aniview, setECpmIsRequiredError_aniview] = useState("");
    const [eCpmValidError_aniview, setECpmValidError_aniview] = useState("");


    function onChangeECpm_aniview(event) {
        setECpmIsRequiredError_aniview(false);
        if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
            setECpm_aniview(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_aniview(false)
            }
            else {
                setECpmValidError_aniview(true)
            }
        }
    }

    function onBlurECpm_aniview(event) {
        if (event.target.value.trim().length === 0) {
            setECpmValidError_aniview(false);
            setECpmIsRequiredError_aniview(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_aniview(false);
            } else {
                setECpmIsRequiredError_aniview(false);
                setECpmValidError_aniview(true);
            }
        }
        setECpm_aniview(event.target.value.trim());
    }


    const [grossRate_aniview, setGrossRate_aniview] = useState("0")
    const [grossRate_aniviewIsRequiredError, setGrossRate_aniviewIsRequiredError] = useState(false)

    function onChangeGrossRate_aniview(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setGrossRate_aniview(event.target.value.trim())
            if (event.target.value.trim().length !== 0) {
                setGrossRate_aniviewIsRequiredError(false)
            }
        }



        if (event.target.value.trim().length === 0) {
            setGrossRate_aniviewIsRequiredError(true)
        }
    }


    const [revenueModel_aniview, setRevenueModel_aniview] = useState(1)
    const [revenueModelOptions_aniview] = useState([{ label: "Impression (CPM)", value: 1 }, { label: "Win (PreBid)", value: 2 }, { label: "Click (CPC)", value: 3 }, { label: "Lead (CPL)", value: 4 }, { label: "Install (CPI)", value: 5 }, { label: "Action/Sale (CPA)", value: 6 }, { label: "Complete (CPCV)", value: 7 }])

    function onChangeRevenueModel_aniview(event) {
        setRevenueModel_aniview(event)
    }


    const name_aniview_Ref = useRef(null)

    const errorDetectAniview = () => {
        if (name_aniview.trim() === "" || name_aniviewIsRequiredError) {
            scrollToItem(name_aniview_Ref);
            return
        }
    }

    const handleAniviewValidations = () => {
        errorDetectAniview()


        if (
            name_aniview.trim() !== ""
            // &&
            // grossRate_aniview.trim() !== "" 
            &&
            (activeAdSourceRefreshInModal_aniview ? true : eCpm_aniview !== "")

        ) {

            if (
                name_aniviewIsRequiredError === false &&
                // grossRate_aniviewIsRequiredError === false &&
                (activeAdSourceRefreshInModal_aniview ? true : eCpmIsRequiredError_aniview === false) &&
                (activeAdSourceRefreshInModal_aniview ? true : eCpmValidError_aniview === false)

            ) {


                // const result = creativeMainTableData.find(item => item.frontendId === activeCreativeIdInModal_aniview)

                // handleFinalPayload()
                let updatedArray
                if (!activeAdSourceRefreshInModal_aniview) {
                    setECpmDisabled_aniview(eCpm_aniview)
                    updatedArray = creativeMainTableData.map(item =>
                        item.adSourceRefresh === false
                            ? {
                                ...item,
                                adSource: {
                                    ...item.adSource,
                                    provider_aniview: provider_aniview,
                                    demandPublisher_aniview: publisher,
                                    name_aniview: name_aniview,
                                    advertiser_aniview: advertiser_aniview,
                                    sourceType_aniview: sourceType_aniview,
                                    status_aniview: status_aniview,
                                    ownertype_aniview: ownerType_aniview,
                                    environment_aniview: environment_aniview,
                                    eCpm_aniview: eCpm_aniview,
                                    grossRate_aniview: grossRate_aniview,
                                    revenueModel_aniview: revenueModel_aniview
                                }
                            }
                            : item

                    );
                }
                else {
                    updatedArray = creativeMainTableData.map(item =>
                        item.frontendId === activeCreativeIdInModal_aniview
                            ? {
                                ...item,
                                adSource: {
                                    ...item.adSource,
                                    provider_aniview: provider_aniview,
                                    demandPublisher_aniview: publisher,
                                    name_aniview: name_aniview,
                                    advertiser_aniview: advertiser_aniview,
                                    sourceType_aniview: sourceType_aniview,
                                    status_aniview: status_aniview,
                                    ownertype_aniview: ownerType_aniview,
                                    environment_aniview: environment_aniview,
                                    // eCpm_aniview: eCpm_aniview,
                                    grossRate_aniview: grossRate_aniview,
                                    revenueModel_aniview: revenueModel_aniview
                                }
                            }
                            : item // Return the object unchanged if frontendId is not 124
                    );
                }

                setCreativeMainTableData(updatedArray)
                handleHideModal_aniview()

            }
        } else {
            if (name_aniview.trim() === "") {
                setName_aniviewIsRequiredError(true);
            }
            // if (grossRate_aniview.trim() === "") {
            //     setGrossRate_aniviewIsRequiredError(true);
            // }
            if (!activeAdSourceRefreshInModal_aniview && eCpm_aniview === "") {
                setECpmIsRequiredError_aniview(true);
            }

        }

    };


    function validateAniviewCreative(array) {
        return creativeMainTableData.every(item => {
            // Check `adSource` only for relevant items
            if (item.default || item.adSourceRefresh) {
                return item.adSource; // Validate `adSource` exists
            }
            // Non-relevant items are considered valid
            return true;
        });
    }




    // -----------------------------------------------------------------------------------------------------------------------//
    // ---------------------------------Aniview form related code ends ---------------- -------------------------------------//
    // -----------------------------------------------------------------------------------------------------------------------//


    function handleFinalPayload() {
        if (creativeMainTableData.length > 0 && (campaignType === "IBV" ? validateAniviewCreative() : true)) {

            let payload = {
                type: campaignType,
                publisher: publisher,
                advertiser: advertiser,
                campaign_name: campaignName,
                campaign_category: selectedCampaignCategory,
                selectedRunTimeOption: selectedRunTimeOption,
                startDate: selectedRunTimeOption === "Setup start and end date and time" ? startDateString : "",
                endDate: selectedRunTimeOption === "Setup start and end date and time" ? endDateString : "",
                startDateIsTodayDate: selectedRunTimeOption === "Setup start and end date and time" ? dayjs(startDate).isSame(dayjs(), 'day') ? true : false : false,
                budget_type: selectedBudgetTypeOption,
                total_budget: totalBudget,
                monthly_budget: monthlyBudget,
                daily_budget: dailyBudget,
                total_wins: totalWins,
                daily_wins: dailyWins,
                daily_clicks: dailyClicks,
                min_eCPM: minCpm,
                max_eCPM: maxCpm,
                exchanges: exchangeMappingData.filter(item => item.check === true).map(({ check, loading, validate, ...rest }) => rest),
                bidOptimize: checkboxSmartBidOptimization,

                multipleAd_per_page: unitAdTypeOption,
                creatives_rotation: selectedCreativeOption,
                freqType: selectedListTypeOption,
                freqCapping: selectedListTypeFrequencyOption,
                freqValue: frequencyValue,
                minBiddingUniqueIP: minBidding,
                maxClicks: maxClicks,
                viewability: minViewability,
                optimizationType: selectedBidOptimizationMode,
                bidfloorMarginValue: selectedBidOptimizationMode === "BIDFLOOR_TO_MAX_RANDOM" ? "" : bidOptiomizationValue,
                vcrMin: minVCR,
                vcrMax: maxVCR,
                viewThroughConversionIp: checkbox_ipBasedConversion,

                exCategories: excludedcategoryList,
                adxSensitiveCategories: sensitiveCategoryList,
                country: countryList,
                state: stateList,
                city: cityList,
                site_app_option: appSites,
                os: osList,
                browser: browserList,
                deviceBrands: deviceBrandList,
                deviceTypes: deviceList,
                nonEmptyDeviceID: checkbox_non_empty_device_id,
                iplist_option: ipListMode,
                ipList: ipListMode === "DISABLED" ? [] : ipList,
                domainlist_option: domainListMode,
                domainList: domainListMode === "DISABLED" ? [] : domainList,
                extendedUsers_option: extendedUserListMode,
                extendedUsers: extendedUserListMode === "DISABLED" ? [] : extendedUserList,
                appBundle_option: appBundleListMode,
                appBundle: appBundleListMode === "DISABLED" ? [] : appBundleList,
                siteIdList_option: siteIdListMode,
                sitelist: siteIdListMode === "DISABLED" ? [] : siteIdList,
                bundlelist_option: appBundleTextListMode,
                bundlelist: appBundleTextListMode === "DISABLED" ? [] : appBundleTextList,
                appIdList_option: appIdListMode,
                appIdList: appIdListMode === "DISABLED" ? [] : appIdList,
                publisherlist_option: publisherIdListMode,
                publisherlist: publisherIdListMode === "DISABLED" ? [] : publisherIdList,
                nonpublisherid: checkbox_non_empty_publisher_id,
                tagidlist_option: tagIdListMode,
                tagidlist: tagIdListMode === "DISABLED" ? [] : tagIdList,

                creative: creativeMainTableData,
                repeatedHit: repeatedHits,

            }

            if (campaignType === "IBV") {
                let tempArrayOb = creativeMainTableData.find(item => item.default === true);

                payload.provider_aniview = tempArrayOb.adSource.provider_aniview
                payload.demandPublisher_aniview = tempArrayOb.adSource.publisher
                payload.name_aniview = tempArrayOb.adSource.name_aniview
                payload.advertiser_aniview = tempArrayOb.adSource.advertiser_aniview
                payload.sourceType_aniview = tempArrayOb.adSource.sourceType_aniview
                payload.status_aniview = tempArrayOb.adSource.status_aniview
                payload.ownertype_aniview = tempArrayOb.adSource.ownertype_aniview
                payload.environment_aniview = tempArrayOb.adSource.environment_aniview
                payload.eCpm_aniview = tempArrayOb.adSource.eCpm_aniview
                payload.grossRate_aniview = tempArrayOb.adSource.grossRate_aniview
                payload.revenueModel_aniview = tempArrayOb.adSource.revenueModel_aniview

            }

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
                setButtonProcessing(true);
                let token = Cookies.get("token_xapads_ssp");

                axios
                    .post(configData.SERVER_URL + `ops/gam/createCampaign`, payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            "x-access-token": token,
                        },
                    })
                    .then((response) => {
                        notifysuccess(response.data.message);
                        setTimeout(() => { handlePageViewChange("table", "yes") }, 1500)

                    })
                    .catch((error) => {
                        setRepeatedHits(true)
                        if (error?.response) {
                            if (error.response.data.message?.length !== 0) {
                                notifyfailure(error.response.data.message);
                                setButtonProcessing(false)
                            }
                        } else {
                            notifycatch();
                            setButtonProcessing(false)
                        }

                    });
            }
        }
        else {
            if (creativeMainTableData.length > 0) {
                notifyfailure("Please fill Adsource form for all creatives")
            }
            else {
                notifyfailure("Minimum 1 creative is required")
            }

        }

    }



    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">

                        <li >
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>
                                <img src={demandIcon} alt='USP' />
                                GAM
                            </Link>
                        </li>
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>

                                Campaign
                            </Link>
                        </li>
                        <li className="primary">New Campaign</li>
                    </ul>
                </div>

                <div className="container_box--wrapper--title d_flex justify-content-between align-items-center" >
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")

                            }}
                        />
                        <h1 className="heading">
                            Create Campaign
                        </h1>
                    </div>
                    <div className='li_tabs_designs'>
                        <ul>
                            <li
                                className={tabView > 0 ? "completed_li_tab active_li_tab" : tabView === 0 ? "active_li_tab" : ""}
                                onClick={() => {
                                    if (!buttonProcessing) {
                                        handleBackViewRandom(0)
                                    }

                                }}

                            >

                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 5.625V6.875" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 13.125V14.375" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.125 13.125H10.9375C11.3519 13.125 11.7493 12.9604 12.0424 12.6674C12.3354 12.3743 12.5 11.9769 12.5 11.5625C12.5 11.1481 12.3354 10.7507 12.0424 10.4576C11.7493 10.1646 11.3519 10 10.9375 10H9.0625C8.6481 10 8.25067 9.83538 7.95765 9.54235C7.66462 9.24933 7.5 8.8519 7.5 8.4375C7.5 8.0231 7.66462 7.62567 7.95765 7.33265C8.25067 7.03962 8.6481 6.875 9.0625 6.875H11.875" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                                Budget
                            </li>
                            <li
                                className={tabView > 1 ? "completed_li_tab active_li_tab" : tabView === 1 ? "active_li_tab" : ""}
                                onClick={() => {
                                    if (!buttonProcessing) {
                                        handleBackViewRandom(1)
                                    }
                                }}

                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M1.875 14.375V12.5859C1.875 8.09375 5.48437 4.39062 9.96875 4.375C11.0384 4.37089 12.0983 4.57801 13.0877 4.98449C14.077 5.39096 14.9764 5.98879 15.7342 6.74368C16.492 7.49857 17.0933 8.39565 17.5035 9.38346C17.9138 10.3713 18.125 11.4304 18.125 12.5V14.375C18.125 14.5408 18.0592 14.6997 17.9419 14.8169C17.8247 14.9342 17.6658 15 17.5 15H2.5C2.33424 15 2.17527 14.9342 2.05806 14.8169C1.94085 14.6997 1.875 14.5408 1.875 14.375Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 4.375V6.875" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.14844 10.3984L4.57031 11.0469" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.8516 10.3984L15.4297 11.0469" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.07812 15L13.4219 8.03906" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Optimization
                            </li>
                            <li
                                className={tabView > 2 ? "completed_li_tab active_li_tab" : tabView === 2 ? "active_li_tab" : ""}
                                onClick={() => {
                                    if (!buttonProcessing) {
                                        handleBackViewRandom(2)
                                    }
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85787 14.1421 2.5 10 2.5C5.85787 2.5 2.5 5.85787 2.5 10C2.5 14.1421 5.85787 17.5 10 17.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.002 14.5C12.4872 14.5 14.502 12.4853 14.502 10C14.502 7.51472 12.4872 5.5 10.002 5.5C7.51667 5.5 5.50195 7.51472 5.50195 10C5.50195 12.4853 7.51667 14.5 10.002 14.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Targeting
                            </li>
                            <li
                                className={tabView > 3 ? "completed_li_tab active_li_tab" : tabView === 3 ? "active_li_tab" : ""}
                                onClick={() => {
                                    if (!buttonProcessing && campaignType === "IBV") {
                                        handleBackViewRandom(3)
                                    }
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.4444 3H4.55556C3.69645 3 3 3.69645 3 4.55556V15.4444C3 16.3036 3.69645 17 4.55556 17H15.4444C16.3036 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.3036 3 15.4444 3Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.27799 8.44444C7.92233 8.44444 8.44466 7.92211 8.44466 7.27778C8.44466 6.63345 7.92233 6.11111 7.27799 6.11111C6.63366 6.11111 6.11133 6.63345 6.11133 7.27778C6.11133 7.92211 6.63366 8.44444 7.27799 8.44444Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16.9991 12.3333L13.1102 8.44444L4.55469 17" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Ads
                            </li>

                        </ul>
                    </div>
                </div>

                {initialProcessing &&
                    <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
                        <img src={FullLoader} className="mt-5" width={50} height={50} alt="" />
                    </div>
                }



                {/* // ---------------------------------------------------------------------------------------------------------------------------------------//
    // -----------------------------------------  Budget Code Starts ---------------------------------------------------------------------------//
    // ---------------------------------------------------------------------------------------------------------------------------------------//  */}
                {!initialProcessing &&
                    <>
                        {tabView === 0 ?

                            <div

                                className="container_box--content pt_20 form_scrollable_div_d2 ">


                                <div className="container_box--width "
                                    ref={scrollTopBudgetRef}
                                >

                                    <Row gutter={16} >
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>GAM Type</label>
                                            </div>
                                        </Col>

                                        <Col span={16}>
                                            <div className="container_box--form-container">
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="form_content_block--group mb-0">
                                                            <label className="form_label">Type * </label>
                                                            <Select
                                                                className='form_select basic no_search'
                                                                placeholder=""
                                                                optionFilterProp="label"
                                                                value={campaignType}
                                                                options={campaignTypeOptions}
                                                                onChange={onChangeCampaignType}
                                                            // disabled
                                                            />
                                                            <span className="error_content"> </span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>Campaign Details</label>
                                            </div>
                                        </Col>

                                        <Col span={16}>
                                            <div className="container_box--form-container">
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                                            <label className="form_label">Advertiser * </label>
                                                            <Input className='form_control basic ' disabled autocomplete="off"
                                                                value={advertiser}
                                                            />
                                                            <span className="error_content"> </span>
                                                        </div>
                                                        <Row gutter={16}>
                                                            <Col span={24}>
                                                                <div className="form_content_block--group " ref={campaignNameRef}>
                                                                    <label className="form_label">Publisher * </label>
                                                                    <Select
                                                                        showSearch
                                                                        className={publisherIsRequiredError ? 'form_select basic error' : 'form_select basic '}
                                                                        placeholder=""
                                                                        optionFilterProp="label"
                                                                        value={publisher}
                                                                        onChange={onChangePublisher}
                                                                        options={publisherOptions}

                                                                    />
                                                                    <span className="error_content">{publisherIsRequiredError && <>This field is required</>} </span>
                                                                </div>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group hide_caret_after_select_value" >
                                                                    <label className="form_label">Campaign Name *</label>
                                                                    <Input className={campaignNameIsRequiredError ? 'form_control basic error' : 'form_control basic '} autocomplete="off"
                                                                        placeholder="Campaign Name"
                                                                        value={campaignName}
                                                                        onChange={onChangeCampaignName}
                                                                        onBlur={onBlurCampaignName}

                                                                    />
                                                                    <span className="error_content"> {campaignNameIsRequiredError && <>  This field is required</>}</span>
                                                                </div>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                                    <label className="form_label">Campaign Category * </label>
                                                                    <Select
                                                                        showSearch
                                                                        className={campaignCategoryIsRequiredError ? 'form_select basic error ' : 'form_select basic '}
                                                                        placeholder=""
                                                                        optionFilterProp="label"
                                                                        options={campaignCategoryList}
                                                                        onChange={onChangeCampaignCategory}
                                                                        value={selectedCampaignCategory}

                                                                    />
                                                                    <span className="error_content">  {campaignCategoryIsRequiredError && <>  This field is required</>} </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <div className="form_content_block--group">
                                                            <Radio.Group className="form_radio two_radio_box_design_d2"
                                                                value={selectedRunTimeOption}
                                                                onChange={onChangeRuntimeOption}
                                                            >
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <label className="form_label ">
                                                                            When do you want to run this campaign?
                                                                        </label>
                                                                        <Radio className="radio_btn" value="Start immediately, run continuously">
                                                                            Start immediately, run continuously
                                                                        </Radio>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        <label className="form_label invisible">
                                                                            When do you want to run this campaign?
                                                                        </label>
                                                                        <Radio className="radio_btn" value="Setup start and end date and time">
                                                                            Setup start and end date and time
                                                                        </Radio>
                                                                    </Col>
                                                                </Row>
                                                            </Radio.Group>
                                                        </div>

                                                        {selectedRunTimeOption ===
                                                            "Setup start and end date and time" &&
                                                            <div className="form_content_block--group date_picker_d2 mb-0">
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label">Date Range </label>
                                                                            <DatePicker popupClassName="custom_datepicker_d2" placeholder='Start Date' className='w-100 form_control'
                                                                                value={startDate}
                                                                                onChange={onChangeStartDate}
                                                                                format="DD/MM/YYYY"
                                                                                disabledDate={disabledStartDate}
                                                                            />
                                                                        </div>
                                                                        <div className='d-flex align-items-start justify-content-between'>
                                                                            <p className="week_table_text">Calendar in PST Timezone</p>
                                                                            <span className="error_content">
                                                                                {startDateValidation && <>
                                                                                    Start Date not selected
                                                                                </>}
                                                                            </span>
                                                                        </div>
                                                                        <small className='line_between_cols_d2'>-</small>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label invisible">Date Range</label>
                                                                            <DatePicker popupClassName="custom_datepicker_d2" placeholder='End Date' className='w-100 form_control'
                                                                                value={endDate}
                                                                                onChange={onChangeEndDate}
                                                                                disabledDate={disabledEndDate}
                                                                                format="DD/MM/YYYY"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        }
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>Budget Details</label>
                                            </div>
                                        </Col>

                                        <Col span={16}>
                                            <div className="container_box--form-container" ref={totalBudgetRef}>
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="form_content_block--group prefixed_icon_d2">
                                                            <label className="form_label">Total Budget *  </label>
                                                            <Input className={totalBudgetIsRequiredError || totalBudgetValueError || budgetMaxGreaterThanMinError ? 'form_control basic error' : 'form_control basic'} placeholder='0' prefix={'$'} autocomplete="off"
                                                                value={totalBudget}
                                                                onChange={onChangeTotalBudget}

                                                            />
                                                            <span className="error_content">
                                                                {totalBudgetIsRequiredError && <>This field is required <br /> </>}
                                                                {totalBudgetValueError && <>Total budget must be between 0 and 1000000 <br /> </>}
                                                                {budgetMaxGreaterThanMinError && <> Total budget must be greater than daily/monthy budget </>}
                                                            </span>
                                                        </div>
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group prefixed_icon_d2">
                                                                    <label className="form_label">Daily Budget </label>
                                                                    <Input className={dailyBudgetValueError ? 'form_control basic error' : 'form_control basic'} prefix={'$'} placeholder='0' autocomplete="off"
                                                                        value={dailyBudget}
                                                                        onChange={onChangeDailyBudget}
                                                                        disabled={monthlyBudget.trim().length > 0}
                                                                    />
                                                                    <span className="error_content">{dailyBudgetValueError && <>Daily budget must be between 0 and 1000000 </>} </span>
                                                                </div>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group prefixed_icon_d2">
                                                                    <label className="form_label">Monthly Budget</label>
                                                                    <Input className={monthlyBudgetValueError ? 'form_control basic error' : 'form_control basic'} prefix={'$'} placeholder='0' autocomplete="off"
                                                                        value={monthlyBudget}
                                                                        onChange={onChangeMonthlyBudget}
                                                                        disabled={dailyBudget.trim().length > 0}
                                                                    />
                                                                    <span className="error_content">{monthlyBudgetValueError && <>Monthly budget must be between 0 and 1000000 </>} </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={16}>
                                                            <Col span={8}>
                                                                <div className="form_content_block--group" ref={totalWinsRef}>
                                                                    <label className="form_label">Total Wins</label>
                                                                    <Input className={totalWinsValueError || winsMaxGreaterThanMinError ? 'form_control basic error' : 'form_control basic'} placeholder='0' autocomplete="off"
                                                                        value={totalWins}
                                                                        onChange={onChangeTotalWins}

                                                                    />
                                                                    <span className="error_content">
                                                                        {totalWinsValueError && <>Total wins must be between 1 and 1000000 <br /> </>}
                                                                        {winsMaxGreaterThanMinError && <> Total wins must be greater than daily wins </>}
                                                                    </span>
                                                                </div>
                                                            </Col>
                                                            <Col span={8}>
                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">Daily Wins</label>
                                                                    <Input className={dailyWinsValueError ? 'form_control basic error' : 'form_control basic'} placeholder='0' autocomplete="off"
                                                                        value={dailyWins}
                                                                        onChange={onChangeDailyWins}

                                                                    />
                                                                    <span className="error_content">{dailyWinsValueError && <>Daily wins must be between 1 and 1000000 </>} </span>
                                                                </div>
                                                            </Col>
                                                            <Col span={8}>
                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">Daily Clicks</label>
                                                                    <Input className={dailyClicksValidError ? 'form_control basic error' : 'form_control basic'} placeholder='0' autocomplete="off"
                                                                        value={dailyClicks}
                                                                        onChange={onChangeDailyClicks}
                                                                    />
                                                                    <span className="error_content">{dailyClicksValidError && <>Daily clicks must be between 1 and 1000000 </>} </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <div className="form_content_block--group">
                                                            <Radio.Group className="form_radio two_radio_box_design_d2 w-100"
                                                                value={selectedBudgetTypeOption}
                                                                onChange={onChangeBudgetTypeOption}
                                                            >
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <label className="form_label ">
                                                                            Budget Type *
                                                                        </label>
                                                                        <Radio className="radio_btn w-100" value="Evenly">
                                                                            Evenly
                                                                        </Radio>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        <label className="form_label invisible">
                                                                            Budget Type *
                                                                        </label>
                                                                        <Radio className="radio_btn w-100" value="ASAP">
                                                                            ASAP
                                                                        </Radio>
                                                                    </Col>
                                                                </Row>
                                                            </Radio.Group>
                                                        </div>
                                                        <div className="form_content_block--group">
                                                            <div className="primary_checkbox">
                                                                <Checkbox id="checkboxSmartBidOptimization" name="checkboxSmartBidOptimization"
                                                                    checked={checkboxSmartBidOptimization}
                                                                    onChange={onChangeCheckbox_smartBidOptimization}
                                                                >
                                                                    <span className="form_label">
                                                                        Use Smart bid optimization
                                                                    </span>
                                                                </Checkbox>
                                                            </div>
                                                            <span className="error_content">{checkboxSmartBidOptimizationValueError && <>Use Smart bid optimization can be enabled only if budget type is Evenly</>} </span>
                                                        </div>
                                                        <div className="form_content_block--group mb-0">
                                                            <label className="form_label d-block">Exchanges Mapping *</label>
                                                            <div className="d_flex justify_content_between mb_10 align-items-center">
                                                                <Input
                                                                    type='text'
                                                                    className='form_control basic md search_input w_table_search'
                                                                    placeholder="Search"
                                                                    value={searchExchangeMapping}
                                                                    onChange={(e) => {
                                                                        setSearchExchangeMapping(e.target.value)
                                                                    }}
                                                                />
                                                                {!loadingExchangeMapping && <span className='row_count_value_d2'>{exchangeMappingData.filter(item => item.check === true).length} out of {exchangeMappingData.length} Selected</span>}
                                                            </div>
                                                        </div>
                                                        <div className='form_content_block--group'>
                                                            <div className="table_content--box form_table_design_d2">
                                                                <Table
                                                                    columns={exchangeMappingColumns}
                                                                    dataSource={filterExchangeMappingData}
                                                                    // dataSource={filterExchangeMappingData.sort((a, b) => {
                                                                    //     return a.check === b.check ? 0 : a.check ? -1 : 1;
                                                                    // })}
                                                                    rowClassName={(record) => record.check ? 'table_row_checked_d2' : ''}
                                                                    // onChange={onChange}
                                                                    locale={localeExchangeMapping}
                                                                    pagination={false}
                                                                    scroll={{ x: '', y: 'calc(100vh - 35rem' }}
                                                                />
                                                                <span className="error_content">

                                                                    {exchangeMappingDataIsRequiredError && (
                                                                        <>
                                                                            This field is required
                                                                            <br />
                                                                        </>
                                                                    )}
                                                                    {exchangeMappingDataMappingError && (
                                                                        <>
                                                                            Fill the zone ID for selected exchanges and submit to proceed.

                                                                        </>
                                                                    )}
                                                                </span>
                                                            </div>

                                                        </div>

                                                        <Row gutter={16} className='position-relative'>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">eCPM range (Min-Max) *</label>
                                                                    <Input className={minCpmIsRequiredError || minCpmValueError ? 'form_control basic error' : 'form_control basic'} placeholder='Min' autocomplete="off"
                                                                        value={minCpm}
                                                                        // onBlur={onBlurMinCpm}
                                                                        onChange={onChangeMinCpm}
                                                                    />
                                                                </div>
                                                                <span className="error_content">

                                                                    {minCpmIsRequiredError && (
                                                                        <>
                                                                            This field is required
                                                                            <br />
                                                                        </>
                                                                    )}

                                                                    {minCpmValueError && (
                                                                        <>
                                                                            Value should be greater than 0 and less than or equal to 50
                                                                        </>
                                                                    )}
                                                                </span>
                                                                <small className='line_between_cols_d2'>-</small>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label invisible">eCPM range (Min-Max) *</label>
                                                                    <Input className={maxCpmIsRequiredError || maxCpmValueError || maxGreaterThanMinError ? 'form_control basic error' : 'form_control basic'} placeholder='Max' autocomplete="off"
                                                                        value={maxCpm}
                                                                        // onBlur={onBlurMaxCpm}
                                                                        onChange={onChangeMaxCpm}
                                                                    />
                                                                    <span className="error_content">
                                                                        {maxCpmIsRequiredError && (
                                                                            <>
                                                                                This field is required
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                        {maxCpmValueError && (
                                                                            <>
                                                                                Value should be greater than 0 and less than or equal to 50
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                        {maxGreaterThanMinError && (
                                                                            <>
                                                                                Max CPM Should be greater than or equal to Min
                                                                                CPM
                                                                                <br />
                                                                            </>
                                                                        )}


                                                                    </span>
                                                                </div>
                                                            </Col>
                                                        </Row>



                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </div >


                                <div className="hr_custom mb_20"></div>
                                <div className="btn_group justify-content-end gap_8 pb_50">
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={() => { handlePageViewChange("table", "no") }}> Discard </button>
                                    <button className="w_120_d2 btn btn_primary w_fit_content" onClick={() => { handleBudgetValidations() }}>Next</button>
                                </div>
                            </div>


                            : tabView === 1 ?

                                <div

                                    className="container_box--content pt_20  form_scrollable_div_d2">

                                    <div className="container_box--width"

                                    >
                                        <Row gutter={16} ref={scrollTopOptimizationRef}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>Ad</label>
                                                </div>
                                            </Col>

                                            <Col span={16}>
                                                <div className="container_box--form-container">
                                                    <div className="form_content_block--group">
                                                        <Radio.Group className="form_radio two_radio_box_design_d2"
                                                            value={unitAdTypeOption}
                                                            onChange={onChangeUnitAdTypeOption}
                                                        >
                                                            <Row gutter={16}>
                                                                <Col span={12}>
                                                                    <label className="form_label ">
                                                                        Multiple units per page *
                                                                    </label>
                                                                    <Radio className="radio_btn" value="Show all ads per publish page">
                                                                        Show all ads per publish page
                                                                    </Radio>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <label className="form_label invisible">
                                                                        Multiple units per page
                                                                    </label>
                                                                    <Radio className="radio_btn" value="One ad per publisher page">
                                                                        One ad per publisher page
                                                                    </Radio>
                                                                </Col>
                                                            </Row>
                                                        </Radio.Group>
                                                    </div>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                                <label className="form_label">Creative rotation  *</label>
                                                                <Select

                                                                    className='form_select basic no_search'
                                                                    placeholder=""
                                                                    optionFilterProp="label"
                                                                    value={selectedCreativeOption}
                                                                    onChange={onChangeCreativeOption}
                                                                    options={creativeRotationOption}
                                                                />
                                                                <span className="error_content"> </span>
                                                            </div>
                                                            <Row gutter={16}>
                                                                <Col span={12}>
                                                                    <div className="form_content_block--group suffix_d2" ref={minBiddingRef}>
                                                                        <label className="form_label">Min. bidding interval per unique IP, ms </label>
                                                                        <Input className={minBiddingValidError ? 'form_control form_control_with_icon_d2 basic error ' : 'form_control form_control_with_icon_d2 basic '} placeholder='' autocomplete="off" value={minBidding}
                                                                            onChange={onChangeMinBidding}
                                                                        />
                                                                        <span className="error_content">{minBiddingValidError && <>Min. bidding interval per unique IP must be from 10 to 100000 </>} </span>
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <div className="form_content_block--group suffix_d2">
                                                                        <label className="form_label">Max clicks per user id </label>
                                                                        <Input className={maxClicksValidError ? 'form_control form_control_with_icon_d2 basic error ' : 'form_control form_control_with_icon_d2 basic '} placeholder='' autocomplete="off" value={maxClicks}
                                                                            onChange={onChangeMaxClicks}
                                                                        />
                                                                        <span className="error_content">{maxClicksValidError && <>Max CLicks must be from 1 to 1000 </>} </span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <div className="form_content_block--group suffix_d2 mb-0">
                                                                <label className="form_label">Min viewability  </label>
                                                                <Input className={minViewabilityValidError ? 'form_control form_control_with_icon_d2 basic error ' : 'form_control form_control_with_icon_d2 basic '} placeholder='0' suffix={'%'} autocomplete="off" value={minViewability}
                                                                    onChange={onChangeMinViewability}
                                                                />
                                                                <span className="error_content">
                                                                    {minViewabilityValidError && <>Min Viewability must be a positive integer between 1 and 99 </>} </span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>


                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>Frequency Capping</label>
                                                </div>
                                            </Col>

                                            <Col span={16}>
                                                <div className="container_box--form-container">
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <Row gutter={16}>
                                                                <Col span={8}>
                                                                    <div className="form_content_block--group mb-0">
                                                                        <Select

                                                                            className='form_select basic no_search'
                                                                            placeholder=""
                                                                            optionFilterProp="label"
                                                                            value={selectedListTypeOption}
                                                                            onChange={onChangeListTypeOption}
                                                                            options={listTypeOption}
                                                                        />
                                                                        <span className="error_content"> </span>
                                                                    </div>
                                                                </Col>
                                                                <Col span={8}>
                                                                    <div className="form_content_block--group mb-0">
                                                                        <Select

                                                                            className='form_select basic no_search'
                                                                            placeholder=""
                                                                            optionFilterProp="label"
                                                                            value={selectedListTypeFrequencyOption}
                                                                            onChange={onChangeListTypeFrequencyOption}
                                                                            options={ListTypeFrequencyOption}
                                                                        />
                                                                        <span className="error_content"> </span>
                                                                    </div>
                                                                </Col>
                                                                <Col span={8}>
                                                                    <div className="form_content_block--group mb-0">
                                                                        <Input className={frequencyValueValidError ? 'form_control basic error' : 'form_control basic'} placeholder='0' autocomplete="off" value={frequencyValue}
                                                                            onChange={onChangeFrequencyValue}
                                                                        />
                                                                        <span className="error_content">{frequencyValueValidError && <>Value must be between 0 to 100 </>} </span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>Conversion Details</label>
                                                </div>
                                            </Col>

                                            <Col span={16}>
                                                <div className="container_box--form-container">
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                                <label className="form_label">Bid optimization mode </label>
                                                                <Select
                                                                    className='form_select basic no_search'
                                                                    placeholder=""
                                                                    optionFilterProp="label"
                                                                    value={selectedBidOptimizationMode}
                                                                    onChange={onChangeBidOptimizationMode}
                                                                    options={bidOptimizationModeOption}
                                                                />
                                                                <span className="error_content"> </span>
                                                            </div>
                                                            <Row gutter={16} className='position-relative'>
                                                                <Col span={12}>
                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">VCR (Min-Max)</label>
                                                                        <Input className={minVCRValueError || minVCRIsRequiredError ? 'form_control basic error' : 'form_control basic'} placeholder='Min' autocomplete="off" value={minVCR}
                                                                            onChange={onChangeMinVCR}

                                                                        />

                                                                        <span className="error_content">
                                                                            {minVCRIsRequiredError && <>This field is required  <br />  </>}
                                                                            {minVCRValueError && <>Min VCR must be greater than or equal to 0 and less than 100 </>}

                                                                        </span>
                                                                    </div>
                                                                    <small className='line_between_cols_d2 translateY'>-</small>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label invisible">VCR (Min-Max)</label>
                                                                        <Input className={maxVCRValueError || VCRMaxGreaterThanMinError || maxVCRIsRequiredError ? 'form_control basic error' : 'form_control basic'} placeholder='Max' autocomplete="off" value={maxVCR}
                                                                            onChange={onChangeMaxVCR}

                                                                        />

                                                                        <span className="error_content">
                                                                            {maxVCRIsRequiredError && <>This field is required  <br />  </>}
                                                                            {maxVCRValueError && <>Max VCR must be greater  0 and less than or equal to  100  <br />  </>}
                                                                            {VCRMaxGreaterThanMinError && <>Max VCR must be greater than min VCR </>}
                                                                        </span>
                                                                    </div>
                                                                </Col>
                                                                {(selectedBidOptimizationMode === "BIDFLOOR_PLUS_PERCENT_MARGIN" || selectedBidOptimizationMode === "BIDFLOOR_PLUS_FIXED_MARGIN") &&
                                                                    <Col span={24}>
                                                                        <div className="form_content_block--group suffix_d2">
                                                                            <label className="form_label"> Bid Floor + {selectedBidOptimizationMode === "BIDFLOOR_PLUS_PERCENT_MARGIN" ? <>%</> : <>$</>} Margin * </label>
                                                                            <Input className={bidOptiomizationValueIsRequiredError || bidOptiomizationValueValidError ? 'form_control  basic error ' : "form_control  basic"} placeholder='0' autocomplete="off"
                                                                                value={bidOptiomizationValue}
                                                                                onChange={onChangeBidOptiomizationValue}
                                                                            />

                                                                            <span className="error_content">
                                                                                {bidOptiomizationValueIsRequiredError && <>This field is required </>}
                                                                                {bidOptiomizationValueValidError && <>Value must be greater than 0 and less than or equal to  100 </>} </span>

                                                                        </div>
                                                                    </Col>
                                                                }

                                                            </Row>
                                                            <div className="form_content_block--group mb-0">
                                                                <div className="primary_checkbox">
                                                                    <Checkbox id="zone_checkbox_prebid" name="checkbox_ipBasedConversion"
                                                                        checked={checkbox_ipBasedConversion}
                                                                        onChange={onChangeCheckbox_ipBasedconversion}
                                                                    >
                                                                        <span className="form_label">
                                                                            IP-based View-through Conversion for CTV devices
                                                                        </span>
                                                                    </Checkbox>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="hr_custom mb_20"></div>
                                    <div className="btn_group justify-content-end gap_8 pb_50">
                                        <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={() => { handleBackView(0) }}> Back </button>
                                        <button className="w_120_d2 btn btn_primary w_fit_content" onClick={() => { handleOptimizationValidations() }} >Next</button>
                                    </div>
                                </div>

                                : tabView === 2 ?

                                    <div

                                        className="container_box--content pt_20 form_scrollable_div_d2">

                                        <div className="container_box--width" ref={scrollTopTargetingRef}>

                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Ad</label>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container">
                                                        <Row gutter={16}>
                                                            <Col span={24}>
                                                                <div className="form_content_block--group">
                                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2 custom_modal_form_d2'>
                                                                        <label className="form_label"></label>
                                                                        <div className='d-flex align-items-center justify-content-between'>
                                                                            <label className="form_label ">Excluded Categories </label>
                                                                            <Link className='Supported_macros_text'
                                                                                style={{ cursor: "pointer" }}
                                                                                to="/excludedCategoryListGam"
                                                                                target="_blank"
                                                                            >
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                    <path d="M8 3.33325V12.6666" stroke="#4F44E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    <path d="M3.33398 8H12.6673" stroke="#4F44E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </svg>
                                                                                Add New
                                                                            </Link>
                                                                        </div>
                                                                        <Select
                                                                            id="excludedcategoryList"
                                                                            value={excludedcategoryList}
                                                                            // disabled={true}
                                                                            popupClassName='diff_select_d2 --full'
                                                                            // open={true}
                                                                            showSearch={false}
                                                                            placeholder='- Select -'
                                                                            className="form_select basic"
                                                                            mode='multiple'
                                                                            maxTagCount='responsive'
                                                                            dropdownRender={menu => (
                                                                                <>
                                                                                    <div className="custom_inside_searchbar_d2">
                                                                                        <Input placeholder="Search" value={searchExcludedcategoryList} onChange={handleSearchExcludedcategoryList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                    </div>
                                                                                    <div className='select_all_d2'
                                                                                        onClick={() => handleSelectAllExcludedcategoryList()}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={excludedcategoryList?.length === excludedcategoryListOptions?.length}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            Select All
                                                                                        </Checkbox>
                                                                                    </div>

                                                                                    {menu}
                                                                                </>
                                                                            )}
                                                                        >
                                                                            {[
                                                                                ...filterExcludedcategoryList?.filter(option => excludedcategoryList?.includes(option.value)), // Checked options first
                                                                                ...filterExcludedcategoryList?.filter(option => !excludedcategoryList?.includes(option.value)) // Unchecked options next
                                                                            ].map(option => (
                                                                                <Option key={option.value} value={option.value}>
                                                                                    <div
                                                                                        onClick={() => handleExcludedcategoryList(option.value)}
                                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={excludedcategoryList?.includes(option.value)}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            {option.label}
                                                                                        </Checkbox>
                                                                                    </div>
                                                                                </Option>
                                                                            ))}
                                                                        </Select>
                                                                    </div>
                                                                </div>
                                                                <div className="form_content_block--group mb-0">
                                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                        <label className="form_label">ADX Sensitive Categories </label>


                                                                        <Select
                                                                            id="sensitiveCategoryList"
                                                                            value={sensitiveCategoryList}
                                                                            // disabled={true}
                                                                            popupClassName='diff_select_d2 --full'
                                                                            // open={true}
                                                                            showSearch={false}
                                                                            placeholder='- Select -'
                                                                            className="form_select basic"
                                                                            mode='multiple'
                                                                            maxTagCount='responsive'
                                                                            dropdownRender={menu => (
                                                                                <>
                                                                                    <div className="custom_inside_searchbar_d2">
                                                                                        <Input placeholder="Search" value={searchSensitiveCategoryList} onChange={handleSearchSensitiveCategoryList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                    </div>
                                                                                    <div className='select_all_d2'

                                                                                        onClick={() => handleSelectAllSensitiveCategoryList()}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={sensitiveCategoryList?.length === sensitiveCategoryListOptions?.length}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            Select All
                                                                                        </Checkbox>
                                                                                    </div>

                                                                                    {menu}
                                                                                </>
                                                                            )}
                                                                        >
                                                                            {[
                                                                                ...filterSensitiveCategoryList?.filter(option => sensitiveCategoryList?.includes(option.value)), // Checked options first
                                                                                ...filterSensitiveCategoryList?.filter(option => !sensitiveCategoryList?.includes(option.value)) // Unchecked options next
                                                                            ].map(option => (
                                                                                <Option key={option.value} value={option.value}>
                                                                                    <div
                                                                                        onClick={() => handleSensitiveCategoryList(option.value)}
                                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={sensitiveCategoryList?.includes(option.value)}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            {option.label}
                                                                                        </Checkbox>
                                                                                    </div>
                                                                                </Option>
                                                                            ))}
                                                                        </Select>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Geo</label>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container">
                                                        <Row gutter={16}>
                                                            <Col span={24}>
                                                                <div className="form_content_block--group">
                                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2' ref={countryListRef}>
                                                                        <label className="form_label">Country * </label>
                                                                        <Select
                                                                            id="countryList"
                                                                            value={countryList}
                                                                            // disabled={true}
                                                                            popupClassName='diff_select_d2 --full'
                                                                            showSearch={false}
                                                                            placeholder='- Select -'
                                                                            className={countryListIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                                            mode='multiple'
                                                                            maxTagCount='responsive'
                                                                            dropdownRender={menu => (
                                                                                <>
                                                                                    <div className="custom_inside_searchbar_d2">
                                                                                        <Input placeholder="Search" value={searchCountryList} onChange={handleSearchCountryList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                    </div>
                                                                                    <div className='select_all_d2'
                                                                                        onClick={() => handleSelectAllCountryList()}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={countryList?.length === countryListOptions?.length}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            Select All
                                                                                        </Checkbox>
                                                                                    </div>

                                                                                    {menu}
                                                                                </>
                                                                            )}
                                                                        >
                                                                            {[
                                                                                ...filterCountryList?.filter(option => countryList?.includes(option.value)), // Checked options first
                                                                                ...filterCountryList?.filter(option => !countryList?.includes(option.value)) // Unchecked options next
                                                                            ].map(option => (
                                                                                <Option key={option.value} value={option.value}>
                                                                                    <div
                                                                                        onClick={() => handleCountryList(option.value)}
                                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={countryList?.includes(option.value)}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            {option.label}
                                                                                        </Checkbox>
                                                                                    </div>
                                                                                </Option>
                                                                            ))}
                                                                        </Select>

                                                                        <span className="error_content">{countryListIsRequiredError && <>Minimum 1 selection is required</>} </span>

                                                                    </div>
                                                                </div>
                                                                <div className="form_content_block--group">
                                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                        <label className="form_label">State </label>
                                                                        {stateListOptionsLoader ?
                                                                            <div className="laoding_input_form_d2">
                                                                                <div className="position-relative">
                                                                                    <Input className="" disabled />
                                                                                    <img src={FullLoader} className="loader_img_d2" alt="" />
                                                                                </div>
                                                                            </div> :

                                                                            <Select
                                                                                id="stateList"
                                                                                value={stateList}
                                                                                // disabled={true}
                                                                                popupClassName='diff_select_d2 --full'
                                                                                // open={true}
                                                                                showSearch={false}
                                                                                placeholder='- Select -'
                                                                                className="form_select basic"
                                                                                mode='multiple'
                                                                                maxTagCount='responsive'
                                                                                dropdownRender={menu => (
                                                                                    <>
                                                                                        <div className="custom_inside_searchbar_d2">
                                                                                            <Input placeholder="Search" value={searchStateList} onChange={handleSearchStateList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                        </div>
                                                                                        <div className='select_all_d2'
                                                                                            onClick={() => handleSelectAllStateList()}
                                                                                        >
                                                                                            <Checkbox
                                                                                                checked={stateList?.length === stateListOptions?.length}
                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                            >
                                                                                                Select All
                                                                                            </Checkbox>
                                                                                        </div>

                                                                                        {menu}
                                                                                    </>
                                                                                )}
                                                                            >
                                                                                {[
                                                                                    ...filterStateList?.filter(option => stateList?.includes(option.value)), // Checked options first
                                                                                    ...filterStateList?.filter(option => !stateList?.includes(option.value)) // Unchecked options next
                                                                                ].map(option => (
                                                                                    <Option key={option.value} value={option.value}>
                                                                                        <div
                                                                                            onClick={() => handleStateList(option.value)}
                                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                                        >
                                                                                            <Checkbox
                                                                                                checked={stateList?.includes(option.value)}
                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                            >
                                                                                                {option.label}
                                                                                            </Checkbox>
                                                                                        </div>
                                                                                    </Option>
                                                                                ))}
                                                                            </Select>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="form_content_block--group mb-0">
                                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                        <label className="form_label">City </label>
                                                                        {cityListOptionsLoader ?
                                                                            <div className="laoding_input_form_d2">
                                                                                <div className="position-relative">
                                                                                    <Input className="" disabled />
                                                                                    <img src={FullLoader} className="loader_img_d2" alt="" />
                                                                                </div>
                                                                            </div> :
                                                                            <Select
                                                                                id="cityList"
                                                                                value={cityList}
                                                                                // disabled={true}
                                                                                popupClassName='diff_select_d2 --full'
                                                                                // open={true}
                                                                                showSearch={false}
                                                                                placeholder='- Select -'
                                                                                className="form_select basic"
                                                                                mode='multiple'
                                                                                maxTagCount='responsive'
                                                                                dropdownRender={menu => (
                                                                                    <>
                                                                                        <div className="custom_inside_searchbar_d2">
                                                                                            <Input placeholder="Search" value={searchCityList} onChange={handleSearchCityList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                        </div>
                                                                                        <div className='select_all_d2'
                                                                                            onClick={() => handleSelectAllCityList()}
                                                                                        >
                                                                                            <Checkbox
                                                                                                checked={cityList?.length === cityListOptions?.length}
                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                            >
                                                                                                Select All
                                                                                            </Checkbox>
                                                                                        </div>

                                                                                        {menu}
                                                                                    </>
                                                                                )}
                                                                            >
                                                                                {[
                                                                                    ...filterCityList?.filter(option => cityList?.includes(option.value)), // Checked options first
                                                                                    ...filterCityList?.filter(option => !cityList?.includes(option.value)) // Unchecked options next
                                                                                ].map(option => (
                                                                                    <Option key={option.value} value={option.value}>
                                                                                        <div
                                                                                            onClick={() => handleCityList(option.value)}
                                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                                        >
                                                                                            <Checkbox
                                                                                                checked={cityList?.includes(option.value)}
                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                            >
                                                                                                {option.label}
                                                                                            </Checkbox>
                                                                                        </div>
                                                                                    </Option>
                                                                                ))}
                                                                            </Select>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Devices and Browsers</label>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container">
                                                        <Row gutter={16}>
                                                            <Col span={24}>
                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">
                                                                        App/ Sites
                                                                    </label>
                                                                    <Radio.Group className="form_radio equal_space"
                                                                        value={appSites}
                                                                        onChange={onChangeAppSites}
                                                                    >
                                                                        <Radio className="radio_btn" value="Show on both">
                                                                            Show on both
                                                                        </Radio>
                                                                        <Radio className="radio_btn" value="Show in apps">
                                                                            Show in apps
                                                                        </Radio>
                                                                        <Radio className="radio_btn" value="Show on sites">
                                                                            Show on sites
                                                                        </Radio>
                                                                    </Radio.Group>
                                                                </div>
                                                                <div className="form_content_block--group">
                                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2' ref={deviceListRef}>
                                                                        <label className="form_label">Devices * </label>
                                                                        <Select
                                                                            id="deviceList"
                                                                            value={deviceList}
                                                                            // disabled={true}
                                                                            popupClassName='diff_select_d2 --full'
                                                                            showSearch={false}
                                                                            placeholder='- Select -'
                                                                            className={deviceListIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                                            mode='multiple'
                                                                            maxTagCount='responsive'
                                                                            dropdownRender={menu => (
                                                                                <>
                                                                                    <div className="custom_inside_searchbar_d2">
                                                                                        <Input placeholder="Search" value={searchDeviceList} onChange={handleSearchDeviceList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                    </div>
                                                                                    <div className='select_all_d2'
                                                                                        onClick={() => handleSelectAllDeviceList()}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={deviceList?.length === deviceListOptions?.length}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            Select All
                                                                                        </Checkbox>
                                                                                    </div>

                                                                                    {menu}
                                                                                </>
                                                                            )}
                                                                        >
                                                                            {[
                                                                                ...filterDeviceList?.filter(option => deviceList?.includes(option.value)), // Checked options first
                                                                                ...filterDeviceList?.filter(option => !deviceList?.includes(option.value)) // Unchecked options next
                                                                            ].map(option => (
                                                                                <Option key={option.value} value={option.value}>
                                                                                    <div
                                                                                        onClick={() => handleDeviceList(option.value)}
                                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={deviceList?.includes(option.value)}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            {option.label}
                                                                                        </Checkbox>
                                                                                    </div>
                                                                                </Option>
                                                                            ))}
                                                                        </Select>
                                                                        <span className="error_content">{deviceListIsRequiredError && <>Minimum 1 selection is required</>} </span>
                                                                    </div>
                                                                </div>
                                                                <div className="form_content_block--group">
                                                                    <div className="primary_checkbox">
                                                                        <Checkbox id="zone_checkbox_prebid" name="checkbox_non_empty_device_id"
                                                                            checked={checkbox_non_empty_device_id}
                                                                            onChange={onChangeCheckbox_non_empty_device_id}
                                                                        >
                                                                            <span className="form_label">
                                                                                Non-empty device ID
                                                                            </span>
                                                                        </Checkbox>
                                                                    </div>
                                                                </div>

                                                                <div className="form_content_block--group">
                                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                        <label className="form_label">Device Brands and Models *</label>
                                                                        <Select
                                                                            id="deviceBrandList"
                                                                            value={deviceBrandList}
                                                                            // disabled={true}
                                                                            popupClassName='diff_select_d2 --full'
                                                                            showSearch={false}
                                                                            placeholder='- Select -'
                                                                            className="form_select basic"
                                                                            mode='multiple'
                                                                            maxTagCount='responsive'
                                                                            dropdownRender={menu => (
                                                                                <>
                                                                                    <div className="custom_inside_searchbar_d2">
                                                                                        <Input placeholder="Search" value={searchDeviceBrandList} onChange={handleSearchDeviceBrandList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                    </div>
                                                                                    <div className='select_all_d2'
                                                                                        onClick={() => handleSelectAllDeviceBrandList()}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={deviceBrandList?.length === deviceBrandListOptions?.length}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            Select All
                                                                                        </Checkbox>
                                                                                    </div>

                                                                                    {menu}
                                                                                </>
                                                                            )}
                                                                        >
                                                                            {[
                                                                                ...filterDeviceBrandList?.filter(option => deviceBrandList?.includes(option.value)), // Checked options first
                                                                                ...filterDeviceBrandList?.filter(option => !deviceBrandList?.includes(option.value)) // Unchecked options next
                                                                            ].map(option => (
                                                                                <Option key={option.value} value={option.value}>
                                                                                    <div
                                                                                        onClick={() => handleDeviceBrandList(option.value)}
                                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={deviceBrandList?.includes(option.value)}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            {option.label}
                                                                                        </Checkbox>
                                                                                    </div>
                                                                                </Option>
                                                                            ))}
                                                                        </Select>
                                                                        <span className="error_content">{deviceBrandListIsRequiredError && <>Minimum 1 selection is required</>} </span>
                                                                    </div>
                                                                </div>

                                                                <div className="form_content_block--group">
                                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                        <label className="form_label">Operating systems *</label>
                                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                            <TreeSelect {...tPropsOs} className="form_select basic tree_height_d2" maxTagCount={6} popupClassName='diff_tree_select_d2' />
                                                                            <span className="error_content">{osListIsRequiredError && <>Minimum 1 selection is required</>} </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="form_content_block--group mb-0">
                                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                        <label className="form_label">Browsers *</label>
                                                                        <Select
                                                                            id="browserList"
                                                                            value={browserList}
                                                                            // disabled={true}
                                                                            popupClassName='diff_select_d2 --full'
                                                                            // open={true}
                                                                            showSearch={false}
                                                                            placeholder='- Select -'
                                                                            className="form_select basic"
                                                                            mode='multiple'
                                                                            maxTagCount='responsive'
                                                                            dropdownRender={menu => (
                                                                                <>
                                                                                    <div className="custom_inside_searchbar_d2">
                                                                                        <Input placeholder="Search" value={searchBrowserList} onChange={handleSearchBrowserList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                    </div>
                                                                                    <div className='select_all_d2'
                                                                                        onClick={() => handleSelectAllBrowserList()}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={browserList?.length === browserListOptions?.length}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            Select All
                                                                                        </Checkbox>
                                                                                    </div>

                                                                                    {menu}
                                                                                </>
                                                                            )}
                                                                        >
                                                                            {[
                                                                                ...filterBrowserList?.filter(option => browserList?.includes(option.value)), // Checked options first
                                                                                ...filterBrowserList?.filter(option => !browserList?.includes(option.value)) // Unchecked options next
                                                                            ].map(option => (
                                                                                <Option key={option.value} value={option.value}>
                                                                                    <div
                                                                                        onClick={() => handleBrowserList(option.value)}
                                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={browserList?.includes(option.value)}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            {option.label}
                                                                                        </Checkbox>
                                                                                    </div>
                                                                                </Option>
                                                                            ))}
                                                                        </Select>
                                                                        <span className="error_content">{browserListIsRequiredError && <>Minimum 1 selection is required</>} </span>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>List Targeting</label>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container" ref={ipListRef}>
                                                        <Row gutter={16}>
                                                            <Col span={24}>
                                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                                    <Row gutter={8}>
                                                                        <Col span={7}>

                                                                            <label className="form_label">IP Lists </label>
                                                                            <Select

                                                                                className='form_select basic no_search'
                                                                                optionFilterProp="label"
                                                                                onChange={onChangeIpListMode}
                                                                                value={ipListMode}
                                                                                options={ipListModeOptions}
                                                                            />
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                        <Col span={17} className='disabled_ant_select_d2 custom_modal_form_d2'>
                                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                                <label className="form_label invisible">IP Lists </label>
                                                                                <Link className='Supported_macros_text'
                                                                                    style={{ cursor: "pointer" }}
                                                                                    to="/ipListGam"
                                                                                    target="_blank"
                                                                                >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                        <path d="M8 3.33325V12.6666" stroke="#4F44E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M3.33398 8H12.6673" stroke="#4F44E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </svg>
                                                                                    Add New
                                                                                </Link>
                                                                            </div>
                                                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                                {ipListMode === "DISABLED" ?
                                                                                    <Select

                                                                                        className='form_select basic no_search'
                                                                                        // placeholder="-Select-"
                                                                                        optionFilterProp="label"
                                                                                        disabled
                                                                                    />
                                                                                    :
                                                                                    <Select
                                                                                        id="ipList"
                                                                                        value={ipList}
                                                                                        // disabled={true}
                                                                                        popupClassName='diff_select_d2 --full'
                                                                                        // open={true}
                                                                                        showSearch={false}
                                                                                        placeholder='- Select -'
                                                                                        className="form_select basic "
                                                                                        mode='multiple'
                                                                                        maxTagCount='responsive'
                                                                                        dropdownRender={menu => (
                                                                                            <>
                                                                                                <div className="custom_inside_searchbar_d2">
                                                                                                    <Input placeholder="Search" value={searchIpList} onChange={handleSearchIpList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                                </div>
                                                                                                <div className='select_all_d2'
                                                                                                    onClick={() => handleSelectAllIpList()}
                                                                                                >
                                                                                                    <Checkbox
                                                                                                        checked={ipList?.length === ipListOptions?.length}
                                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                                    >
                                                                                                        Select All
                                                                                                    </Checkbox>
                                                                                                </div>

                                                                                                {menu}
                                                                                            </>
                                                                                        )}
                                                                                    >
                                                                                        {[
                                                                                            ...filterIpList?.filter(option => ipList?.includes(option.value)), // Checked options first
                                                                                            ...filterIpList?.filter(option => !ipList?.includes(option.value)) // Unchecked options next
                                                                                        ].map(option => (
                                                                                            <Option key={option.value} value={option.value}>
                                                                                                <div
                                                                                                    onClick={() => handleIpList(option.value)}
                                                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                                                >
                                                                                                    <Checkbox
                                                                                                        checked={ipList?.includes(option.value)}
                                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                                    >
                                                                                                        {option.label}
                                                                                                    </Checkbox>
                                                                                                </div>
                                                                                            </Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                }
                                                                            </div>
                                                                            <span className="error_content">{ipListMode !== "DISABLED" && ipListIsRequiredError && <>Please disable this mode if you don't want to use it at the moment.</>} </span>
                                                                        </Col>
                                                                    </Row>
                                                                </div>

                                                                <div className="form_content_block--group  hide_caret_after_select_value" >
                                                                    <Row gutter={8}>
                                                                        <Col span={7}>
                                                                            <label className="form_label">Domains List *</label>
                                                                            <Select
                                                                                className='form_select basic no_search'
                                                                                placeholder="-Select-"
                                                                                optionFilterProp="label"
                                                                                onChange={onChangeDomainListMode}
                                                                                value={domainListMode}
                                                                                options={domainListModeOptions}
                                                                                disabled
                                                                            />
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                        <Col span={17} className='disabled_ant_select_d2'>
                                                                            <label className="form_label invisible">Domains List </label>
                                                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                                {
                                                                                    domainListMode === "DISABLED" ?
                                                                                        <Select

                                                                                            className='form_select basic no_search'
                                                                                            // placeholder="-Select-"
                                                                                            optionFilterProp="label"
                                                                                            disabled
                                                                                        />
                                                                                        :
                                                                                        <>
                                                                                            <Select
                                                                                                id="domainList"
                                                                                                value={domainList}
                                                                                                // disabled={true}
                                                                                                popupClassName='diff_select_d2 --full '
                                                                                                // open={true}
                                                                                                showSearch={false}
                                                                                                placeholder='- Select -'
                                                                                                className={domainListIsRequiredError ? "form_select basic error " : "form_select basic "}
                                                                                                mode='multdomainle'
                                                                                                maxTagCount='responsive'
                                                                                                dropdownRender={menu => (
                                                                                                    <>
                                                                                                        <div className="custom_inside_searchbar_d2">
                                                                                                            <Input placeholder="Search" value={searchDomainList} onChange={handleSearchDomainList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                                        </div>
                                                                                                        <div className='select_all_d2'
                                                                                                            onClick={() => handleSelectAllDomainList()}
                                                                                                        >
                                                                                                            <Checkbox
                                                                                                                checked={domainList?.length === domainListOptions?.length}
                                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                                            >
                                                                                                                Select All
                                                                                                            </Checkbox>
                                                                                                        </div>

                                                                                                        {menu}
                                                                                                    </>
                                                                                                )}
                                                                                            >
                                                                                                {[
                                                                                                    ...filterDomainList?.filter(option => domainList?.includes(option.value)), // Checked options first
                                                                                                    ...filterDomainList?.filter(option => !domainList?.includes(option.value)) // Unchecked options next
                                                                                                ].map(option => (
                                                                                                    <Option key={option.value} value={option.value}>
                                                                                                        <div
                                                                                                            onClick={() => handleDomainList(option.value)}
                                                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                                                        >
                                                                                                            <Checkbox
                                                                                                                checked={domainList?.includes(option.value)}
                                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                                            >
                                                                                                                {option.label}
                                                                                                            </Checkbox>
                                                                                                        </div>
                                                                                                    </Option>
                                                                                                ))}
                                                                                            </Select>
                                                                                            <span className="error_content">{domainListIsRequiredError && <>Minimum 1 selection is required</>} </span>
                                                                                        </>
                                                                                }
                                                                            </div>
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                                    <Row gutter={8}>
                                                                        <Col span={7}>
                                                                            <label className="form_label">Extended User List </label>
                                                                            <Select

                                                                                className='form_select basic no_search'
                                                                                optionFilterProp="label"
                                                                                onChange={onChangeExtendedUserListMode}
                                                                                value={extendedUserListMode}
                                                                                options={extendedUserListModeOptions}
                                                                            />
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                        <Col span={17} className='disabled_ant_select_d2 custom_modal_form_d2'>
                                                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                                <div className='d-flex align-items-center justify-content-between'>
                                                                                    <label className="form_label invisible">Extended User List</label>
                                                                                    <Link className='Supported_macros_text'
                                                                                        style={{ cursor: "pointer" }}
                                                                                        to="/extendedUserListGam"
                                                                                        target="_blank"
                                                                                    >
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                            <path d="M8 3.33325V12.6666" stroke="#4F44E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            <path d="M3.33398 8H12.6673" stroke="#4F44E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        </svg>
                                                                                        Add New
                                                                                    </Link>
                                                                                </div>
                                                                                {extendedUserListMode === "DISABLED" ?
                                                                                    <Select

                                                                                        className='form_select basic no_search'
                                                                                        // placeholder="-Select-"
                                                                                        optionFilterProp="label"
                                                                                        disabled
                                                                                    />
                                                                                    :
                                                                                    <Select
                                                                                        id="extendedUserList"
                                                                                        value={extendedUserList}
                                                                                        // disabled={true}
                                                                                        popupClassName='diff_select_d2 --full'
                                                                                        // open={true}
                                                                                        showSearch={false}
                                                                                        placeholder='- Select -'
                                                                                        className="form_select basic"
                                                                                        mode='multiple'
                                                                                        maxTagCount='responsive'
                                                                                        dropdownRender={menu => (
                                                                                            <>
                                                                                                <div className="custom_inside_searchbar_d2">
                                                                                                    <Input placeholder="Search" value={searchExtendedUserList} onChange={handleSearchExtendedUserList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                                </div>
                                                                                                <div className='select_all_d2'
                                                                                                    onClick={() => handleSelectAllExtendedUserList()}
                                                                                                >
                                                                                                    <Checkbox
                                                                                                        checked={extendedUserList?.length === extendedUserListOptions?.length}
                                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                                    >
                                                                                                        Select All
                                                                                                    </Checkbox>
                                                                                                </div>

                                                                                                {menu}
                                                                                            </>
                                                                                        )}
                                                                                    >
                                                                                        {[
                                                                                            ...filterExtendedUserList?.filter(option => extendedUserList?.includes(option.value)), // Checked options first
                                                                                            ...filterExtendedUserList?.filter(option => !extendedUserList?.includes(option.value)) // Unchecked options next
                                                                                        ].map(option => (
                                                                                            <Option key={option.value} value={option.value}>
                                                                                                <div
                                                                                                    onClick={() => handleExtendedUserList(option.value)}
                                                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                                                >
                                                                                                    <Checkbox
                                                                                                        checked={extendedUserList?.includes(option.value)}
                                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                                    >
                                                                                                        {option.label}
                                                                                                    </Checkbox>
                                                                                                </div>
                                                                                            </Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                }
                                                                                <span className="error_content">{extendedUserListMode !== "DISABLED" && extendedUserListIsRequiredError && <>Please disable this mode if you don't want to use it at the moment.</>} </span>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                                    <Row gutter={8}>
                                                                        <Col span={7}>
                                                                            <label className="form_label">App Bundle Lists </label>
                                                                            <Select

                                                                                className='form_select basic no_search'
                                                                                optionFilterProp="label"
                                                                                onChange={onChangeAppBundleListMode}
                                                                                value={appBundleListMode}
                                                                                options={appBundleListModeOptions}
                                                                            />
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                        <Col span={17} className='disabled_ant_select_d2 custom_modal_form_d2'>
                                                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                                <div className='d-flex align-items-center justify-content-between'>
                                                                                    <label className="form_label invisible">App Bundle Lists </label>
                                                                                    <Link className='Supported_macros_text'
                                                                                        style={{ cursor: "pointer" }}
                                                                                        to="/appBundleListGam"
                                                                                        target="_blank"
                                                                                    >
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                            <path d="M8 3.33325V12.6666" stroke="#4F44E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            <path d="M3.33398 8H12.6673" stroke="#4F44E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        </svg>
                                                                                        Add New
                                                                                    </Link>
                                                                                </div>
                                                                                {appBundleListMode === "DISABLED" ?
                                                                                    <Select

                                                                                        className='form_select basic no_search'
                                                                                        // placeholder="-Select-"
                                                                                        optionFilterProp="label"
                                                                                        disabled
                                                                                    />
                                                                                    :
                                                                                    <Select
                                                                                        id="appBundleList"
                                                                                        value={appBundleList}
                                                                                        // disabled={true}
                                                                                        popupClassName='diff_select_d2 --full'
                                                                                        // open={true}
                                                                                        showSearch={false}
                                                                                        placeholder='- Select -'
                                                                                        className="form_select basic"
                                                                                        mode='multiple'
                                                                                        maxTagCount='responsive'
                                                                                        dropdownRender={menu => (
                                                                                            <>
                                                                                                <div className="custom_inside_searchbar_d2">
                                                                                                    <Input placeholder="Search" value={searchAppBundleList} onChange={handleSearchAppBundleList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                                </div>
                                                                                                <div className='select_all_d2'
                                                                                                    onClick={() => handleSelectAllAppBundleList()}
                                                                                                >
                                                                                                    <Checkbox
                                                                                                        checked={appBundleList?.length === appBundleListOptions?.length}
                                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                                    >
                                                                                                        Select All
                                                                                                    </Checkbox>
                                                                                                </div>

                                                                                                {menu}
                                                                                            </>
                                                                                        )}
                                                                                    >
                                                                                        {[
                                                                                            ...filterAppBundleList?.filter(option => appBundleList?.includes(option.value)), // Checked options first
                                                                                            ...filterAppBundleList?.filter(option => !appBundleList?.includes(option.value)) // Unchecked options next
                                                                                        ].map(option => (
                                                                                            <Option key={option.value} value={option.value}>
                                                                                                <div
                                                                                                    onClick={() => handleAppBundleList(option.value)}
                                                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                                                >
                                                                                                    <Checkbox
                                                                                                        checked={appBundleList?.includes(option.value)}
                                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                                    >
                                                                                                        {option.label}
                                                                                                    </Checkbox>
                                                                                                </div>
                                                                                            </Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                }
                                                                                <span className="error_content">{appBundleListMode !== "DISABLED" && appBundleListIsRequiredError && <>Please disable this mode if you don't want to use it at the moment.</>} </span>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                                <div className="form_content_block--group">
                                                                    <Row gutter={8}>
                                                                        <Col span={7}>
                                                                            <label className="form_label">Site Ids List Mode </label>
                                                                            <Select
                                                                                className='form_select basic no_search'
                                                                                placeholder="-Select-"
                                                                                optionFilterProp="label"
                                                                                onChange={onChangeSiteIdListMode}
                                                                                value={siteIdListMode}
                                                                                options={siteIdListModeOptions}
                                                                            />
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                        <Col span={17}>
                                                                            <div className="form_content_block--group mb-0">
                                                                                <label className="form_label invisible">Site Ids List Mode </label>
                                                                                {
                                                                                    siteIdListMode === "DISABLED" ?
                                                                                        <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                                                        :
                                                                                        <>
                                                                                            <TextArea autocomplete="off" placeholder='' className={siteIdListIsRequiredError ? 'form_control basic form_control_h textarea_paddingY_d2 error --120' : 'form_control basic form_control_h textarea_paddingY_d2 --120'}
                                                                                                value={siteIdList}
                                                                                                onChange={onChangeSiteIdList}
                                                                                                onBlur={onBlurSiteIdList}
                                                                                            />
                                                                                            <span className="error_content">{siteIdListIsRequiredError && <> Please disable this mode if you don't want to use it at the moment.</>}</span>
                                                                                        </>

                                                                                }
                                                                            </div>
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                                <div className="form_content_block--group">
                                                                    <Row gutter={8}>
                                                                        <Col span={7}>
                                                                            <label className="form_label">App Bundles List </label>
                                                                            <Select
                                                                                className='form_select basic no_search'
                                                                                placeholder="-Select-"
                                                                                optionFilterProp="label"
                                                                                onChange={onChangeAppBundleTextListMode}
                                                                                value={appBundleTextListMode}
                                                                                options={appBundleTextListModeOptions}
                                                                            />
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                        <Col span={17}>
                                                                            <div className="form_content_block--group mb-0">
                                                                                <label className="form_label invisible">App Bundles List </label>
                                                                                {
                                                                                    appBundleTextListMode === "DISABLED" ?
                                                                                        <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                                                        :
                                                                                        <>
                                                                                            <TextArea autocomplete="off" placeholder='' className={appBundleTextListIsRequiredError || appBundleTextListValidError ? 'form_control basic form_control_h textarea_paddingY_d2 error --120' : 'form_control basic form_control_h textarea_paddingY_d2 --120'}
                                                                                                value={appBundleTextList}
                                                                                                onChange={onChangeAppBundleTextList}
                                                                                                onBlur={onBlurAppBundleTextList}
                                                                                            />
                                                                                            <span className="error_content">
                                                                                                {appBundleTextListIsRequiredError && <> Please disable this mode if you don't want to use it at the moment.</>}
                                                                                                {appBundleTextListValidError && <> Invalid app bundles list. One valid app bundle per line expected.</>}
                                                                                            </span>
                                                                                        </>

                                                                                }
                                                                            </div>
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                                <div className="form_content_block--group">
                                                                    <Row gutter={8}>
                                                                        <Col span={7}>
                                                                            <label className="form_label">App Ids List </label>
                                                                            <Select

                                                                                className='form_select basic no_search'
                                                                                placeholder="-Select-"
                                                                                optionFilterProp="label"
                                                                                onChange={onChangeAppIdListMode}
                                                                                value={appIdListMode}
                                                                                options={appIdListModeOptions}
                                                                            />
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                        <Col span={17}>
                                                                            <div className="form_content_block--group mb-0">
                                                                                <label className="form_label invisible">App Ids List </label>
                                                                                {
                                                                                    appIdListMode === "DISABLED" ?
                                                                                        <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                                                        :
                                                                                        <>
                                                                                            <TextArea autocomplete="off" placeholder="" className={appIdListIsRequiredError ? 'form_control basic form_control_h textarea_paddingY_d2 error --120' : 'form_control basic form_control_h textarea_paddingY_d2 --120'}
                                                                                                value={appIdList}
                                                                                                onChange={onChangeAppIdList}
                                                                                                onBlur={onBlurAppIdList}
                                                                                            />
                                                                                            <span className="error_content">{appIdListIsRequiredError && <> Please disable this mode if you don't want to use it at the moment.</>}</span>
                                                                                        </>

                                                                                }
                                                                            </div>
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                                <div className="form_content_block--group ">
                                                                    <Row gutter={8}>
                                                                        <Col span={7}>
                                                                            <label className="form_label">Publishers List </label>
                                                                            <Select

                                                                                className='form_select basic no_search'
                                                                                placeholder="-Select-"
                                                                                optionFilterProp="label"
                                                                                onChange={onChangePublisherIdListMode}
                                                                                value={publisherIdListMode}
                                                                                options={publisherIdListModeOptions}
                                                                            />
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                        <Col span={17}>
                                                                            <div className="form_content_block--group mb-0">
                                                                                <label className="form_label invisible">Publishers List </label>
                                                                                {
                                                                                    publisherIdListMode === "DISABLED" ?
                                                                                        <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                                                        :
                                                                                        <>
                                                                                            <TextArea autocomplete="off" placeholder="" className={publisherIdListIsRequiredError ? 'form_control basic form_control_h textarea_paddingY_d2 error --120' : 'form_control basic form_control_h textarea_paddingY_d2 --120'}
                                                                                                value={publisherIdList}
                                                                                                onChange={onChangePublisherIdList}
                                                                                                onBlur={onBlurPublisherIdList}
                                                                                            />
                                                                                            <span className="error_content">{publisherIdListIsRequiredError && <> Please disable this mode if you don't want to use it at the moment.</>}</span>
                                                                                        </>

                                                                                }

                                                                            </div>
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                                <div className="form_content_block--group">
                                                                    <div className="primary_checkbox">
                                                                        <Checkbox id="checkbox_non_empty_publisher_id" name="checkbox_non_empty_publisher_id"
                                                                            checked={checkbox_non_empty_publisher_id}
                                                                            onChange={onChangeCheckbox_non_empty_publisher_id}
                                                                        >
                                                                            <span className="form_label">
                                                                                Non-empty publisher ID
                                                                            </span>
                                                                        </Checkbox>
                                                                    </div>
                                                                </div>
                                                                <div className="form_content_block--group mb-0">
                                                                    <Row gutter={8}>
                                                                        <Col span={7}>
                                                                            <label className="form_label">Tag Ids List </label>
                                                                            <Select
                                                                                className='form_select basic no_search'
                                                                                placeholder="-Select-"
                                                                                optionFilterProp="label"
                                                                                onChange={onChangeTagIdListMode}
                                                                                value={tagIdListMode}
                                                                                options={tagIdListModeOptions}
                                                                            />
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                        <Col span={17}>
                                                                            <div className="form_content_block--group mb-0">
                                                                                <label className="form_label invisible">Tag Ids List </label>
                                                                                {
                                                                                    tagIdListMode === "DISABLED" ?
                                                                                        <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                                                        :
                                                                                        <>
                                                                                            <TextArea autocomplete="off" placeholder=""
                                                                                                className={tagIdListIsRequiredError ? 'form_control basic form_control_h textarea_paddingY_d2 error --120' : 'form_control basic form_control_h textarea_paddingY_d2 --120'}
                                                                                                value={tagIdList}
                                                                                                onChange={onChangeTagIdList}
                                                                                                onBlur={onBlurTagIdList}
                                                                                            />
                                                                                            <span className="error_content"> {tagIdListIsRequiredError && <> Please disable this mode if you don't want to use it at the moment.</>}</span>
                                                                                        </>

                                                                                }


                                                                            </div>
                                                                            <span className="error_content"> </span>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>

                                        </div >

                                        <div className="hr_custom mb_20"></div>
                                        <div className="btn_group justify-content-end gap_8 pb_50">
                                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={() => { handleBackView(1) }}> Back </button>
                                            <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleTargetingValidations} >Next</button>

                                        </div >
                                    </div>

                                    :
                                    <div

                                        className="container_box--content pt_20 form_scrollable_div_d2">
                                        <div className="container_box--width w-100 px-3" ref={scrollTopCreativeRef}>
                                            <Row gutter={16}>
                                                <Col span={5}>
                                                    <div className="container_box--label-info">
                                                        <label>Ad Creatives</label>
                                                    </div>
                                                </Col>

                                                <Col span={19}>
                                                    {creativeMainTableData?.length === 0 ?
                                                        <div className="container_box--form-container border-0 p-0">
                                                            <Row gutter={16}>
                                                                <Col span={24}>
                                                                    <div className="form_content_block--group new_file_uploader_d2 mb-0">
                                                                        <label for='fileUploader' className='ant_upload_drag' onClick={() => {
                                                                            setModalCreativeType("create"); showModalCreative(); setDomain_html(domain_html_ViaCategory);
                                                                            if (campaignType === "Banner") {
                                                                                setName_html("Banner_" + new Date().toLocaleDateString('en-GB', {
                                                                                    day: '2-digit',
                                                                                    month: '2-digit',
                                                                                    year: '2-digit'
                                                                                }))
                                                                            }
                                                                            else {
                                                                                setName_html("IBV_" + new Date().toLocaleDateString('en-GB', {
                                                                                    day: '2-digit',
                                                                                    month: '2-digit',
                                                                                    year: '2-digit'
                                                                                }))
                                                                                setSize_html(3)
                                                                            }

                                                                        }}>
                                                                            <p className="upload_drag_icon"> <img src={uploadIcon} alt='USP' /> </p>
                                                                            <p className="ant_upload_text"><b className="primary">Add Creative </b></p>
                                                                        </label>
                                                                        {/* <input className='form_upload d-none' type="file" id="fileUploader" name="fileUploader" /> */}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        :
                                                        <div>
                                                            <div className="d_flex align-items-center justify_content_between w-100 mb_10">
                                                                <div className='form_content_block--group'>
                                                                    <Input
                                                                        className='form_control basic md search_input w_table_search'
                                                                        placeholder="Search Name"
                                                                        value={creativeMainTableSearch}
                                                                        onChange={handleCreativeMainTableSearch}
                                                                    />
                                                                </div>
                                                                <button className='btn btn_primary w_fit_content md'
                                                                    onClick={() => {
                                                                        setModalCreativeType("create"); showModalCreative(); setDomain_html(domain_html_ViaCategory); if (campaignType === "Banner") {
                                                                            setName_html("Banner_" + new Date().toLocaleDateString('en-GB', {
                                                                                day: '2-digit',
                                                                                month: '2-digit',
                                                                                year: '2-digit'
                                                                            }))
                                                                        }
                                                                        else {
                                                                            setName_html("IBV_" + new Date().toLocaleDateString('en-GB', {
                                                                                day: '2-digit',
                                                                                month: '2-digit',
                                                                                year: '2-digit'
                                                                            }))
                                                                            setSize_html(3)
                                                                        }
                                                                    }}
                                                                >
                                                                    <span><img src={addIcon} alt='USP' /> Upload </span>
                                                                </button>
                                                            </div>
                                                            <div className="table_content--box form_table_design_d2">
                                                                {campaignType === "Banner" ?
                                                                    <Table
                                                                        columns={creativeMainTableColumnsBanner}
                                                                        dataSource={filterDataCreativeMainTable}
                                                                        pagination={false}
                                                                        scroll={{ x: 'max-content', y: 'calc(100vh - 32rem' }}
                                                                    /> :
                                                                    <Table
                                                                        columns={creativeMainTableColumnsIBV}
                                                                        dataSource={filterDataCreativeMainTable}
                                                                        pagination={false}
                                                                        scroll={{ x: 'min-content', y: 'calc(100vh - 32rem' }}
                                                                    />
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                </Col>
                                            </Row>
                                        </div >
                                        <div className="hr_custom mb_20"></div>
                                        <div className="btn_group justify-content-end gap_8 pb_50">
                                            {buttonProcessing ?
                                                <>
                                                    <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                                        disabled
                                                    >
                                                        Back
                                                    </button>
                                                    <button
                                                        className="w_120_d2 btn btn_primary w_fit_content loader"

                                                    >
                                                        <span>Create </span>

                                                        <img
                                                            src={loaderIcon}
                                                            alt="USP"
                                                            className="loader_icon"
                                                        />
                                                    </button>
                                                </> :
                                                <>
                                                    <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={() => { handleBackView(2) }}> Back </button>
                                                    <button className="w_120_d2 btn btn_primary w_fit_content" onClick={() => { handleFinalPayload() }}>Create</button>


                                                </>}
                                        </div>
                                    </div >


                        }

                    </>
                }


                {/* // ---------------------------------------------------------------------------------------------------------------------------------------//
    // -----------------------------------------  Creative Code Ends ---------------------------------------------------------------------------//
    // ---------------------------------------------------------------------------------------------------------------------------------------// */}




                <Modal
                    className='custom_modal custom_modal_form_d2' onCancel={handleCancelCreativeModal}
                    title={<div className='custom_modal--header'><h3 className='heading'><img src={CreativeIcon} alt='USP' />{modalCreativeType === "create" ? <>Add Creative</> : modalCreativeType === "edit" ? <>Edit Creative</> : <>Clone Creative</>} </h3>
                    </div>}
                    closable={true} // This removes the default close button
                    visible={isModalCreativeVisible}
                    maskClosable={false}
                    width={770}
                    footer={[
                        <div className="custom_modal--footer d_flex justify_content_end gap_8">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={handleCancelCreativeModal}> Discard </button>
                            <button key="submit" className='btn btn_primary w_fit_content' onClick={handleCreativeValidations}>
                                {modalCreativeType === "edit" ? <>Update</> : <>Submit</>}
                            </button>
                        </div>
                    ]}>
                    <div className="custom_modal--body">
                        <div className="tab_content--body">
                            <div className="container_box--width w-100">
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Creative Type *</label>
                                    <Select
                                        className='form_select basic no_search'
                                        placeholder=""
                                        optionFilterProp="label"
                                        options={creativeTypeOptions}
                                        value={creativeType}
                                        disabled
                                    />
                                    <span className="error_content"> </span>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2" ref={creativeNameRef}>
                                    <label className="form_label">Name *</label>
                                    <Input className={name_htmlIsRequiredError ? 'form_control basic error ' : 'form_control basic '} placeholder='' autocomplete="off"
                                        value={name_html}
                                        onChange={onChangeName_html}
                                        onBlur={onBlurName_html}
                                    />
                                    <span className="error_content">
                                        {name_htmlIsRequiredError && (
                                            <>
                                                This field is required
                                            </>
                                        )}
                                    </span>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <label className="form_label">Destination URL *</label>
                                        <span className='Supported_macros_text'
                                            style={{ cursor: "pointer" }}
                                            onClick={showModalMacros}
                                        >Supported macros</span>
                                    </div>
                                    <Input
                                        className={!thirdparty_html && (destinationurl_htmlValidError || destinationurl_htmlIsRequiredError) ? 'form_control basic error ' : 'form_control basic'}
                                        placeholder='https://' autocomplete="off"
                                        value={destinationurl_html}
                                        disabled={thirdparty_html}
                                        onChange={onChangeDestinationurl_html}
                                        onBlur={onBlurDestinationurl_html}
                                    />
                                    <span className="error_content">
                                        {!thirdparty_html && (
                                            <>
                                                {destinationurl_htmlIsRequiredError && (
                                                    <>
                                                        This field is required{" "}
                                                        <br />
                                                    </>
                                                )}
                                            </>
                                        )}
                                        {!thirdparty_html && (
                                            <>
                                                {destinationurl_htmlValidError && (
                                                    <>
                                                        Invalid Url{" "}
                                                    </>
                                                )}
                                            </>
                                        )}

                                    </span>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2" ref={creativeDomainListRef}>
                                    <label className="form_label">Ad domains *</label>
                                    <TextArea
                                        autocomplete="off"
                                        className={domain_htmlIsRequiredError || domain_htmlValidError ? 'form_control basic form_control_h textarea_paddingY_d2 error' : 'form_control basic form_control_h textarea_paddingY_d2'}
                                        placeholder='Enter ad domains, separated by comma'
                                        value={domain_html}
                                        onChange={onChangeDomain_html}
                                        onBlur={onBlurDomain_html}
                                    />
                                    <span className="error_content">{domain_htmlIsRequiredError && <>This field is required</>}
                                        {domain_htmlValidError && <>Invalid Domain</>}
                                    </span>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">App Bundle </label>
                                    <TextArea
                                        autocomplete="off"
                                        className={appbundle_htmlCharError ? 'form_control basic form_control_h textarea_paddingY_d2 error' : 'form_control basic form_control_h textarea_paddingY_d2'}
                                        placeholder="App Bundle"
                                        value={appbundle_html}
                                        onChange={onChangeAppbundle_html}
                                        onBlur={onBlurAppbundle_html}
                                    />
                                    <span className="error_content"> {appbundle_htmlCharError && (
                                        <>
                                            Maximum {MsgNumberAppbundle} characters are allowed{" "}
                                        </>
                                    )} </span>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                        <label className="form_label">Position *</label>
                                        <Select
                                            id="position_html"
                                            value={position_html}
                                            // disabled={true}
                                            popupClassName='diff_select_d2 --full'
                                            // open={true}
                                            showSearch={false}
                                            placeholder='- Select -'
                                            className={positionIsRequiredError_html ? "form_select basic error" : "form_select basic"}
                                            mode='multiple'
                                            maxTagCount='responsive'
                                            dropdownRender={menu => (
                                                <>
                                                    <div className="custom_inside_searchbar_d2">
                                                        <Input placeholder="Search" value={searchPosition_html} onChange={handleSearchPosition_html} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                    </div>
                                                    <div className='select_all_d2'
                                                        onClick={() => handleSelectAllPosition_html()}
                                                    >
                                                        <Checkbox
                                                            checked={position_html?.length === position_htmlOptions?.length}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            Select All
                                                        </Checkbox>
                                                    </div>

                                                    {menu}
                                                </>
                                            )}
                                        >
                                            {[
                                                ...filterPosition_html?.filter(option => position_html?.includes(option.value)), // Checked options first
                                                ...filterPosition_html?.filter(option => !position_html?.includes(option.value)) // Unchecked options next
                                            ].map(option => (
                                                <Option key={option.value} value={option.value}>
                                                    <div
                                                        onClick={() => handlePosition_html(option.value)}
                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                    >
                                                        <Checkbox
                                                            checked={position_html?.includes(option.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            {option.label}
                                                        </Checkbox>
                                                    </div>
                                                </Option>
                                            ))}
                                        </Select>
                                        <span className="error_content">{positionIsRequiredError_html && <>Minimum 1 selection is required</>} </span>

                                    </div>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <div className="primary_checkbox">
                                        <Checkbox id="interstitial_html" name="interstitial_html"
                                            checked={interstitial_html}
                                            onChange={onChangeInterstitial_html}
                                        >
                                            <span className="form_label">
                                                Interstitial
                                            </span>
                                        </Checkbox>
                                    </div>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                        <label className="form_label">Attributes </label>
                                        <Select
                                            id="attribute_html"
                                            value={attribute_html}
                                            // disabled={true}
                                            popupClassName='diff_select_d2 --full'
                                            // open={true}
                                            showSearch={false}
                                            placeholder='- Select -'
                                            className="form_select basic"
                                            mode='multiple'
                                            maxTagCount='responsive'
                                            dropdownRender={menu => (
                                                <>
                                                    <div className="custom_inside_searchbar_d2">
                                                        <Input placeholder="Search" value={searchAttribute_html} onChange={handleSearchAttribute_html} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                    </div>
                                                    <div className='select_all_d2'
                                                        onClick={() => handleSelectAllAttribute_html()}
                                                    >
                                                        <Checkbox
                                                            checked={attribute_html?.length === attribute_htmlOptions?.length}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            Select All
                                                        </Checkbox>
                                                    </div>

                                                    {menu}
                                                </>
                                            )}
                                        >
                                            {[
                                                ...filterAttribute_html?.filter(option => attribute_html?.includes(option.value)), // Checked options first
                                                ...filterAttribute_html?.filter(option => !attribute_html?.includes(option.value)) // Unchecked options next
                                            ].map(option => (
                                                <Option key={option.value} value={option.value}>
                                                    <div
                                                        onClick={() => handleAttribute_html(option.value)}
                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                    >
                                                        <Checkbox
                                                            checked={attribute_html?.includes(option.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            {option.label}
                                                        </Checkbox>
                                                    </div>
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2" ref={creativeImpressionRef}>
                                    <label className="form_label">Impression pixels </label>
                                    <TextArea
                                        autocomplete="off"
                                        className={impressionpixel_htmlCharError || impressionpixel_htmlValidError ? 'form_control basic form_control_h textarea_paddingY_d2 error' : 'form_control basic form_control_h textarea_paddingY_d2'}
                                        placeholder="One Impression Tracker per line"
                                        value={impressionpixel_html}
                                        onChange={onChangeImpressionpixel_html}
                                        onBlur={onBlurImpressionpixel_html}
                                    />
                                    <span className="error_content">
                                        {impressionpixel_htmlCharError && (
                                            <>
                                                Maximum {MsgNumberImpression} characters are allowed{" "}
                                            </>
                                        )}

                                        {impressionpixel_htmlValidError &&
                                            !impressionpixel_htmlCharError && (
                                                <>
                                                    Please provide valid HTTPS URL/s or
                                                    ensure no spacing among them{" "}
                                                </>
                                            )}
                                    </span>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">JS Trackers </label>
                                    <TextArea
                                        autocomplete="off"
                                        className={jstracker_htmlCharError || jstracker_htmlValidError ? 'form_control basic form_control_h textarea_paddingY_d2 error' : 'form_control basic form_control_h textarea_paddingY_d2'}
                                        placeholder="One Js Tracker per line"
                                        value={jstracker_html}
                                        onChange={onChangeJstracker_html}
                                        onBlur={onBlurJstracker_html}
                                    />
                                    <span className="error_content">
                                        {jstracker_htmlCharError && (
                                            <>
                                                Maximum {MsgNumberJstracker} characters are allowed{" "}
                                            </>
                                        )}

                                        {jstracker_htmlValidError &&
                                            !jstracker_htmlCharError && (
                                                <>
                                                    Please provide valid HTTPS URL/s or
                                                    ensure no spacing among them{" "}
                                                </>
                                            )}
                                    </span>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Size *</label>
                                    <Select
                                        showSearch
                                        className={size_htmlIsRequiredError ? 'form_select basic error ' : 'form_select basic '}
                                        placeholder="-Select-"
                                        optionFilterProp="label"
                                        options={sizeOptions_html}
                                        value={size_html}
                                        onChange={onChangeSize_html}
                                    />
                                    <span className="error_content">{size_htmlIsRequiredError && <>This field is required</>} </span>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <div className="primary_checkbox">
                                        <Checkbox id="thirdparty_html" name="thirdparty_html"
                                            checked={thirdparty_html}
                                            onChange={onChangeThirdparty_html}
                                        >
                                            <span className="form_label">
                                                3rd party
                                            </span>
                                        </Checkbox>
                                    </div>
                                </div>
                                {/* <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <div className="primary_checkbox">
                                    <Checkbox id="secure_html" name="secure_html"
                                        checked={secure_html}
                                        onChange={onChangeSecure_html}
                                    >
                                        <span className="form_label">
                                            Secure
                                        </span>
                                    </Checkbox>
                                </div>
                            </div> */}
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Template *</label>
                                    <Select
                                        open={isDropdownOpenTemplate} // Controlled open state for Select dropdown
                                        onDropdownVisibleChange={(open) => setIsDropdownOpenTemplate(open)} // Track dropdown visibility
                                        showSearch
                                        className={template_htmlIsRequiredError ? "form_select basic  error" : "form_select basic "}
                                        // placeholder="-Select-"
                                        value={template_html}
                                        onChange={onChangeTemplate_html}
                                        optionFilterProp="label"
                                        dropdownRender={(menu) => (
                                            <>
                                                {campaignType === "IBV" ? <></> :
                                                    <div
                                                        style={{
                                                            padding: '8px',
                                                            cursor: 'pointer',
                                                            color: '#9254de',
                                                            borderBottom: '1px solid #f0f0f0',
                                                        }}
                                                        onClick={openTemplateModal}
                                                    >
                                                        + New Template
                                                    </div>
                                                }

                                                {menu}
                                            </>
                                        )}
                                        options={campaignType === "IBV" ? templateOptions_ibv_html : templateOptions_html}
                                    />
                                    <span className="error_content">{template_htmlIsRequiredError && <>This field is required</>} </span>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Banner *</label>
                                    <TextArea autocomplete="off" placeholder=''
                                        className='form_control basic form_control_h --160 textarea_paddingY_d2'
                                        // className={text_htmlIsRequiredError || text_htmlValidError ? 'form_control basic form_control_h --160 textarea_paddingY_d2 error' : 'form_control basic form_control_h --160 textarea_paddingY_d2'}
                                        value={text_html}
                                        onChange={onChangeText_html}
                                        onBlur={onBlurText_html}
                                        disabled

                                    />
                                    <span className="error_content">

                                        {text_htmlIsRequiredError && (
                                            <>
                                                This field is required
                                            </>
                                        )}
                                        {text_htmlValidError && (
                                            <>
                                                Invalid Script Format
                                            </>
                                        )}
                                    </span>
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2 hide_caret_after_select_value">
                                    <Row gutter={8}>
                                        <Col span={7}>
                                            <label className="form_label">App Bundles List </label>
                                            <Select
                                                className='form_select basic no_search'
                                                placeholder="-Select-"
                                                optionFilterProp="label"
                                                onChange={onChangeBundleList_htmlMode}
                                                value={bundleList_htmlMode}
                                                options={bundleList_htmlModeOptions}
                                            />
                                            <span className="error_content"> </span>
                                        </Col>
                                        <Col span={17}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label invisible">App Bundles List </label>
                                                {
                                                    bundleList_htmlMode === "DISABLED" ?
                                                        <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                        :
                                                        <>
                                                            <TextArea autocomplete="off" placeholder="One App Bundle per line" className={bundleList_html_IsRequiredError || bundleList_html_Error ? 'form_control basic form_control_h textarea_paddingY_d2 error  --120' : 'form_control basic form_control_h textarea_paddingY_d2 --120'}
                                                                value={bundleList_html}
                                                                onChange={onChangeBundleList_html}
                                                                onBlur={onBlurBundleList_html}
                                                            />
                                                            <span className="error_content">
                                                                {bundleList_html_IsRequiredError && <> Please disable this mode if you don't want to use it at the moment.</>}
                                                                {bundleList_html_Error && <> Invalid app bundles list. One valid app bundle per line expected.</>}
                                                            </span>
                                                        </>

                                                }
                                            </div>
                                            <span className="error_content"> </span>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="form_content_block--group hide_caret_after_select_value">
                                    <Row gutter={8}>
                                        <Col span={7}>
                                            <label className="form_label">Domain List </label>
                                            <Select
                                                className='form_select basic no_search'
                                                placeholder="-Select-"
                                                optionFilterProp="label"
                                                onChange={onChangeDomainList_htmlMode}
                                                value={domainList_htmlMode}
                                                options={domainList_htmlModeOptions}
                                            />
                                            <span className="error_content"> </span>
                                        </Col>
                                        <Col span={17}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label invisible">Domain List </label>
                                                {
                                                    domainList_htmlMode === "DISABLED" ?
                                                        <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                                        :
                                                        <>
                                                            <TextArea autocomplete="off" placeholder="One Domain per line" className={domainList_html_IsRequiredError || domainList_html_Error ? 'form_control basic form_control_h textarea_paddingY_d2 error --120' : 'form_control basic form_control_h textarea_paddingY_d2 --120'}
                                                                value={domainList_html}
                                                                onChange={onChangeDomainList_html}
                                                                onBlur={onBlurDomainList_html}
                                                            />
                                                            <span className="error_content">
                                                                {domainList_html_IsRequiredError && <> Please disable this mode if you don't want to use it at the moment.</>}
                                                                {domainList_html_Error && <> Invalid domains list. One valid  domain per line expected.</>}
                                                            </span>
                                                        </>

                                                }
                                            </div>
                                            <span className="error_content"> </span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    className='custom_modal custom_modal_form_d2'
                    visible={isTemplateModalOpen}
                    onOk={closeTemplateModal}
                    width={770}
                    onCancel={closeTemplateModal}
                    maskClosable={false}
                    title={<div className='custom_modal--header'><h3 className='heading'><img src={creativetemicon} alt='USP' /> Create Template</h3>
                    </div>}
                    closable={true} // This removes the default close button
                    footer={[
                        <div className="custom_modal--footer d_flex justify_content_end">
                            <div className="btn_group justify-content-end gap_8">
                                <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeTemplateModal}> Discard </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleTemplateCreationValidation}>Create</button>
                            </div>
                        </div>
                    ]}>
                    <div className="custom_modal--body">
                        <div className="form_content_block--group modal_form_bottom_gap_d2">
                            <label className="form_label">Template Name * </label>
                            <Input className={nameTemplate_htmlIsRequiredError ? 'form_control basic error ' : 'form_control basic '} placeholder='' autocomplete="off"
                                value={nameTemplate_html}
                                onChange={onChangeNameTemplate_html}
                                onBlur={onBlurNameTemplate_html}
                            />
                            <span className="error_content">{nameTemplate_htmlIsRequiredError && <>This field is required</>} </span>
                        </div>
                        <div className="form_content_block--group">
                            <label className="form_label">Tag * </label>
                            <TextArea autocomplete="off" placeholder='' className={tagTemplate_htmlIsRequiredError ? 'form_control basic form_control_h --160 error textarea_paddingY_d2' : 'form_control basic form_control_h --160 textarea_paddingY_d2'}
                                value={tagTemplate_html}
                                onChange={onChangeTagTemplate_html}
                                onBlur={onBlurTagTemplate_html}
                            />
                            <span className="error_content"> {tagTemplate_htmlIsRequiredError && <>This field is required</>}</span>
                        </div>

                    </div>
                </Modal>

                <Modal
                    className='custom_modal custom_modal_form_d2'
                    visible={isModalVisibleMacros}
                    onOk={closeModalMacros}
                    width={780}
                    onCancel={closeModalMacros}
                    maskClosable={false}
                    title={
                        <div className='custom_modal--header'><h3 className='heading'><img src={macrosicon} alt='USP' /> Supported macros</h3>
                        </div>
                    }
                    closable={true} // This removes the default close button
                    footer={[
                        <div className="custom_modal--footer d_flex justify_content_end d-none">
                            <div className="btn_group justify-content-end gap_8">
                                <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeModalMacros}> Discard </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content">Create</button>
                            </div>
                        </div>
                    ]}
                >
                    <div className="custom_modal--body">
                        <div className='all_macros_tag_d2'>
                            <Row gutter={8}>
                                <Col span={12}>
                                    <ul>
                                        <li>&#123;creative_id&#125; – <span>creative id</span></li>
                                        <li>&#123;publisher_id&#125; – <span>publisher id</span></li>
                                        <li>&#123;exchange&#125; – <span>exchange</span></li>
                                        <li>&#123;domain&#125; – <span>domain (referrer)</span></li>
                                        <li>&#123;app_name&#125; – <span>application name</span></li>
                                        <li>&#123;site_id&#125; – <span>site id</span></li>
                                        <li>&#123;country&#125; – <span>country</span></li>
                                        <li>&#123;city&#125; – <span>city</span></li>
                                        <li>&#123;os&#125; – <span>os</span></li>
                                        <li>&#123;make&#125; – <span>make</span></li>
                                        <li>&#123;carrier&#125; – <span>carrier</span></li>
                                        <li>&#123;device_type&#125; – <span>device type</span></li>
                                        <li>&#123;ipv4_address&#125; – <span>ipv4 address</span></li>
                                        <li>&#123;cachebuster&#125; – <span>random number</span></li>
                                        <li>&#123;tagid&#125; – <span>imp.tagid parameter of bid request</span></li>
                                        <li>$&#123;GDPR_CONSENT_XXX&#125; – <span>base64-encoded GDPR consent string</span></li>
                                        <li>$&#123;ADDTL_CONSENT&#125; – <span>Google"s additional consent</span></li>
                                    </ul>
                                </Col>
                                <Col span={12}>
                                    <ul>
                                        <li>&#123;creative_id&#125; – <span>creative id</span></li>
                                        <li>&#123;publisher_id&#125; – <span>publisher id</span></li>
                                        <li>&#123;exchange&#125; – <span>exchange</span></li>
                                        <li>&#123;domain&#125; – <span>domain (referrer)</span></li>
                                        <li>&#123;app_name&#125; – <span>application name</span></li>
                                        <li>&#123;site_id&#125; – <span>site id</span></li>
                                        <li>&#123;country&#125; – <span>country</span></li>
                                        <li>&#123;city&#125; – <span>city</span></li>
                                        <li>&#123;os&#125; – <span>os</span></li>
                                        <li>&#123;make&#125; – <span>make</span></li>
                                        <li>&#123;carrier&#125; – <span>carrier</span></li>
                                        <li>&#123;device_type&#125; – <span>device type</span></li>
                                        <li>&#123;ipv4_address&#125; – <span>ipv4 address</span></li>
                                        <li>&#123;cachebuster&#125; – <span>random number</span></li>
                                        <li>&#123;tagid&#125; – <span>imp.tagid parameter of bid request</span></li>
                                        <li>$&#123;GDPR_CONSENT_XXX&#125; – <span>base64-encoded GDPR consent string</span></li>
                                        <li>$&#123;ADDTL_CONSENT&#125; – <span>Google"s additional consent</span></li>
                                    </ul>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal>

                <Modal
                    className='custom_modal custom_modal_form_d2'
                    visible={isModalVisibleTypeChange}
                    // onOk={closeModalTypeChangeDiscard}
                    width={620}
                    onCancel={closeModalTypeChangeDiscard}
                    maskClosable={false}
                    title={<div className='custom_modal--header'><h3 className='heading'><img src={alertCircleModal} alt='USP' />Confirmation</h3>
                    </div>}
                    closable={true} // This removes the default close button
                    footer={[
                        <div className="custom_modal--footer d_flex justify_content_end">
                            <div className="btn_group justify-content-end gap_8">
                                <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeModalTypeChangeDiscard}> Discard </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content" onClick={showModalTypeChangeProceed}>Proceed</button>
                            </div>
                        </div>
                    ]}>
                    <div className="custom_modal--body">
                        <div className="form_content_block--group ">
                            <label className="form_label" style={{ fontSize: "1.4rem", fontWeight: "400" }}> Changing the campaign type will clear the creatives. Do you want to proceed?</label>

                            {/* <span className="error_content"> </span> */}
                        </div>


                    </div>
                </Modal>

                <Modal
                    className='custom_modal custom_modal_form_d2'
                    visible={isModalVisibleAdSourceRefresh}
                    // onOk={closeModalTypeChangeDiscard}
                    width={550}
                    maskClosable={false}
                    title={<div className='custom_modal--header'><h3 className='heading'><img src={alertCircleModal} alt='USP' />Confirmation</h3>
                    </div>}
                    closable={false} // This removes the default close button
                    footer={[
                        <div className="custom_modal--footer d_flex justify_content_end">
                            <div className="btn_group justify-content-end gap_8">
                                <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={() => { modalCloseAdSourceRefresh(false) }}> No </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content" onClick={() => { modalCloseAdSourceRefresh(true) }}>Yes</button>
                            </div>
                        </div>
                    ]}>
                    <div className="custom_modal--body">
                        <div className="form_content_block--group ">
                            <label className="form_label" style={{ fontSize: "1.4rem", fontWeight: "400" }}> {campaignType === "IBV" ? <>Do you want to create new AdSource for this creative?</> : <>Do you want to create new AdUnit for this creative?</>}</label>

                            {/* <span className="error_content"> </span> */}
                        </div>


                    </div>
                </Modal>

                <Modal
                    className='custom_modal custom_modal_form_d2' onCancel={handleHideModal_aniview}
                    title={<div className='custom_modal--header'><h3 className='heading'><img src={CreativeIcon} alt='USP' /> AdSource </h3>
                    </div>}
                    closable={true} // This removes the default close button
                    visible={modalShow_aniView}
                    maskClosable={false}
                    width={770}
                    footer={[
                        <div className="custom_modal--footer d_flex justify_content_end gap_8">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={handleHideModal_aniview}> Discard </button>
                            <button key="submit" className='btn btn_primary w_fit_content' onClick={handleAniviewValidations}>
                                Submit
                            </button>
                        </div>
                    ]}>
                    <div className="custom_modal--body">
                        <div className="tab_content--body">
                            <div className="container_box--width w-100">
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Provider</label>
                                    <Select
                                        className='form_select basic no_search'
                                        placeholder="-Select-"
                                        optionFilterProp="label"
                                        options={providerOptions_aniview}
                                        value={provider_aniview}
                                        disabled
                                    />
                                    {/* <span className="error_content"> </span> */}
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Source Type</label>
                                    <Select
                                        className='form_select basic no_search'
                                        placeholder="-Select-"
                                        optionFilterProp="label"
                                        options={sourceTypeOptions_aniview}
                                        value={sourceType_aniview}
                                        disabled
                                    />
                                    {/* <span className="error_content"> </span> */}
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Demand Publisher</label>
                                    <Select
                                        className='form_select basic no_search'
                                        placeholder="-Select-"
                                        optionFilterProp="label"
                                        options={publisherOptions}
                                        value={publisher}
                                        disabled
                                    />
                                    {/* <span className="error_content"> </span> */}
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Advertiser</label>
                                    <Select
                                        className='form_select basic no_search'
                                        placeholder="-Select-"
                                        optionFilterProp="label"
                                        options={advertiserOptions_aniview}
                                        value={advertiser_aniview}
                                        disabled
                                    />
                                    {/* <span className="error_content"> </span> */}
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2" ref={name_aniview_Ref}>
                                    <label className="form_label">Name *</label>
                                    <Input className={name_aniviewIsRequiredError ? 'form_control basic error' : 'form_control basic'} placeholder='Ad Source Name' autocomplete="off"
                                        value={name_aniview}
                                        onChange={onChangeName_aniview}
                                        onBlur={onBlurName_aniview}
                                    />
                                    {name_aniviewIsRequiredError && <span className="error_content"> <>This field is required</></span>}
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Owner Type *</label>
                                    <Select
                                        className='form_select basic no_search'
                                        placeholder="-Select-"
                                        optionFilterProp="label"
                                        onChange={onChangeOwnerType_aniview}
                                        options={ownerTypeOptions_aniview}
                                        value={ownerType_aniview}
                                    />
                                    {/* <span className="error_content"> </span> */}
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Status *</label>
                                    <Select
                                        className='form_select basic no_search'
                                        placeholder="-Select-"
                                        optionFilterProp="label"
                                        onChange={onChangeStatus_aniview}
                                        options={statusOptions_aniview}
                                        value={status_aniview}
                                    />
                                    {/* <span className="error_content"> </span> */}
                                </div>
                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Environment *</label>
                                    <Select
                                        className='form_select basic no_search'
                                        placeholder="-Select-"
                                        optionFilterProp="label"
                                        onChange={onChangeEnvironment_aniview}
                                        options={environmentOptions_aniview}
                                        value={environment_aniview}
                                    />
                                    {/* <span className="error_content"> </span> */}
                                </div>


                                <div className="form_content_block--group modal_form_bottom_gap_d2" ref={creativeNameRef}>
                                    <label className="form_label">eCPM *</label>
                                    <Input className={eCpmIsRequiredError_aniview || eCpmValidError_aniview
                                        ? "form_control basic error"
                                        : "form_control basic"}
                                        autocomplete="off"
                                        value={activeAdSourceRefreshInModal_aniview ? eCpmDisabled_aniview : eCpm_aniview}
                                        onBlur={onBlurECpm_aniview}
                                        onChange={onChangeECpm_aniview}
                                        disabled={activeAdSourceRefreshInModal_aniview}
                                    />
                                    {eCpmIsRequiredError_aniview &&
                                        <span className="error_content">
                                            <> This field is required</>
                                        </span>
                                    }
                                    {eCpmValidError_aniview &&
                                        <span className="error_content">
                                            <> Value should be greater than 0 and less than 100</>
                                        </span>
                                    }
                                </div>




                                <div className="form_content_block--group modal_form_bottom_gap_d2" ref={creativeNameRef}>
                                    <label className="form_label">Gross Rate ($)</label>
                                    <Input className={grossRate_aniviewIsRequiredError ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                        value={grossRate_aniview}
                                        onChange={onChangeGrossRate_aniview}
                                        disabled
                                    />
                                    {grossRate_aniviewIsRequiredError && <span className="error_content"> <>This field is required</></span>}
                                </div>

                                <div className="form_content_block--group modal_form_bottom_gap_d2">
                                    <label className="form_label">Revenue Model *</label>
                                    <Select
                                        className='form_select basic no_search'
                                        placeholder="-Select-"
                                        optionFilterProp="label"
                                        onChange={onChangeRevenueModel_aniview}
                                        options={revenueModelOptions_aniview}
                                        value={revenueModel_aniview}
                                    />
                                    {/* <span className="error_content"> </span> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                {exchangeMappingDataLoader &&
                    <div className='full_screen_loader_d2'>
                        <img src={FullLoader} alt="" />
                    </div>
                }
            </div >
        </>
    )
}

export default CampaignCreateGam
